var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSsw2025IconsStartgrafikRgb = function SvgSsw2025IconsStartgrafikRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 493,
    height: 135,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 493 135",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.92,33.9c-1.49-1.85-3.73-2.9-6.11-2.9-1.29,0-2.5.3-3.63.89-1.12.56-2.44.92-4.01,1.05-1.97.17-5.48-1.07-5.48-1.32l-.88-19.1-.12-2.05s-21.94-.7-21.95-.67c-.6,1.42-.82,3.05-.66,5,.13,1.56.49,2.87,1.05,3.97.58,1.12.88,2.32.88,3.6,0,2.36-1.05,4.57-2.89,6.05-1.86,1.52-4.29,2.1-6.69,1.59-3.07-.64-5.57-3.24-6.07-6.35-.26-1.65-.02-3.28.69-4.74.56-1.12.9-2.27,1.05-3.41.28-2.25.09-4.12-.58-5.72-.01-.03-.05-.05-.06-.07-.13-.21-23.1.72-23.1.72,0,0-.62,20.3-.91,22.36,1.18.46,2.97.97,4.2.92,1.57-.06,2.91-.36,4.05-.88,1.16-.53,2.38-.78,3.67-.72,2.38.11,4.56,1.26,5.97,3.17,1.45,1.93,1.97,3.43,1.35,5.82-.78,3.06-3.52,5.44-6.68,5.81-1.67.19-3.31-.13-4.75-.91-1.11-.61-2.25-1-3.39-1.21-2.25-.38-3.23-.28-4.86.33-.03.01,1.99,23.36,1.99,23.36h1s20.71.2,20.84.05h.03c.14,0,.28.04.39.12.5,0,.8.03.81.05.73,1.63.96,3.56.66,5.9-.15,1.14-.51,2.3-1.05,3.43-.71,1.48-.96,3.13-.69,4.78.51,3.13,2.98,5.75,6.03,6.39.47.1.9.14,1.31.16.71-.02,1.4-.13,2.07-.33.75-.29,1.47-.75,2.26-1.4,1.85-1.5,2.92-3.73,2.92-6.13,0-1.27-.28-2.49-.86-3.62-.56-1.12-.92-2.42-1.05-3.99-.17-2.02.07-3.73.73-5.19l25.18-.56-1.89-22.92c0-.25.4-.65.44-.66,1.61-.68,3.5-.87,5.77-.58,1.15.15,2.31.49,3.44,1.05,1.47.72,3.12.96,4.78.7,3.14-.51,5.77-3.01,6.41-6.1.51-2.41-.08-3.89-1.61-5.75Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.09,
    y: -8.7,
    width: 66.72,
    height: 66.72,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.09,
    y: 58.02,
    width: 66.72,
    height: 66.72,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.36,
    y: -8.7,
    width: 66.72,
    height: 66.72,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.36,
    y: 58.02,
    width: 66.72,
    height: 66.72,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "_10_dpi_40_",
    x: 0,
    y: 0,
    width: 28.8,
    height: 28.8,
    patternTransform: "translate(-18951.84 817.28) rotate(90) scale(1.14)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 28.8 28.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 28.8,
    height: 28.8,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,31.68c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,31.68c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,17.28c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,17.28c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,24.48c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,24.48c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,10.08c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,10.08c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88-2.88,1.29-2.88,2.88,1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,31.68c1.59,0,2.88-1.29,2.88-2.88S1.59,25.92,0,25.92s-2.88,1.29-2.88,2.88S-1.59,31.68,0,31.68Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,17.28c1.59,0,2.88-1.29,2.88-2.88S1.59,11.52,0,11.52s-2.88,1.29-2.88,2.88S-1.59,17.28,0,17.28Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,2.88C30.39,2.88,31.68,1.59,31.68,0s-1.29-2.88-2.88-2.88S25.92-1.59,25.92,0s1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,2.88C15.99,2.88,17.28,1.59,17.28,0s-1.29-2.88-2.88-2.88S11.52-1.59,11.52,0s1.29,2.88,2.88,2.88Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.88C1.59,2.88,2.88,1.59,2.88,0S1.59-2.88,0-2.88-2.88-1.59-2.88,0-1.59,2.88,0,2.88Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.96,66.9l18.65-.68,3.66-.19c.09-.04.17-.09.24-.16.1-.22.2-.44.32-.67.51-1.35.71-2.89.56-4.7-.13-1.57-.49-2.86-1.05-3.98-.58-1.12-.86-2.34-.86-3.61,0-2.39,1.07-4.62,2.92-6.11,1.83-1.5,4.23-2.06,6.6-1.57,3.05.64,5.52,3.25,6.02,6.38.2,1.28.09,2.56-.3,3.77-.13.52-.3,1.04-.54,1.53-.26.53-.47,1.06-.64,1.6-.11.43-.21.87-.27,1.3-.3,2.34-.07,4.26.65,5.89.11.26.37.41.65.41l22.36-.33c-.05-3.13-.38-22.06-.13-22.16,1.61-.68,3.5-.87,5.77-.58,1.15.15,2.31.49,3.44,1.05,1.47.72,3.12.96,4.78.7,3.14-.51,5.77-3.01,6.41-6.1.51-2.41-.08-4.86-1.61-6.72-1.49-1.85-3.73-2.9-6.11-2.9-1.29,0-2.5.3-3.63.89-1.12.56-2.44.92-4.01,1.05-1.97.17-3.61-.06-5.05-.66-.07-.03-.13-1.06-.11-1.06V8.78s-22.67,1.29-22.79,1.54c-.66,1.47-.91,1.23-.74,3.26.13,1.58.49,2.88,1.06,4.01.59,1.13.87,2.35.87,3.63,0,2.41-1.08,4.65-2.95,6.16-1.85,1.51-4.27,2.07-6.68,1.58-3.08-.64-5.58-3.28-6.09-6.42-.26-1.66-.02-3.31.7-4.8.55-1.13.91-2.3,1.06-3.45.3-2.35.08-2.34-.66-3.98-.11-.26-23.83.19-23.83.19l.09,2,.88,19.1c0,.25,3.52,1.49,5.48,1.32,1.57-.13,2.89-.49,4.01-1.05,1.13-.58,2.34-.89,3.63-.89,2.38,0,4.61,1.05,6.11,2.9,1.53,1.86,2.12,3.34,1.61,5.75-.64,3.09-3.27,5.59-6.41,6.1-1.66.26-3.31.02-4.78-.7-1.13-.57-2.29-.9-3.44-1.05-2.27-.28-4.16-.09-5.77.58-.03.01-.43.41-.43.66",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: -14.58,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 55.51,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: -14.58,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: 55.51,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.96,66.9l18.65-.68,3.66-.19c.09-.04.17-.09.24-.16.1-.22.2-.44.32-.67.51-1.35.71-2.89.56-4.7-.13-1.57-.49-2.86-1.05-3.98-.58-1.12-.86-2.34-.86-3.61,0-2.39,1.07-4.62,2.92-6.11,1.83-1.5,4.23-2.06,6.6-1.57,3.05.64,5.52,3.25,6.02,6.38.2,1.28.09,2.56-.3,3.77-.13.52-.3,1.04-.54,1.53-.26.53-.47,1.06-.64,1.6-.11.43-.21.87-.27,1.3-.3,2.34-.07,4.26.65,5.89.11.26.37.41.65.41l22.36-.33c-.05-3.13-.38-22.06-.13-22.16,1.61-.68,3.5-.87,5.77-.58,1.15.15,2.31.49,3.44,1.05,1.47.72,3.12.96,4.78.7,3.14-.51,5.77-3.01,6.41-6.1.51-2.41-.08-4.86-1.61-6.72-1.49-1.85-3.73-2.9-6.11-2.9-1.29,0-2.5.3-3.63.89-1.12.56-2.44.92-4.01,1.05-1.97.17-3.61-.06-5.05-.66-.07-.03-.13-1.06-.11-1.06V8.78s-22.67,1.29-22.79,1.54c-.66,1.47-.91,1.23-.74,3.26.13,1.58.49,2.88,1.06,4.01.59,1.13.87,2.35.87,3.63,0,2.41-1.08,4.65-2.95,6.16-1.85,1.51-4.27,2.07-6.68,1.58-3.08-.64-5.58-3.28-6.09-6.42-.26-1.66-.02-3.31.7-4.8.55-1.13.91-2.3,1.06-3.45.3-2.35.08-2.34-.66-3.98-.11-.26-23.83.19-23.83.19l.09,2,.88,19.1c0,.25,3.52,1.49,5.48,1.32,1.57-.13,2.89-.49,4.01-1.05,1.13-.58,2.34-.89,3.63-.89,2.38,0,4.61,1.05,6.11,2.9,1.53,1.86,2.12,3.34,1.61,5.75-.64,3.09-3.27,5.59-6.41,6.1-1.66.26-3.31.02-4.78-.7-1.13-.57-2.29-.9-3.44-1.05-2.27-.28-4.16-.09-5.77.58-.03.01-.43.41-.43.66",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: -14.58,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 55.51,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: -14.58,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: 55.51,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.23,90.82c-1.48-1.83-3.68-2.88-6.04-2.88-1.27,0-2.47.3-3.59.88-1.1.56-2.41.92-3.96,1.05-1.94.17-3.57-.06-4.99-.65-.26-.11-.43-.37-.43-.65l-.21-22.79h-.07s-22.36.33-22.36.33c-.28,0-.54-.15-.65-.41-.73-1.63-.95-3.55-.65-5.89.06-.43.15-.86.27-1.3.19-.71.44-1.43.78-2.13.16-.33.28-.66.39-1,.39-1.2.5-2.48.3-3.77-.5-3.12-2.97-5.74-6.02-6.38-2.37-.49-4.77.07-6.6,1.57-1.85,1.5-2.92,3.72-2.92,6.11,0,1.27.28,2.49.86,3.61.56,1.12.92,2.41,1.05,3.98.15,1.81-.05,3.35-.56,4.7-.06.16-.11.33-.17.48-.03.07-.08.14-.14.19-.07.07-.15.12-.24.16-.09.04-.18.06-.28.06l-3.38.12-18.65.68s0,.1,0,.27c.01.54.04,1.89.08,3.65l.8,16.75s.04,1.03.1,1.05c1.42.6,2.08.82,4.03.66,1.55-.13,2.87-.49,3.97-1.05,1.12-.58,2.32-.88,3.6-.88,1.85,0,3.46.77,4.89,1.89.65.43,1.24.96,1.75,1.58.33.4.6.83.84,1.28,0,.01.02.03.02.04.1.2.2.4.28.61.84,1.89.98,3.98.64,5.6-.64,3.07-4.02,6.09-7.13,6.6-1.65.26-3.28.02-4.74-.69-1.12-.56-2.27-.9-3.41-1.05-2.25-.28-4.12-.09-5.71.58-.24.1.43,19.25.55,22.79l57.55-.1,1.14-23.43c0-.28.17-.54.43-.65,1.59-.67,3.46-.86,5.7-.58,1.14.15,2.28.49,3.4,1.05,1.46.71,3.09.95,4.73.69,3.1-.51,5.7-2.99,6.34-6.06.51-2.39-.07-4.82-1.59-6.67Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: -14.58,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 55.51,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 125.6,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: -14.58,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: 55.51,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: 125.6,
    width: 70.09,
    height: 70.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.98,103.8c1.59-.67,3.47-.86,5.71-.58,1.14.15,2.29.49,3.41,1.05,1.46.71,3.09.96,4.74.69,3.11-.51,6.5-3.52,7.13-6.6.34-1.62.2-3.71-.64-5.6-.09-.21-.18-.41-.28-.61,0-.01-.02-.03-.02-.04-.37-.67-.84-1.3-1.43-1.86-.37-.35-.76-.69-1.16-1-1.43-1.11-3.05-1.89-4.89-1.89-1.27,0-2.47.3-3.6.88-1.11.56-2.42.92-3.97,1.05-1.95.17-2.6-.06-4.03-.66-.07-.03-.12-1.05-.1-1.05l-.32-21.35s-24.1,2.27-24.21,2.5c-.66,1.46-.9,3.17-.73,5.19.13,1.57.49,2.87,1.05,3.99.58,1.12.86,2.34.86,3.62,0,2.4-1.07,4.63-2.92,6.13-.79.65-1.51,1.11-2.26,1.4-.64.25-1.31.36-2.07.33-.41-.01-.84-.06-1.31-.16-3.05-.64-5.53-3.26-6.03-6.39-.26-1.65-.02-3.3.69-4.78.54-1.12.9-2.29,1.05-3.43.3-2.34.07-4.27-.66-5.9-.01-.03-.31-.04-.81-.05-4.14-.07-23.01.47-23.01.47l.21,20.78c0,.25.15.46.36.59.03.02.04.05.07.06,1.42.6,3.05.82,5,.66,1.56-.13,2.87-.49,3.97-1.05,1.12-.58,2.32-.88,3.6-.88,2.36,0,4.57,1.05,6.05,2.89,1.52,1.85,2.1,4.29,1.59,6.69-.64,3.07-3.24,5.56-6.35,6.07-1.65.26-3.28.02-4.74-.69-1.12-.56-2.27-.9-3.41-1.05-2.25-.28-4.12-.09-5.71.58-.03.01-.05.05-.07.06-.21.13-.36.34-.36.59l-.06,21.36h.06l22.61,1.25c.58-1.41.8-3.03.64-4.94-.13-1.57-.49-2.87-1.05-3.99-.58-1.12-.86-2.34-.86-3.62,0-2.4,1.07-4.63,2.92-6.13,1.84-1.5,4.23-2.06,6.61-1.57,3.05.64,5.53,3.26,6.03,6.39.26,1.65.02,3.3-.69,4.78-.54,1.12-.9,2.29-1.05,3.43-.29,2.26-.08,3.15.59,4.74l24.39.43s0-.21-.02-.58c-.13-3.55-.77-22.11-.53-22.21Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.25,
    y: 100.49,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.92,
    y: 100.49,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.59,
    y: 100.49,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.25,
    y: 70.17,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.92,
    y: 70.17,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.59,
    y: 70.17,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.25,
    y: 39.84,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.92,
    y: 39.84,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.59,
    y: 39.84,
    width: 30.33,
    height: 30.32,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M428.92,33.9c-1.49-1.85-3.73-2.9-6.11-2.9-1.29,0-2.5.3-3.63.89-1.12.56-2.44.92-4.01,1.05-1.97.17-5.48-1.07-5.48-1.32l-.88-19.1-.12-2.05s-21.94-.7-21.95-.67c-.6,1.42-.82,3.05-.66,5,.13,1.56.49,2.87,1.05,3.97.58,1.12.88,2.32.88,3.6,0,2.36-1.05,4.57-2.89,6.05-1.86,1.52-4.29,2.1-6.69,1.59-3.07-.64-5.57-3.24-6.07-6.35-.26-1.65-.02-3.28.69-4.74.56-1.12.9-2.27,1.05-3.41.28-2.25.09-4.12-.58-5.72-.01-.03-.05-.05-.06-.07-.13-.21-23.1.72-23.1.72,0,0-.62,20.3-.91,22.36,1.18.46,2.97.97,4.2.92,1.57-.06,2.91-.36,4.05-.88,1.16-.53,2.38-.78,3.67-.72,2.38.11,4.56,1.26,5.97,3.17,1.45,1.93,1.97,3.43,1.35,5.82-.78,3.06-3.52,5.44-6.68,5.81-1.67.19-3.31-.13-4.75-.91-1.11-.61-2.25-1-3.39-1.21-2.25-.38-3.23-.28-4.86.33-.03.01,2.49,22.86,2.49,22.86h1s20.21.7,20.34.55h.03c.14,0,.28.04.39.12.5,0,.8.03.81.05.73,1.63.96,3.56.66,5.9-.15,1.14-.51,2.3-1.05,3.43-.71,1.48-.96,3.13-.69,4.78.51,3.13,2.98,5.75,6.03,6.39.47.1.9.14,1.31.16.71-.02,1.4-.13,2.07-.33.75-.29,1.47-.75,2.26-1.4,1.85-1.5,2.92-3.73,2.92-6.13,0-1.27-.28-2.49-.86-3.62-.56-1.12-.92-2.42-1.05-3.99-.17-2.02.07-3.73.73-5.19l25.18-.56-1.89-22.92c0-.25.4-.65.44-.66,1.61-.68,3.5-.87,5.77-.58,1.15.15,2.31.49,3.44,1.05,1.47.72,3.12.96,4.78.7,3.14-.51,5.77-3.01,6.41-6.1.51-2.41-.08-3.89-1.61-5.75Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.34,89.87c-.51-.02-.96-.07-1.42-.17-3.25-.68-5.89-3.47-6.43-6.8-.28-1.74-.02-3.5.74-5.07.52-1.08.86-2.18,1-3.28.27-2.11.1-3.87-.51-5.38-.12,0-.28,0-.47-.01h-.14s-.12-.08-.12-.08c-.04-.02-.08-.04-.12-.04v-.04c-.92.11-4.53.04-20.39-.51h-1.43s-1.3-11.87-1.3-11.87c-.31-2.86-.62-5.71-.86-7.86q-.43-3.96-.05-4.1c1.8-.67,2.85-.74,5.12-.35,1.24.22,2.43.64,3.55,1.26,1.35.73,2.89,1.03,4.45.85,2.95-.34,5.52-2.58,6.25-5.44.6-2.31.02-3.68-1.27-5.39-1.32-1.79-3.36-2.87-5.6-2.97-1.18-.05-2.34.18-3.44.68-1.21.55-2.64.86-4.24.92-1.27.05-3.11-.46-4.4-.96l-.37-.14.05-.39c.28-2.01.9-22.1.9-22.3v-.47s.48-.02.48-.02c23.27-.95,23.34-.82,23.55-.48l.1.15c.71,1.67.91,3.62.61,5.97-.16,1.24-.53,2.44-1.1,3.57-.67,1.37-.89,2.9-.65,4.44.47,2.9,2.81,5.35,5.68,5.94,2.25.48,4.54-.07,6.27-1.49,1.72-1.39,2.7-3.45,2.7-5.67,0-1.18-.28-2.31-.83-3.37-.6-1.18-.97-2.58-1.1-4.16-.17-2,.05-3.72.69-5.24q.15-.34,11.46.02l11.43.36.15,2.51.87,18.88c.68.35,3.37,1.21,4.95,1.07,1.47-.12,2.76-.46,3.83-1,1.21-.62,2.51-.94,3.86-.94,2.54,0,4.91,1.12,6.5,3.08,1.52,1.85,2.29,3.45,1.71,6.17-.68,3.28-3.49,5.95-6.82,6.49-1.76.28-3.51.02-5.08-.74-1.05-.52-2.15-.86-3.29-1.01-2.15-.27-3.93-.1-5.43.52-.08.08-.19.22-.21.28l1.94,23.36-25.39.56c-.53,1.33-.72,2.85-.57,4.66.12,1.46.45,2.71,1,3.81.61,1.17.92,2.47.92,3.84,0,2.54-1.13,4.92-3.11,6.51-.87.71-1.63,1.18-2.4,1.48-.77.23-1.51.35-2.24.37ZM373.4,68.17c.76.01,1,.03,1.13.36.77,1.72,1,3.74.69,6.16-.16,1.2-.53,2.41-1.1,3.58-.67,1.39-.89,2.94-.65,4.48.47,2.92,2.79,5.38,5.64,5.98.4.08.8.13,1.23.15.61-.02,1.26-.12,1.91-.31.62-.24,1.3-.66,2.09-1.31,1.74-1.41,2.74-3.5,2.74-5.74,0-1.21-.27-2.35-.81-3.39-.61-1.22-.97-2.59-1.1-4.18-.18-2.11.08-3.88.77-5.44l.13-.29,24.97-.55-1.84-22.39c0-.53.55-1.08.74-1.16,1.69-.71,3.66-.91,6.02-.62,1.25.16,2.46.53,3.6,1.1,1.38.67,2.93.9,4.48.65,2.93-.48,5.4-2.82,6-5.71.5-2.34-.15-3.68-1.5-5.33h0c-1.4-1.73-3.48-2.72-5.72-2.72-1.19,0-2.33.28-3.4.83-1.19.6-2.6.97-4.2,1.11-1.93.17-5.34-.95-5.83-1.4l-.16-.15-.03-.27-.97-20.67c-6.92-.22-19.01-.6-21.14-.65-.48,1.29-.64,2.75-.5,4.46.12,1.45.46,2.73,1,3.79.62,1.2.94,2.49.94,3.82,0,2.52-1.12,4.87-3.07,6.44-1.97,1.61-4.56,2.23-7.11,1.69-3.27-.68-5.92-3.46-6.46-6.76-.28-1.74-.02-3.48.74-5.04.52-1.04.86-2.13,1-3.26.26-2.07.11-3.79-.46-5.25-1.83-.05-13.94.4-22.3.73-.09,2.96-.58,18.36-.86,21.54,1.12.4,2.61.8,3.64.76,1.47-.06,2.77-.34,3.87-.83,1.24-.57,2.55-.83,3.9-.77,2.54.11,4.85,1.34,6.35,3.37,1.43,1.91,2.13,3.55,1.43,6.24-.83,3.25-3.75,5.79-7.1,6.18-1.76.2-3.51-.13-5.04-.97-1.02-.57-2.11-.95-3.24-1.15-2.04-.34-2.94-.27-4.24.18.23,2.3,1.61,14.85,2.4,22.02h.55c7.43.26,18.52.61,20.09.57l.02-.02h.23c.21,0,.39.04.56.12ZM373.04,9.99s.03.05.05.07l-.05-.07Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 419.65,
    y1: 57.79,
    x2: 419.65,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.89,
    y1: 57.79,
    x2: 441.89,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.13,
    y1: 57.79,
    x2: 464.13,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.77,
    y1: 57.79,
    x2: 430.77,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.01,
    y1: 57.79,
    x2: 453.01,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.25,
    y1: 57.79,
    x2: 475.25,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 52.46,
    x2: 547.76,
    y2: 52.46,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 30.22,
    x2: 547.76,
    y2: 30.22,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 7.98,
    x2: 547.76,
    y2: 7.98,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 41.34,
    x2: 547.76,
    y2: 41.34,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 19.1,
    x2: 547.76,
    y2: 19.1,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.65,
    y1: -8.93,
    x2: 419.65,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.89,
    y1: -8.93,
    x2: 441.89,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.13,
    y1: -8.93,
    x2: 464.13,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 52.46,
    x2: 481.04,
    y2: 52.46,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 30.22,
    x2: 481.04,
    y2: 30.22,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 7.98,
    x2: 481.04,
    y2: 7.98,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 41.34,
    x2: 481.04,
    y2: 41.34,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 19.1,
    x2: 481.04,
    y2: 19.1,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.77,
    y1: -8.93,
    x2: 430.77,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.01,
    y1: -8.93,
    x2: 453.01,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.25,
    y1: -8.93,
    x2: 475.25,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 52.46,
    x2: 414.32,
    y2: 52.46,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 30.22,
    x2: 414.32,
    y2: 30.22,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 7.98,
    x2: 414.32,
    y2: 7.98,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 41.34,
    x2: 414.32,
    y2: 41.34,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 19.1,
    x2: 414.32,
    y2: 19.1,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 419.65,
    y1: 124.51,
    x2: 419.65,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.89,
    y1: 124.51,
    x2: 441.89,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.13,
    y1: 124.51,
    x2: 464.13,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.77,
    y1: 124.51,
    x2: 430.77,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.01,
    y1: 124.51,
    x2: 453.01,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.25,
    y1: 124.51,
    x2: 475.25,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 119.18,
    x2: 547.76,
    y2: 119.18,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 96.94,
    x2: 547.76,
    y2: 96.94,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 74.7,
    x2: 547.76,
    y2: 74.7,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 108.06,
    x2: 547.76,
    y2: 108.06,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 85.82,
    x2: 547.76,
    y2: 85.82,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.57,
    y1: 63.58,
    x2: 547.76,
    y2: 63.58,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.65,
    y1: 57.79,
    x2: 419.65,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.89,
    y1: 57.79,
    x2: 441.89,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.13,
    y1: 57.79,
    x2: 464.13,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 119.18,
    x2: 481.04,
    y2: 119.18,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 96.94,
    x2: 481.04,
    y2: 96.94,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 74.7,
    x2: 481.04,
    y2: 74.7,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 108.06,
    x2: 481.04,
    y2: 108.06,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 85.82,
    x2: 481.04,
    y2: 85.82,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 63.58,
    x2: 481.04,
    y2: 63.58,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.77,
    y1: 57.79,
    x2: 430.77,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.01,
    y1: 57.79,
    x2: 453.01,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.25,
    y1: 57.79,
    x2: 475.25,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 119.18,
    x2: 414.32,
    y2: 119.18,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 96.94,
    x2: 414.32,
    y2: 96.94,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 74.7,
    x2: 414.32,
    y2: 74.7,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 108.06,
    x2: 414.32,
    y2: 108.06,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 85.82,
    x2: 414.32,
    y2: 85.82,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 63.58,
    x2: 414.32,
    y2: 63.58,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.65,
    y1: -8.93,
    x2: 419.65,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.89,
    y1: -8.93,
    x2: 441.89,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.13,
    y1: -8.93,
    x2: 464.13,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.77,
    y1: -8.93,
    x2: 430.77,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.01,
    y1: -8.93,
    x2: 453.01,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.25,
    y1: -8.93,
    x2: 475.25,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 352.92,
    y1: 57.79,
    x2: 352.92,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.16,
    y1: 57.79,
    x2: 375.16,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.41,
    y1: 57.79,
    x2: 397.41,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.04,
    y1: 57.79,
    x2: 364.04,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.28,
    y1: 57.79,
    x2: 386.28,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.53,
    y1: 57.79,
    x2: 408.53,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 52.46,
    x2: 481.04,
    y2: 52.46,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 30.22,
    x2: 481.04,
    y2: 30.22,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 7.98,
    x2: 481.04,
    y2: 7.98,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 41.34,
    x2: 481.04,
    y2: 41.34,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 19.1,
    x2: 481.04,
    y2: 19.1,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.92,
    y1: -8.93,
    x2: 352.92,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.16,
    y1: -8.93,
    x2: 375.16,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.41,
    y1: -8.93,
    x2: 397.41,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 52.46,
    x2: 414.32,
    y2: 52.46,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 30.22,
    x2: 414.32,
    y2: 30.22,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 7.98,
    x2: 414.32,
    y2: 7.98,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 41.34,
    x2: 414.32,
    y2: 41.34,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 19.1,
    x2: 414.32,
    y2: 19.1,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.04,
    y1: -8.93,
    x2: 364.04,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.28,
    y1: -8.93,
    x2: 386.28,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.53,
    y1: -8.93,
    x2: 408.53,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 52.46,
    x2: 347.6,
    y2: 52.46,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 30.22,
    x2: 347.6,
    y2: 30.22,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 7.98,
    x2: 347.6,
    y2: 7.98,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 41.34,
    x2: 347.6,
    y2: 41.34,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 19.1,
    x2: 347.6,
    y2: 19.1,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-4)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 352.92,
    y1: 124.51,
    x2: 352.92,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.16,
    y1: 124.51,
    x2: 375.16,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.41,
    y1: 124.51,
    x2: 397.41,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.04,
    y1: 124.51,
    x2: 364.04,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.28,
    y1: 124.51,
    x2: 386.28,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.53,
    y1: 124.51,
    x2: 408.53,
    y2: 191.69,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 119.18,
    x2: 481.04,
    y2: 119.18,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 96.94,
    x2: 481.04,
    y2: 96.94,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 74.7,
    x2: 481.04,
    y2: 74.7,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 108.06,
    x2: 481.04,
    y2: 108.06,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 85.82,
    x2: 481.04,
    y2: 85.82,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.85,
    y1: 63.58,
    x2: 481.04,
    y2: 63.58,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.92,
    y1: 57.79,
    x2: 352.92,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.16,
    y1: 57.79,
    x2: 375.16,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.41,
    y1: 57.79,
    x2: 397.41,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 119.18,
    x2: 414.32,
    y2: 119.18,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 96.94,
    x2: 414.32,
    y2: 96.94,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 74.7,
    x2: 414.32,
    y2: 74.7,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 108.06,
    x2: 414.32,
    y2: 108.06,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 85.82,
    x2: 414.32,
    y2: 85.82,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.13,
    y1: 63.58,
    x2: 414.32,
    y2: 63.58,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.04,
    y1: 57.79,
    x2: 364.04,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.28,
    y1: 57.79,
    x2: 386.28,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.53,
    y1: 57.79,
    x2: 408.53,
    y2: 124.97,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 119.18,
    x2: 347.6,
    y2: 119.18,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 96.94,
    x2: 347.6,
    y2: 96.94,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 74.7,
    x2: 347.6,
    y2: 74.7,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 108.06,
    x2: 347.6,
    y2: 108.06,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 85.82,
    x2: 347.6,
    y2: 85.82,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.41,
    y1: 63.58,
    x2: 347.6,
    y2: 63.58,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.92,
    y1: -8.93,
    x2: 352.92,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.16,
    y1: -8.93,
    x2: 375.16,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.41,
    y1: -8.93,
    x2: 397.41,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.04,
    y1: -8.93,
    x2: 364.04,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.28,
    y1: -8.93,
    x2: 386.28,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.53,
    y1: -8.93,
    x2: 408.53,
    y2: 58.25,
    style: {
      fill: "#f06400",
      stroke: "#fff",
      strokeWidth: ".7px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M26.32,100.35v3.9h-10.2v4.88h8.84v3.61h-8.84v8.72h-4.64v-21.11h14.84Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.57,100.35v13.22c0,3.1,1.36,4.49,4.35,4.49,3.25,0,4.37-1.39,4.37-4.49v-13.22h4.64v13.22c0,5.26-3.05,8.4-9.02,8.4s-8.99-3.13-8.99-8.4v-13.22h4.64ZM36.88,94.7v3.46h-3.99v-3.46h3.99ZM42.97,94.7v3.46h-3.99v-3.46h3.99Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.31,100.35c3.72,0,6.18,2.57,6.18,5.82,0,2.66-1.13,4.41-3.34,5.29v.06c2.96.83,3.05,4.08,3.13,6.06.09,2.01.3,3.13.83,3.87h-4.64c-.35-.89-.47-2.16-.59-3.67-.24-2.96-.71-4.58-3.64-4.58h-4.67v8.25h-4.64v-21.11h11.38ZM60.69,109.9c1.95,0,3.16-.8,3.16-3.02,0-2.1-1.15-2.93-3.19-2.93h-5.09v5.94h5.11Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.23,106.65h-4.5c-.15-2.13-1.39-3.19-4.14-3.19-1.72,0-3.22.74-3.22,2.39,0,1.54.89,1.83,5.62,3.02,3.13.8,6.95,1.86,6.95,6.33,0,3.99-3.16,6.77-8.78,6.77-4.46,0-8.99-2.13-8.99-7.36v-.15h4.5c0,2.99,2.45,3.9,4.64,3.9s4.14-.71,4.14-2.63c0-1.33-1.03-2.16-3.64-2.81-1.57-.41-2.93-.71-4.29-1.15-3.19-1.06-4.64-2.87-4.64-5.56,0-4.26,4.02-6.36,7.89-6.36,4.53,0,8.46,2.01,8.46,6.8Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.26,107.44h-4.49c-.33-2.07-2.31-3.7-4.61-3.7-3.78,0-5.74,2.99-5.74,7.24,0,3.96,1.86,7.07,5.74,7.07,2.66,0,4.4-1.72,4.79-4.73h4.5c-.47,5.32-4.11,8.63-9.28,8.63-6.44,0-10.38-4.79-10.38-10.97s3.84-11.15,10.38-11.15c4.73,0,8.57,2.84,9.11,7.6Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.25,100.35v8.1h8.55v-8.1h4.64v21.11h-4.64v-9.11h-8.55v9.11h-4.64v-21.11h4.64Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.07,100.35v13.22c0,3.1,1.36,4.49,4.34,4.49,3.25,0,4.38-1.39,4.38-4.49v-13.22h4.64v13.22c0,5.26-3.04,8.4-9.02,8.4s-8.99-3.13-8.99-8.4v-13.22h4.64Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.08,100.35v17.21h10.29v3.9h-14.93v-21.11h4.64Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.52,100.35c4.94,0,7.27,3.01,7.27,6.77s-2.4,6.77-7.24,6.77h-4.94v7.57h-4.64v-21.11h9.55ZM191.31,110.28c2.66,0,3.99-.92,3.99-3.16s-1.24-3.16-3.96-3.16h-3.72v6.33h3.7Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.08,100.35c3.72,0,6.18,2.57,6.18,5.82,0,2.66-1.13,4.41-3.34,5.29v.06c2.96.83,3.05,4.08,3.13,6.06.09,2.01.3,3.13.83,3.87h-4.64c-.35-.89-.47-2.16-.59-3.67-.24-2.96-.71-4.58-3.64-4.58h-4.67v8.25h-4.64v-21.11h11.38ZM212.45,109.9c1.95,0,3.16-.8,3.16-3.02,0-2.1-1.15-2.93-3.19-2.93h-5.09v5.94h5.11Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.88,110.99c0,6.15-3.93,10.97-10.38,10.97s-10.38-4.82-10.38-10.97,3.9-11.15,10.38-11.15,10.38,4.76,10.38,11.15ZM233.51,118.06c3.93,0,5.74-3.22,5.74-7.07,0-4.05-1.81-7.24-5.77-7.24s-5.71,3.16-5.71,7.24,1.86,7.07,5.74,7.07Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41,100.35v14.49c0,4.61-2.34,7.13-6.98,7.13-4.29,0-7.01-2.54-7.01-6.47v-1.89h4.2v1.03c0,2.48.92,3.43,2.69,3.43,2.31,0,2.45-1.69,2.45-3.28v-14.43h4.64Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,100.35v3.9h-11.14v4.52h10.23v3.61h-10.23v5.17h11.38v3.9h-16.02v-21.11h15.79Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,100.35v8.75l8.25-8.75h5.8l-8.25,8.34,9.05,12.77h-5.83l-6.36-9.49-2.66,2.69v6.8h-4.64v-21.11h4.64Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.65,100.35v3.9h-6.33v17.21h-4.64v-17.21h-6.33v-3.9h17.29Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.86,100.35v3.9h-11.14v4.52h10.23v3.61h-10.23v5.17h11.38v3.9h-16.02v-21.11h15.79Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.19,57.82l20.64.08.02,4.92-14.18-.05.03,6.15,12.29.05.02,4.54-12.29-.05.05,10.99-6.45-.02-.12-26.59Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.72,57.33c9.08.03,14.45,6.2,14.49,14.1.03,7.67-5.28,13.8-14.37,13.76-9.08-.03-14.46-6.2-14.49-13.87-.03-7.9,5.28-14.02,14.37-13.99ZM48.82,80.28c5.8.02,7.95-4.44,7.94-8.87-.02-4.66-2.22-9.13-8.01-9.15-5.8-.02-7.96,4.44-7.94,9.09.02,4.43,2.22,8.91,8.01,8.93ZM41.7,50.6l5.55.02.02,4.36-5.55-.02-.02-4.36ZM50.17,50.63l5.55.02.02,4.36-5.55-.02-.02-4.36Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,58.04l15.83.06c5.26.02,8.61,3.35,8.62,7.37.01,3.13-1.37,5.47-4.62,6.65v.07c3.17.76,4.09,3.55,4.3,6.24.13,1.68.1,4.8,1.26,6.3l-6.45-.02c-.79-1.68-.72-4.25-1.06-6.37-.46-2.79-1.66-4.03-4.91-4.04l-6.45-.02.04,10.39-6.45-.02-.12-26.59ZM74.05,70.09l7.07.03c2.88.01,4.44-1.1,4.42-3.78-.01-2.57-1.58-3.69-4.46-3.7l-7.07-.03.03,7.49Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.23,58.15l12.66.05c7.61.03,13.34,4.37,13.38,13.2.03,7.71-4.3,13.43-13.26,13.39l-12.66-.05-.12-26.59ZM103.77,79.85l5.76.02c3.74.01,7.31-2.06,7.28-7.94-.02-5.36-2.09-8.8-8.51-8.82l-4.6-.02.07,16.76Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,58.27l21.95.08.02,4.92-15.5-.06.02,5.7,14.22.05.02,4.54-14.22-.05.03,6.52,15.83.06.02,4.92-22.28-.08-.12-26.59Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.32,58.37l15.83.06c5.26.02,8.61,3.35,8.62,7.37.01,3.13-1.37,5.47-4.62,6.65v.07c3.17.76,4.09,3.55,4.3,6.24.13,1.68.1,4.8,1.26,6.3l-6.45-.02c-.79-1.68-.72-4.25-1.06-6.37-.46-2.8-1.66-4.03-4.91-4.04l-6.45-.02.04,10.39-6.45-.02-.12-26.59ZM160.83,70.42l7.07.03c2.88.01,4.44-1.1,4.42-3.78-.01-2.57-1.58-3.69-4.46-3.7l-7.07-.03.03,7.49Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48,76.26c.01,3.54,3.06,4.93,6.52,4.94,2.26,0,5.71-.57,5.7-3.29-.01-2.87-4.41-3.37-8.73-4.43-4.36-1.06-8.77-2.6-8.79-7.59-.02-5.44,5.64-8.02,10.94-8,6.12.02,11.77,2.47,11.8,8.61l-6.25-.02c-.22-3.2-2.73-4.03-5.81-4.04-2.05,0-4.44.77-4.43,3,0,2.05,1.41,2.31,8.77,4.06,2.14.49,8.72,1.75,8.75,7.78.02,4.88-4.2,8.51-12.17,8.48-6.5-.03-12.59-2.95-12.54-9.51l6.25.02Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,75.21c.03,7.19-4.64,10.67-12.49,10.64-7.89-.03-12.51-3.51-12.54-10.74l-.07-16.54,6.45.02.07,16.54c.01,2.91.85,5.78,6.07,5.8,4.6.02,6.08-1.8,6.06-5.75l-.07-16.54,6.45.02.07,16.54Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.14,58.69l9.08.03,6.95,18.31h.08s6.42-18.26,6.42-18.26l9.08.03.12,26.59-6.04-.02-.08-18.85h-.08s-7.11,18.82-7.11,18.82l-4.97-.02-7.28-18.69h-.08s.08,18.66.08,18.66l-6.04-.02-.12-26.59Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,58.83l9.08.03,6.95,18.31h.08l6.42-18.26,9.08.03.12,26.59-6.04-.02-.08-18.85h-.08s-7.11,18.82-7.11,18.82l-4.97-.02-7.28-18.69h-.08l.08,18.66-6.04-.02-.12-26.59Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,58.98l21.95.08.02,4.92-15.5-.06.02,5.7,14.22.05.02,4.54-14.22-.05.03,6.52,15.83.06.02,4.92-22.28-.08-.12-26.59Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.62,9.82v20.43h4.51v5.68h-4.51v7.86h-6.55v-7.86h-14.36v-6.31l14.75-19.8h6.16ZM24.93,18.46l-8.78,11.79h8.93v-11.79h-.14Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,26.66c0,11.69-4.37,17.81-12.52,17.81s-12.42-6.07-12.42-17.81,4.27-17.52,12.42-17.52,12.52,6.02,12.52,17.52ZM50.36,38.79c5.48,0,5.63-7.76,5.63-12.33s-.44-11.64-5.68-11.64-5.48,8.2-5.48,11.64c0,4.22.05,12.33,5.53,12.33Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.85,26.66c0,11.69-4.37,17.81-12.52,17.81s-12.42-6.07-12.42-17.81,4.27-17.52,12.42-17.52,12.52,6.02,12.52,17.52ZM77.34,38.79c5.48,0,5.63-7.76,5.63-12.33s-.44-11.64-5.68-11.64-5.48,8.2-5.48,11.64c0,4.22.05,12.33,5.53,12.33Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.33,26.66c0,11.69-4.37,17.81-12.52,17.81s-12.42-6.07-12.42-17.81,4.27-17.52,12.42-17.52,12.52,6.02,12.52,17.52ZM117.81,38.79c5.48,0,5.63-7.76,5.63-12.33s-.44-11.64-5.68-11.64-5.48,8.2-5.48,11.64c0,4.22.05,12.33,5.53,12.33Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.31,26.66c0,11.69-4.37,17.81-12.52,17.81s-12.42-6.07-12.42-17.81,4.27-17.52,12.42-17.52,12.52,6.02,12.52,17.52ZM144.79,38.79c5.48,0,5.63-7.76,5.63-12.33s-.44-11.64-5.68-11.64-5.48,8.2-5.48,11.64c0,4.22.05,12.33,5.53,12.33Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,26.66c0,11.69-4.37,17.81-12.52,17.81s-12.42-6.07-12.42-17.81,4.27-17.52,12.42-17.52,12.52,6.02,12.52,17.52ZM171.77,38.79c5.48,0,5.63-7.76,5.63-12.33s-.44-11.64-5.68-11.64-5.48,8.2-5.48,11.64c0,4.22.05,12.33,5.53,12.33Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.06,9.14v6.41h-18.29v7.42h16.79v5.92h-16.79v8.49h18.68v6.41h-26.3V9.14h25.91Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.07,9.14v21.69c0,5.09,2.23,7.38,7.13,7.38,5.34,0,7.18-2.28,7.18-7.38V9.14h7.62v21.69c0,8.64-5,13.78-14.8,13.78s-14.75-5.14-14.75-13.78V9.14h7.62Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,9.14c6.12,0,10.14,4.22,10.14,9.56,0,4.37-1.84,7.23-5.48,8.69v.1c4.85,1.36,5,6.7,5.14,9.95.14,3.3.49,5.14,1.36,6.36h-7.62c-.58-1.46-.78-3.54-.97-6.02-.39-4.85-1.16-7.52-5.97-7.52h-7.67v13.54h-7.62V9.14h18.68ZM285.57,24.81c3.2,0,5.19-1.31,5.19-4.95,0-3.44-1.89-4.8-5.24-4.8h-8.35v9.75h8.4Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.15,26.61c0,10.09-6.45,18-17.03,18s-17.03-7.91-17.03-18,6.41-18.29,17.03-18.29,17.03,7.81,17.03,18.29ZM320.11,38.2c6.45,0,9.41-5.29,9.41-11.6,0-6.65-2.96-11.89-9.46-11.89s-9.37,5.19-9.37,11.89,3.06,11.6,9.41,11.6Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.04,36.19h7.59v7.8h-7.59v-7.8Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.99,102.11v.94c.12,0,.24.01.36.02v-1.56c-.21.13-.36.34-.36.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.95 65.04 410.91 65.08 410.95 65.08 410.95 65.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.99,102.11v.94c.12,0,.24.01.36.02v-1.56c-.21.13-.36.34-.36.59Z",
    style: {
      fill: "url(#_10_dpi_40_)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.95 65.04 410.91 65.08 410.95 65.08 410.95 65.04",
    style: {
      fill: "url(#_10_dpi_40_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.03,92.1c-.24-.45-.51-.88-.84-1.28-.5-.62-1.1-1.15-1.75-1.58.4.31.79.64,1.16,1,.59.56,1.06,1.19,1.43,1.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.83,67.19s.05,0,.05,0l.17,3.63c-.04-1.77-.07-3.11-.08-3.65h-.14v.02Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.32,89.04c-.67.2-1.36.32-2.07.33.76.03,1.43-.09,2.07-.33Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.99,66.1c.1,0,.19-.03.28-.06l-3.66.19,3.38-.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.65,65.69c.07-.15.11-.32.17-.48-.11.23-.22.45-.32.67.06-.06.11-.12.14-.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.71,55.38c-.11.34-.24.68-.39,1-.34.7-.59,1.41-.78,2.13.17-.54.38-1.07.64-1.6.24-.49.4-1.01.54-1.53Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-6)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 54.05,
    x2: 550.25,
    y2: 54.05,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 51.13,
    x2: 550.25,
    y2: 51.13,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 48.21,
    x2: 550.25,
    y2: 48.21,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 45.29,
    x2: 550.25,
    y2: 45.29,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 42.37,
    x2: 550.25,
    y2: 42.37,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 39.45,
    x2: 550.25,
    y2: 39.45,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 36.53,
    x2: 550.25,
    y2: 36.53,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 33.61,
    x2: 550.25,
    y2: 33.61,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 30.69,
    x2: 550.25,
    y2: 30.69,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 27.77,
    x2: 550.25,
    y2: 27.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 24.85,
    x2: 550.25,
    y2: 24.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 21.93,
    x2: 550.25,
    y2: 21.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 19.01,
    x2: 550.25,
    y2: 19.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 16.08,
    x2: 550.25,
    y2: 16.08,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 13.16,
    x2: 550.25,
    y2: 13.16,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 10.24,
    x2: 550.25,
    y2: 10.24,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 7.32,
    x2: 550.25,
    y2: 7.32,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 4.4,
    x2: 550.25,
    y2: 4.4,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 1.48,
    x2: 550.25,
    y2: 1.48,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 54.05,
    x2: 480.16,
    y2: 54.05,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 51.13,
    x2: 480.16,
    y2: 51.13,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 48.21,
    x2: 480.16,
    y2: 48.21,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 45.29,
    x2: 480.16,
    y2: 45.29,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 42.37,
    x2: 480.16,
    y2: 42.37,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 39.45,
    x2: 480.16,
    y2: 39.45,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 36.53,
    x2: 480.16,
    y2: 36.53,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 33.61,
    x2: 480.16,
    y2: 33.61,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 30.69,
    x2: 480.16,
    y2: 30.69,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 27.77,
    x2: 480.16,
    y2: 27.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 24.85,
    x2: 480.16,
    y2: 24.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 21.93,
    x2: 480.16,
    y2: 21.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 19.01,
    x2: 480.16,
    y2: 19.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 16.08,
    x2: 480.16,
    y2: 16.08,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 13.16,
    x2: 480.16,
    y2: 13.16,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 10.24,
    x2: 480.16,
    y2: 10.24,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 7.32,
    x2: 480.16,
    y2: 7.32,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 4.4,
    x2: 480.16,
    y2: 4.4,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 1.48,
    x2: 480.16,
    y2: 1.48,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-7)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 124.14,
    x2: 550.25,
    y2: 124.14,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 121.22,
    x2: 550.25,
    y2: 121.22,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 118.3,
    x2: 550.25,
    y2: 118.3,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 115.38,
    x2: 550.25,
    y2: 115.38,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 112.46,
    x2: 550.25,
    y2: 112.46,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 109.54,
    x2: 550.25,
    y2: 109.54,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 106.62,
    x2: 550.25,
    y2: 106.62,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 103.7,
    x2: 550.25,
    y2: 103.7,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 100.77,
    x2: 550.25,
    y2: 100.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 97.85,
    x2: 550.25,
    y2: 97.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 94.93,
    x2: 550.25,
    y2: 94.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 92.01,
    x2: 550.25,
    y2: 92.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 89.09,
    x2: 550.25,
    y2: 89.09,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 86.17,
    x2: 550.25,
    y2: 86.17,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 83.25,
    x2: 550.25,
    y2: 83.25,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 80.33,
    x2: 550.25,
    y2: 80.33,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 77.41,
    x2: 550.25,
    y2: 77.41,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 74.49,
    x2: 550.25,
    y2: 74.49,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 71.57,
    x2: 550.25,
    y2: 71.57,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 68.65,
    x2: 550.25,
    y2: 68.65,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 65.73,
    x2: 550.25,
    y2: 65.73,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 62.81,
    x2: 550.25,
    y2: 62.81,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 59.89,
    x2: 550.25,
    y2: 59.89,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.16,
    y1: 56.97,
    x2: 550.25,
    y2: 56.97,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 124.14,
    x2: 480.16,
    y2: 124.14,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 121.22,
    x2: 480.16,
    y2: 121.22,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 118.3,
    x2: 480.16,
    y2: 118.3,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 115.38,
    x2: 480.16,
    y2: 115.38,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 112.46,
    x2: 480.16,
    y2: 112.46,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 109.54,
    x2: 480.16,
    y2: 109.54,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 106.62,
    x2: 480.16,
    y2: 106.62,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 103.7,
    x2: 480.16,
    y2: 103.7,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 100.77,
    x2: 480.16,
    y2: 100.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 97.85,
    x2: 480.16,
    y2: 97.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 94.93,
    x2: 480.16,
    y2: 94.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 92.01,
    x2: 480.16,
    y2: 92.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 89.09,
    x2: 480.16,
    y2: 89.09,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 86.17,
    x2: 480.16,
    y2: 86.17,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 83.25,
    x2: 480.16,
    y2: 83.25,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 80.33,
    x2: 480.16,
    y2: 80.33,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 77.41,
    x2: 480.16,
    y2: 77.41,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 74.49,
    x2: 480.16,
    y2: 74.49,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 71.57,
    x2: 480.16,
    y2: 71.57,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 68.65,
    x2: 480.16,
    y2: 68.65,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 65.73,
    x2: 480.16,
    y2: 65.73,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 62.81,
    x2: 480.16,
    y2: 62.81,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 59.89,
    x2: 480.16,
    y2: 59.89,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 56.97,
    x2: 480.16,
    y2: 56.97,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-8)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 54.05,
    x2: 480.16,
    y2: 54.05,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 51.13,
    x2: 480.16,
    y2: 51.13,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 48.21,
    x2: 480.16,
    y2: 48.21,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 45.29,
    x2: 480.16,
    y2: 45.29,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 42.37,
    x2: 480.16,
    y2: 42.37,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 39.45,
    x2: 480.16,
    y2: 39.45,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 36.53,
    x2: 480.16,
    y2: 36.53,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 33.61,
    x2: 480.16,
    y2: 33.61,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 30.69,
    x2: 480.16,
    y2: 30.69,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 27.77,
    x2: 480.16,
    y2: 27.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 24.85,
    x2: 480.16,
    y2: 24.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 21.93,
    x2: 480.16,
    y2: 21.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 19.01,
    x2: 480.16,
    y2: 19.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 16.08,
    x2: 480.16,
    y2: 16.08,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 13.16,
    x2: 480.16,
    y2: 13.16,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 10.24,
    x2: 480.16,
    y2: 10.24,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 7.32,
    x2: 480.16,
    y2: 7.32,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 4.4,
    x2: 480.16,
    y2: 4.4,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 1.48,
    x2: 480.16,
    y2: 1.48,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 54.05,
    x2: 410.07,
    y2: 54.05,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 51.13,
    x2: 410.07,
    y2: 51.13,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 48.21,
    x2: 410.07,
    y2: 48.21,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 45.29,
    x2: 410.07,
    y2: 45.29,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 42.37,
    x2: 410.07,
    y2: 42.37,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 39.45,
    x2: 410.07,
    y2: 39.45,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 36.53,
    x2: 410.07,
    y2: 36.53,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 33.61,
    x2: 410.07,
    y2: 33.61,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 30.69,
    x2: 410.07,
    y2: 30.69,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 27.77,
    x2: 410.07,
    y2: 27.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 24.85,
    x2: 410.07,
    y2: 24.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 21.93,
    x2: 410.07,
    y2: 21.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 19.01,
    x2: 410.07,
    y2: 19.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 16.08,
    x2: 410.07,
    y2: 16.08,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 13.16,
    x2: 410.07,
    y2: 13.16,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 10.24,
    x2: 410.07,
    y2: 10.24,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 7.32,
    x2: 410.07,
    y2: 7.32,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 4.4,
    x2: 410.07,
    y2: 4.4,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 1.48,
    x2: 410.07,
    y2: 1.48,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-9)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 124.14,
    x2: 480.16,
    y2: 124.14,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 121.22,
    x2: 480.16,
    y2: 121.22,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 118.3,
    x2: 480.16,
    y2: 118.3,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 115.38,
    x2: 480.16,
    y2: 115.38,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 112.46,
    x2: 480.16,
    y2: 112.46,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 109.54,
    x2: 480.16,
    y2: 109.54,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 106.62,
    x2: 480.16,
    y2: 106.62,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 103.7,
    x2: 480.16,
    y2: 103.7,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 100.77,
    x2: 480.16,
    y2: 100.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 97.85,
    x2: 480.16,
    y2: 97.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 94.93,
    x2: 480.16,
    y2: 94.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 92.01,
    x2: 480.16,
    y2: 92.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 89.09,
    x2: 480.16,
    y2: 89.09,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 86.17,
    x2: 480.16,
    y2: 86.17,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 83.25,
    x2: 480.16,
    y2: 83.25,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 80.33,
    x2: 480.16,
    y2: 80.33,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 77.41,
    x2: 480.16,
    y2: 77.41,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 74.49,
    x2: 480.16,
    y2: 74.49,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 71.57,
    x2: 480.16,
    y2: 71.57,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 68.65,
    x2: 480.16,
    y2: 68.65,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 65.73,
    x2: 480.16,
    y2: 65.73,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 62.81,
    x2: 480.16,
    y2: 62.81,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 59.89,
    x2: 480.16,
    y2: 59.89,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.07,
    y1: 56.97,
    x2: 480.16,
    y2: 56.97,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 124.14,
    x2: 410.07,
    y2: 124.14,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 121.22,
    x2: 410.07,
    y2: 121.22,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 118.3,
    x2: 410.07,
    y2: 118.3,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 115.38,
    x2: 410.07,
    y2: 115.38,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 112.46,
    x2: 410.07,
    y2: 112.46,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 109.54,
    x2: 410.07,
    y2: 109.54,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 106.62,
    x2: 410.07,
    y2: 106.62,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 103.7,
    x2: 410.07,
    y2: 103.7,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 100.77,
    x2: 410.07,
    y2: 100.77,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 97.85,
    x2: 410.07,
    y2: 97.85,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 94.93,
    x2: 410.07,
    y2: 94.93,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 92.01,
    x2: 410.07,
    y2: 92.01,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 89.09,
    x2: 410.07,
    y2: 89.09,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 86.17,
    x2: 410.07,
    y2: 86.17,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 83.25,
    x2: 410.07,
    y2: 83.25,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 80.33,
    x2: 410.07,
    y2: 80.33,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 77.41,
    x2: 410.07,
    y2: 77.41,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 74.49,
    x2: 410.07,
    y2: 74.49,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 71.57,
    x2: 410.07,
    y2: 71.57,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 68.65,
    x2: 410.07,
    y2: 68.65,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 65.73,
    x2: 410.07,
    y2: 65.73,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 62.81,
    x2: 410.07,
    y2: 62.81,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 59.89,
    x2: 410.07,
    y2: 59.89,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.98,
    y1: 56.97,
    x2: 410.07,
    y2: 56.97,
    style: {
      fill: "#1d1d1b",
      stroke: "#6868ac",
      strokeDasharray: "1.95 .97",
      strokeWidth: "1.95px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.96,66.9l18.65-.68,3.66-.19c.09-.04.17-.09.24-.16.1-.22.2-.44.32-.67.51-1.35.71-2.89.56-4.7-.13-1.57-.49-2.86-1.05-3.98-.58-1.12-.86-2.34-.86-3.61,0-2.39,1.07-4.62,2.92-6.11,1.83-1.5,4.23-2.06,6.6-1.57,3.05.64,5.52,3.25,6.02,6.38.2,1.28.09,2.56-.3,3.77-.13.52-.3,1.04-.54,1.53-.26.53-.47,1.06-.64,1.6-.11.43-.21.87-.27,1.3-.3,2.34-.07,4.26.65,5.89.11.26.37.41.65.41l22.36-.33c-.05-3.13-.38-22.06-.13-22.16,1.61-.68,3.5-.87,5.77-.58,1.15.15,2.31.49,3.44,1.05,1.47.72,3.12.96,4.78.7,3.14-.51,5.77-3.01,6.41-6.1.51-2.41-.08-4.86-1.61-6.72-1.49-1.85-3.73-2.9-6.11-2.9-1.29,0-2.5.3-3.63.89-1.12.56-2.44.92-4.01,1.05-1.97.17-3.61-.06-5.05-.66-.07-.03-.13-1.06-.11-1.06V8.78s-22.67,1.29-22.79,1.54c-.66,1.47-.91,1.23-.74,3.26.13,1.58.49,2.88,1.06,4.01.59,1.13.87,2.35.87,3.63,0,2.41-1.08,4.65-2.95,6.16-1.85,1.51-4.27,2.07-6.68,1.58-3.08-.64-5.58-3.28-6.09-6.42-.26-1.66-.02-3.31.7-4.8.55-1.13.91-2.3,1.06-3.45.3-2.35.08-2.34-.66-3.98-.11-.26-23.83.19-23.83.19l.09,2,.88,19.1c0,.25,3.52,1.49,5.48,1.32,1.57-.13,2.89-.49,4.01-1.05,1.13-.58,2.34-.89,3.63-.89,2.38,0,4.61,1.05,6.11,2.9,1.53,1.86,2.12,3.34,1.61,5.75-.64,3.09-3.27,5.59-6.41,6.1-1.66.26-3.31.02-4.78-.7-1.13-.57-2.29-.9-3.44-1.05-2.27-.28-4.16-.09-5.77.58-.03.01-.43.41-.43.66",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-10)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.28,55.02h-1.95v-1.95h1.95v1.95ZM546.35,55.02h-1.95v-1.95h1.95v1.95ZM543.43,55.02h-1.95v-1.95h1.95v1.95ZM540.51,55.02h-1.95v-1.95h1.95v1.95ZM537.59,55.02h-1.95v-1.95h1.95v1.95ZM534.67,55.02h-1.95v-1.95h1.95v1.95ZM531.75,55.02h-1.95v-1.95h1.95v1.95ZM528.83,55.02h-1.95v-1.95h1.95v1.95ZM525.91,55.02h-1.95v-1.95h1.95v1.95ZM522.99,55.02h-1.95v-1.95h1.95v1.95ZM520.07,55.02h-1.95v-1.95h1.95v1.95ZM517.15,55.02h-1.95v-1.95h1.95v1.95ZM514.23,55.02h-1.95v-1.95h1.95v1.95ZM511.31,55.02h-1.95v-1.95h1.95v1.95ZM508.39,55.02h-1.95v-1.95h1.95v1.95ZM505.47,55.02h-1.95v-1.95h1.95v1.95ZM502.55,55.02h-1.95v-1.95h1.95v1.95ZM499.63,55.02h-1.95v-1.95h1.95v1.95ZM496.71,55.02h-1.95v-1.95h1.95v1.95ZM493.79,55.02h-1.95v-1.95h1.95v1.95ZM490.87,55.02h-1.95v-1.95h1.95v1.95ZM487.95,55.02h-1.95v-1.95h1.95v1.95ZM485.03,55.02h-1.95v-1.95h1.95v1.95ZM482.11,55.02h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,52.1h-1.95v-1.95h1.95v1.95ZM546.35,52.1h-1.95v-1.95h1.95v1.95ZM543.43,52.1h-1.95v-1.95h1.95v1.95ZM540.51,52.1h-1.95v-1.95h1.95v1.95ZM537.59,52.1h-1.95v-1.95h1.95v1.95ZM534.67,52.1h-1.95v-1.95h1.95v1.95ZM531.75,52.1h-1.95v-1.95h1.95v1.95ZM528.83,52.1h-1.95v-1.95h1.95v1.95ZM525.91,52.1h-1.95v-1.95h1.95v1.95ZM522.99,52.1h-1.95v-1.95h1.95v1.95ZM520.07,52.1h-1.95v-1.95h1.95v1.95ZM517.15,52.1h-1.95v-1.95h1.95v1.95ZM514.23,52.1h-1.95v-1.95h1.95v1.95ZM511.31,52.1h-1.95v-1.95h1.95v1.95ZM508.39,52.1h-1.95v-1.95h1.95v1.95ZM505.47,52.1h-1.95v-1.95h1.95v1.95ZM502.55,52.1h-1.95v-1.95h1.95v1.95ZM499.63,52.1h-1.95v-1.95h1.95v1.95ZM496.71,52.1h-1.95v-1.95h1.95v1.95ZM493.79,52.1h-1.95v-1.95h1.95v1.95ZM490.87,52.1h-1.95v-1.95h1.95v1.95ZM487.95,52.1h-1.95v-1.95h1.95v1.95ZM485.03,52.1h-1.95v-1.95h1.95v1.95ZM482.11,52.1h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,49.18h-1.95v-1.95h1.95v1.95ZM546.35,49.18h-1.95v-1.95h1.95v1.95ZM543.43,49.18h-1.95v-1.95h1.95v1.95ZM540.51,49.18h-1.95v-1.95h1.95v1.95ZM537.59,49.18h-1.95v-1.95h1.95v1.95ZM534.67,49.18h-1.95v-1.95h1.95v1.95ZM531.75,49.18h-1.95v-1.95h1.95v1.95ZM528.83,49.18h-1.95v-1.95h1.95v1.95ZM525.91,49.18h-1.95v-1.95h1.95v1.95ZM522.99,49.18h-1.95v-1.95h1.95v1.95ZM520.07,49.18h-1.95v-1.95h1.95v1.95ZM517.15,49.18h-1.95v-1.95h1.95v1.95ZM514.23,49.18h-1.95v-1.95h1.95v1.95ZM511.31,49.18h-1.95v-1.95h1.95v1.95ZM508.39,49.18h-1.95v-1.95h1.95v1.95ZM505.47,49.18h-1.95v-1.95h1.95v1.95ZM502.55,49.18h-1.95v-1.95h1.95v1.95ZM499.63,49.18h-1.95v-1.95h1.95v1.95ZM496.71,49.18h-1.95v-1.95h1.95v1.95ZM493.79,49.18h-1.95v-1.95h1.95v1.95ZM490.87,49.18h-1.95v-1.95h1.95v1.95ZM487.95,49.18h-1.95v-1.95h1.95v1.95ZM485.03,49.18h-1.95v-1.95h1.95v1.95ZM482.11,49.18h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,46.26h-1.95v-1.95h1.95v1.95ZM546.35,46.26h-1.95v-1.95h1.95v1.95ZM543.43,46.26h-1.95v-1.95h1.95v1.95ZM540.51,46.26h-1.95v-1.95h1.95v1.95ZM537.59,46.26h-1.95v-1.95h1.95v1.95ZM534.67,46.26h-1.95v-1.95h1.95v1.95ZM531.75,46.26h-1.95v-1.95h1.95v1.95ZM528.83,46.26h-1.95v-1.95h1.95v1.95ZM525.91,46.26h-1.95v-1.95h1.95v1.95ZM522.99,46.26h-1.95v-1.95h1.95v1.95ZM520.07,46.26h-1.95v-1.95h1.95v1.95ZM517.15,46.26h-1.95v-1.95h1.95v1.95ZM514.23,46.26h-1.95v-1.95h1.95v1.95ZM511.31,46.26h-1.95v-1.95h1.95v1.95ZM508.39,46.26h-1.95v-1.95h1.95v1.95ZM505.47,46.26h-1.95v-1.95h1.95v1.95ZM502.55,46.26h-1.95v-1.95h1.95v1.95ZM499.63,46.26h-1.95v-1.95h1.95v1.95ZM496.71,46.26h-1.95v-1.95h1.95v1.95ZM493.79,46.26h-1.95v-1.95h1.95v1.95ZM490.87,46.26h-1.95v-1.95h1.95v1.95ZM487.95,46.26h-1.95v-1.95h1.95v1.95ZM485.03,46.26h-1.95v-1.95h1.95v1.95ZM482.11,46.26h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,43.34h-1.95v-1.95h1.95v1.95ZM546.35,43.34h-1.95v-1.95h1.95v1.95ZM543.43,43.34h-1.95v-1.95h1.95v1.95ZM540.51,43.34h-1.95v-1.95h1.95v1.95ZM537.59,43.34h-1.95v-1.95h1.95v1.95ZM534.67,43.34h-1.95v-1.95h1.95v1.95ZM531.75,43.34h-1.95v-1.95h1.95v1.95ZM528.83,43.34h-1.95v-1.95h1.95v1.95ZM525.91,43.34h-1.95v-1.95h1.95v1.95ZM522.99,43.34h-1.95v-1.95h1.95v1.95ZM520.07,43.34h-1.95v-1.95h1.95v1.95ZM517.15,43.34h-1.95v-1.95h1.95v1.95ZM514.23,43.34h-1.95v-1.95h1.95v1.95ZM511.31,43.34h-1.95v-1.95h1.95v1.95ZM508.39,43.34h-1.95v-1.95h1.95v1.95ZM505.47,43.34h-1.95v-1.95h1.95v1.95ZM502.55,43.34h-1.95v-1.95h1.95v1.95ZM499.63,43.34h-1.95v-1.95h1.95v1.95ZM496.71,43.34h-1.95v-1.95h1.95v1.95ZM493.79,43.34h-1.95v-1.95h1.95v1.95ZM490.87,43.34h-1.95v-1.95h1.95v1.95ZM487.95,43.34h-1.95v-1.95h1.95v1.95ZM485.03,43.34h-1.95v-1.95h1.95v1.95ZM482.11,43.34h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,40.42h-1.95v-1.95h1.95v1.95ZM546.35,40.42h-1.95v-1.95h1.95v1.95ZM543.43,40.42h-1.95v-1.95h1.95v1.95ZM540.51,40.42h-1.95v-1.95h1.95v1.95ZM537.59,40.42h-1.95v-1.95h1.95v1.95ZM534.67,40.42h-1.95v-1.95h1.95v1.95ZM531.75,40.42h-1.95v-1.95h1.95v1.95ZM528.83,40.42h-1.95v-1.95h1.95v1.95ZM525.91,40.42h-1.95v-1.95h1.95v1.95ZM522.99,40.42h-1.95v-1.95h1.95v1.95ZM520.07,40.42h-1.95v-1.95h1.95v1.95ZM517.15,40.42h-1.95v-1.95h1.95v1.95ZM514.23,40.42h-1.95v-1.95h1.95v1.95ZM511.31,40.42h-1.95v-1.95h1.95v1.95ZM508.39,40.42h-1.95v-1.95h1.95v1.95ZM505.47,40.42h-1.95v-1.95h1.95v1.95ZM502.55,40.42h-1.95v-1.95h1.95v1.95ZM499.63,40.42h-1.95v-1.95h1.95v1.95ZM496.71,40.42h-1.95v-1.95h1.95v1.95ZM493.79,40.42h-1.95v-1.95h1.95v1.95ZM490.87,40.42h-1.95v-1.95h1.95v1.95ZM487.95,40.42h-1.95v-1.95h1.95v1.95ZM485.03,40.42h-1.95v-1.95h1.95v1.95ZM482.11,40.42h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,37.5h-1.95v-1.95h1.95v1.95ZM546.35,37.5h-1.95v-1.95h1.95v1.95ZM543.43,37.5h-1.95v-1.95h1.95v1.95ZM540.51,37.5h-1.95v-1.95h1.95v1.95ZM537.59,37.5h-1.95v-1.95h1.95v1.95ZM534.67,37.5h-1.95v-1.95h1.95v1.95ZM531.75,37.5h-1.95v-1.95h1.95v1.95ZM528.83,37.5h-1.95v-1.95h1.95v1.95ZM525.91,37.5h-1.95v-1.95h1.95v1.95ZM522.99,37.5h-1.95v-1.95h1.95v1.95ZM520.07,37.5h-1.95v-1.95h1.95v1.95ZM517.15,37.5h-1.95v-1.95h1.95v1.95ZM514.23,37.5h-1.95v-1.95h1.95v1.95ZM511.31,37.5h-1.95v-1.95h1.95v1.95ZM508.39,37.5h-1.95v-1.95h1.95v1.95ZM505.47,37.5h-1.95v-1.95h1.95v1.95ZM502.55,37.5h-1.95v-1.95h1.95v1.95ZM499.63,37.5h-1.95v-1.95h1.95v1.95ZM496.71,37.5h-1.95v-1.95h1.95v1.95ZM493.79,37.5h-1.95v-1.95h1.95v1.95ZM490.87,37.5h-1.95v-1.95h1.95v1.95ZM487.95,37.5h-1.95v-1.95h1.95v1.95ZM485.03,37.5h-1.95v-1.95h1.95v1.95ZM482.11,37.5h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,34.58h-1.95v-1.95h1.95v1.95ZM546.35,34.58h-1.95v-1.95h1.95v1.95ZM543.43,34.58h-1.95v-1.95h1.95v1.95ZM540.51,34.58h-1.95v-1.95h1.95v1.95ZM537.59,34.58h-1.95v-1.95h1.95v1.95ZM534.67,34.58h-1.95v-1.95h1.95v1.95ZM531.75,34.58h-1.95v-1.95h1.95v1.95ZM528.83,34.58h-1.95v-1.95h1.95v1.95ZM525.91,34.58h-1.95v-1.95h1.95v1.95ZM522.99,34.58h-1.95v-1.95h1.95v1.95ZM520.07,34.58h-1.95v-1.95h1.95v1.95ZM517.15,34.58h-1.95v-1.95h1.95v1.95ZM514.23,34.58h-1.95v-1.95h1.95v1.95ZM511.31,34.58h-1.95v-1.95h1.95v1.95ZM508.39,34.58h-1.95v-1.95h1.95v1.95ZM505.47,34.58h-1.95v-1.95h1.95v1.95ZM502.55,34.58h-1.95v-1.95h1.95v1.95ZM499.63,34.58h-1.95v-1.95h1.95v1.95ZM496.71,34.58h-1.95v-1.95h1.95v1.95ZM493.79,34.58h-1.95v-1.95h1.95v1.95ZM490.87,34.58h-1.95v-1.95h1.95v1.95ZM487.95,34.58h-1.95v-1.95h1.95v1.95ZM485.03,34.58h-1.95v-1.95h1.95v1.95ZM482.11,34.58h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,31.66h-1.95v-1.95h1.95v1.95ZM546.35,31.66h-1.95v-1.95h1.95v1.95ZM543.43,31.66h-1.95v-1.95h1.95v1.95ZM540.51,31.66h-1.95v-1.95h1.95v1.95ZM537.59,31.66h-1.95v-1.95h1.95v1.95ZM534.67,31.66h-1.95v-1.95h1.95v1.95ZM531.75,31.66h-1.95v-1.95h1.95v1.95ZM528.83,31.66h-1.95v-1.95h1.95v1.95ZM525.91,31.66h-1.95v-1.95h1.95v1.95ZM522.99,31.66h-1.95v-1.95h1.95v1.95ZM520.07,31.66h-1.95v-1.95h1.95v1.95ZM517.15,31.66h-1.95v-1.95h1.95v1.95ZM514.23,31.66h-1.95v-1.95h1.95v1.95ZM511.31,31.66h-1.95v-1.95h1.95v1.95ZM508.39,31.66h-1.95v-1.95h1.95v1.95ZM505.47,31.66h-1.95v-1.95h1.95v1.95ZM502.55,31.66h-1.95v-1.95h1.95v1.95ZM499.63,31.66h-1.95v-1.95h1.95v1.95ZM496.71,31.66h-1.95v-1.95h1.95v1.95ZM493.79,31.66h-1.95v-1.95h1.95v1.95ZM490.87,31.66h-1.95v-1.95h1.95v1.95ZM487.95,31.66h-1.95v-1.95h1.95v1.95ZM485.03,31.66h-1.95v-1.95h1.95v1.95ZM482.11,31.66h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,28.74h-1.95v-1.95h1.95v1.95ZM546.35,28.74h-1.95v-1.95h1.95v1.95ZM543.43,28.74h-1.95v-1.95h1.95v1.95ZM540.51,28.74h-1.95v-1.95h1.95v1.95ZM537.59,28.74h-1.95v-1.95h1.95v1.95ZM534.67,28.74h-1.95v-1.95h1.95v1.95ZM531.75,28.74h-1.95v-1.95h1.95v1.95ZM528.83,28.74h-1.95v-1.95h1.95v1.95ZM525.91,28.74h-1.95v-1.95h1.95v1.95ZM522.99,28.74h-1.95v-1.95h1.95v1.95ZM520.07,28.74h-1.95v-1.95h1.95v1.95ZM517.15,28.74h-1.95v-1.95h1.95v1.95ZM514.23,28.74h-1.95v-1.95h1.95v1.95ZM511.31,28.74h-1.95v-1.95h1.95v1.95ZM508.39,28.74h-1.95v-1.95h1.95v1.95ZM505.47,28.74h-1.95v-1.95h1.95v1.95ZM502.55,28.74h-1.95v-1.95h1.95v1.95ZM499.63,28.74h-1.95v-1.95h1.95v1.95ZM496.71,28.74h-1.95v-1.95h1.95v1.95ZM493.79,28.74h-1.95v-1.95h1.95v1.95ZM490.87,28.74h-1.95v-1.95h1.95v1.95ZM487.95,28.74h-1.95v-1.95h1.95v1.95ZM485.03,28.74h-1.95v-1.95h1.95v1.95ZM482.11,28.74h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,25.82h-1.95v-1.95h1.95v1.95ZM546.35,25.82h-1.95v-1.95h1.95v1.95ZM543.43,25.82h-1.95v-1.95h1.95v1.95ZM540.51,25.82h-1.95v-1.95h1.95v1.95ZM537.59,25.82h-1.95v-1.95h1.95v1.95ZM534.67,25.82h-1.95v-1.95h1.95v1.95ZM531.75,25.82h-1.95v-1.95h1.95v1.95ZM528.83,25.82h-1.95v-1.95h1.95v1.95ZM525.91,25.82h-1.95v-1.95h1.95v1.95ZM522.99,25.82h-1.95v-1.95h1.95v1.95ZM520.07,25.82h-1.95v-1.95h1.95v1.95ZM517.15,25.82h-1.95v-1.95h1.95v1.95ZM514.23,25.82h-1.95v-1.95h1.95v1.95ZM511.31,25.82h-1.95v-1.95h1.95v1.95ZM508.39,25.82h-1.95v-1.95h1.95v1.95ZM505.47,25.82h-1.95v-1.95h1.95v1.95ZM502.55,25.82h-1.95v-1.95h1.95v1.95ZM499.63,25.82h-1.95v-1.95h1.95v1.95ZM496.71,25.82h-1.95v-1.95h1.95v1.95ZM493.79,25.82h-1.95v-1.95h1.95v1.95ZM490.87,25.82h-1.95v-1.95h1.95v1.95ZM487.95,25.82h-1.95v-1.95h1.95v1.95ZM485.03,25.82h-1.95v-1.95h1.95v1.95ZM482.11,25.82h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,22.9h-1.95v-1.95h1.95v1.95ZM546.35,22.9h-1.95v-1.95h1.95v1.95ZM543.43,22.9h-1.95v-1.95h1.95v1.95ZM540.51,22.9h-1.95v-1.95h1.95v1.95ZM537.59,22.9h-1.95v-1.95h1.95v1.95ZM534.67,22.9h-1.95v-1.95h1.95v1.95ZM531.75,22.9h-1.95v-1.95h1.95v1.95ZM528.83,22.9h-1.95v-1.95h1.95v1.95ZM525.91,22.9h-1.95v-1.95h1.95v1.95ZM522.99,22.9h-1.95v-1.95h1.95v1.95ZM520.07,22.9h-1.95v-1.95h1.95v1.95ZM517.15,22.9h-1.95v-1.95h1.95v1.95ZM514.23,22.9h-1.95v-1.95h1.95v1.95ZM511.31,22.9h-1.95v-1.95h1.95v1.95ZM508.39,22.9h-1.95v-1.95h1.95v1.95ZM505.47,22.9h-1.95v-1.95h1.95v1.95ZM502.55,22.9h-1.95v-1.95h1.95v1.95ZM499.63,22.9h-1.95v-1.95h1.95v1.95ZM496.71,22.9h-1.95v-1.95h1.95v1.95ZM493.79,22.9h-1.95v-1.95h1.95v1.95ZM490.87,22.9h-1.95v-1.95h1.95v1.95ZM487.95,22.9h-1.95v-1.95h1.95v1.95ZM485.03,22.9h-1.95v-1.95h1.95v1.95ZM482.11,22.9h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,19.98h-1.95v-1.95h1.95v1.95ZM546.35,19.98h-1.95v-1.95h1.95v1.95ZM543.43,19.98h-1.95v-1.95h1.95v1.95ZM540.51,19.98h-1.95v-1.95h1.95v1.95ZM537.59,19.98h-1.95v-1.95h1.95v1.95ZM534.67,19.98h-1.95v-1.95h1.95v1.95ZM531.75,19.98h-1.95v-1.95h1.95v1.95ZM528.83,19.98h-1.95v-1.95h1.95v1.95ZM525.91,19.98h-1.95v-1.95h1.95v1.95ZM522.99,19.98h-1.95v-1.95h1.95v1.95ZM520.07,19.98h-1.95v-1.95h1.95v1.95ZM517.15,19.98h-1.95v-1.95h1.95v1.95ZM514.23,19.98h-1.95v-1.95h1.95v1.95ZM511.31,19.98h-1.95v-1.95h1.95v1.95ZM508.39,19.98h-1.95v-1.95h1.95v1.95ZM505.47,19.98h-1.95v-1.95h1.95v1.95ZM502.55,19.98h-1.95v-1.95h1.95v1.95ZM499.63,19.98h-1.95v-1.95h1.95v1.95ZM496.71,19.98h-1.95v-1.95h1.95v1.95ZM493.79,19.98h-1.95v-1.95h1.95v1.95ZM490.87,19.98h-1.95v-1.95h1.95v1.95ZM487.95,19.98h-1.95v-1.95h1.95v1.95ZM485.03,19.98h-1.95v-1.95h1.95v1.95ZM482.11,19.98h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,17.06h-1.95v-1.95h1.95v1.95ZM546.35,17.06h-1.95v-1.95h1.95v1.95ZM543.43,17.06h-1.95v-1.95h1.95v1.95ZM540.51,17.06h-1.95v-1.95h1.95v1.95ZM537.59,17.06h-1.95v-1.95h1.95v1.95ZM534.67,17.06h-1.95v-1.95h1.95v1.95ZM531.75,17.06h-1.95v-1.95h1.95v1.95ZM528.83,17.06h-1.95v-1.95h1.95v1.95ZM525.91,17.06h-1.95v-1.95h1.95v1.95ZM522.99,17.06h-1.95v-1.95h1.95v1.95ZM520.07,17.06h-1.95v-1.95h1.95v1.95ZM517.15,17.06h-1.95v-1.95h1.95v1.95ZM514.23,17.06h-1.95v-1.95h1.95v1.95ZM511.31,17.06h-1.95v-1.95h1.95v1.95ZM508.39,17.06h-1.95v-1.95h1.95v1.95ZM505.47,17.06h-1.95v-1.95h1.95v1.95ZM502.55,17.06h-1.95v-1.95h1.95v1.95ZM499.63,17.06h-1.95v-1.95h1.95v1.95ZM496.71,17.06h-1.95v-1.95h1.95v1.95ZM493.79,17.06h-1.95v-1.95h1.95v1.95ZM490.87,17.06h-1.95v-1.95h1.95v1.95ZM487.95,17.06h-1.95v-1.95h1.95v1.95ZM485.03,17.06h-1.95v-1.95h1.95v1.95ZM482.11,17.06h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,14.14h-1.95v-1.95h1.95v1.95ZM546.35,14.14h-1.95v-1.95h1.95v1.95ZM543.43,14.14h-1.95v-1.95h1.95v1.95ZM540.51,14.14h-1.95v-1.95h1.95v1.95ZM537.59,14.14h-1.95v-1.95h1.95v1.95ZM534.67,14.14h-1.95v-1.95h1.95v1.95ZM531.75,14.14h-1.95v-1.95h1.95v1.95ZM528.83,14.14h-1.95v-1.95h1.95v1.95ZM525.91,14.14h-1.95v-1.95h1.95v1.95ZM522.99,14.14h-1.95v-1.95h1.95v1.95ZM520.07,14.14h-1.95v-1.95h1.95v1.95ZM517.15,14.14h-1.95v-1.95h1.95v1.95ZM514.23,14.14h-1.95v-1.95h1.95v1.95ZM511.31,14.14h-1.95v-1.95h1.95v1.95ZM508.39,14.14h-1.95v-1.95h1.95v1.95ZM505.47,14.14h-1.95v-1.95h1.95v1.95ZM502.55,14.14h-1.95v-1.95h1.95v1.95ZM499.63,14.14h-1.95v-1.95h1.95v1.95ZM496.71,14.14h-1.95v-1.95h1.95v1.95ZM493.79,14.14h-1.95v-1.95h1.95v1.95ZM490.87,14.14h-1.95v-1.95h1.95v1.95ZM487.95,14.14h-1.95v-1.95h1.95v1.95ZM485.03,14.14h-1.95v-1.95h1.95v1.95ZM482.11,14.14h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,11.22h-1.95v-1.95h1.95v1.95ZM546.35,11.22h-1.95v-1.95h1.95v1.95ZM543.43,11.22h-1.95v-1.95h1.95v1.95ZM540.51,11.22h-1.95v-1.95h1.95v1.95ZM537.59,11.22h-1.95v-1.95h1.95v1.95ZM534.67,11.22h-1.95v-1.95h1.95v1.95ZM531.75,11.22h-1.95v-1.95h1.95v1.95ZM528.83,11.22h-1.95v-1.95h1.95v1.95ZM525.91,11.22h-1.95v-1.95h1.95v1.95ZM522.99,11.22h-1.95v-1.95h1.95v1.95ZM520.07,11.22h-1.95v-1.95h1.95v1.95ZM517.15,11.22h-1.95v-1.95h1.95v1.95ZM514.23,11.22h-1.95v-1.95h1.95v1.95ZM511.31,11.22h-1.95v-1.95h1.95v1.95ZM508.39,11.22h-1.95v-1.95h1.95v1.95ZM505.47,11.22h-1.95v-1.95h1.95v1.95ZM502.55,11.22h-1.95v-1.95h1.95v1.95ZM499.63,11.22h-1.95v-1.95h1.95v1.95ZM496.71,11.22h-1.95v-1.95h1.95v1.95ZM493.79,11.22h-1.95v-1.95h1.95v1.95ZM490.87,11.22h-1.95v-1.95h1.95v1.95ZM487.95,11.22h-1.95v-1.95h1.95v1.95ZM485.03,11.22h-1.95v-1.95h1.95v1.95ZM482.11,11.22h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,8.3h-1.95v-1.95h1.95v1.95ZM546.35,8.3h-1.95v-1.95h1.95v1.95ZM543.43,8.3h-1.95v-1.95h1.95v1.95ZM540.51,8.3h-1.95v-1.95h1.95v1.95ZM537.59,8.3h-1.95v-1.95h1.95v1.95ZM534.67,8.3h-1.95v-1.95h1.95v1.95ZM531.75,8.3h-1.95v-1.95h1.95v1.95ZM528.83,8.3h-1.95v-1.95h1.95v1.95ZM525.91,8.3h-1.95v-1.95h1.95v1.95ZM522.99,8.3h-1.95v-1.95h1.95v1.95ZM520.07,8.3h-1.95v-1.95h1.95v1.95ZM517.15,8.3h-1.95v-1.95h1.95v1.95ZM514.23,8.3h-1.95v-1.95h1.95v1.95ZM511.31,8.3h-1.95v-1.95h1.95v1.95ZM508.39,8.3h-1.95v-1.95h1.95v1.95ZM505.47,8.3h-1.95v-1.95h1.95v1.95ZM502.55,8.3h-1.95v-1.95h1.95v1.95ZM499.63,8.3h-1.95v-1.95h1.95v1.95ZM496.71,8.3h-1.95v-1.95h1.95v1.95ZM493.79,8.3h-1.95v-1.95h1.95v1.95ZM490.87,8.3h-1.95v-1.95h1.95v1.95ZM487.95,8.3h-1.95v-1.95h1.95v1.95ZM485.03,8.3h-1.95v-1.95h1.95v1.95ZM482.11,8.3h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,5.38h-1.95v-1.95h1.95v1.95ZM546.35,5.38h-1.95v-1.95h1.95v1.95ZM543.43,5.38h-1.95v-1.95h1.95v1.95ZM540.51,5.38h-1.95v-1.95h1.95v1.95ZM537.59,5.38h-1.95v-1.95h1.95v1.95ZM534.67,5.38h-1.95v-1.95h1.95v1.95ZM531.75,5.38h-1.95v-1.95h1.95v1.95ZM528.83,5.38h-1.95v-1.95h1.95v1.95ZM525.91,5.38h-1.95v-1.95h1.95v1.95ZM522.99,5.38h-1.95v-1.95h1.95v1.95ZM520.07,5.38h-1.95v-1.95h1.95v1.95ZM517.15,5.38h-1.95v-1.95h1.95v1.95ZM514.23,5.38h-1.95v-1.95h1.95v1.95ZM511.31,5.38h-1.95v-1.95h1.95v1.95ZM508.39,5.38h-1.95v-1.95h1.95v1.95ZM505.47,5.38h-1.95v-1.95h1.95v1.95ZM502.55,5.38h-1.95v-1.95h1.95v1.95ZM499.63,5.38h-1.95v-1.95h1.95v1.95ZM496.71,5.38h-1.95v-1.95h1.95v1.95ZM493.79,5.38h-1.95v-1.95h1.95v1.95ZM490.87,5.38h-1.95v-1.95h1.95v1.95ZM487.95,5.38h-1.95v-1.95h1.95v1.95ZM485.03,5.38h-1.95v-1.95h1.95v1.95ZM482.11,5.38h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,2.46h-1.95V.51h1.95v1.95ZM546.35,2.46h-1.95V.51h1.95v1.95ZM543.43,2.46h-1.95V.51h1.95v1.95ZM540.51,2.46h-1.95V.51h1.95v1.95ZM537.59,2.46h-1.95V.51h1.95v1.95ZM534.67,2.46h-1.95V.51h1.95v1.95ZM531.75,2.46h-1.95V.51h1.95v1.95ZM528.83,2.46h-1.95V.51h1.95v1.95ZM525.91,2.46h-1.95V.51h1.95v1.95ZM522.99,2.46h-1.95V.51h1.95v1.95ZM520.07,2.46h-1.95V.51h1.95v1.95ZM517.15,2.46h-1.95V.51h1.95v1.95ZM514.23,2.46h-1.95V.51h1.95v1.95ZM511.31,2.46h-1.95V.51h1.95v1.95ZM508.39,2.46h-1.95V.51h1.95v1.95ZM505.47,2.46h-1.95V.51h1.95v1.95ZM502.55,2.46h-1.95V.51h1.95v1.95ZM499.63,2.46h-1.95V.51h1.95v1.95ZM496.71,2.46h-1.95V.51h1.95v1.95ZM493.79,2.46h-1.95V.51h1.95v1.95ZM490.87,2.46h-1.95V.51h1.95v1.95ZM487.95,2.46h-1.95V.51h1.95v1.95ZM485.03,2.46h-1.95V.51h1.95v1.95ZM482.11,2.46h-1.95V.51h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,55.02h-1.95v-1.95h1.95v1.95ZM476.27,55.02h-1.95v-1.95h1.95v1.95ZM473.35,55.02h-1.95v-1.95h1.95v1.95ZM470.43,55.02h-1.95v-1.95h1.95v1.95ZM467.51,55.02h-1.95v-1.95h1.95v1.95ZM464.59,55.02h-1.95v-1.95h1.95v1.95ZM461.67,55.02h-1.95v-1.95h1.95v1.95ZM458.75,55.02h-1.95v-1.95h1.95v1.95ZM455.82,55.02h-1.95v-1.95h1.95v1.95ZM452.9,55.02h-1.95v-1.95h1.95v1.95ZM449.98,55.02h-1.95v-1.95h1.95v1.95ZM447.06,55.02h-1.95v-1.95h1.95v1.95ZM444.14,55.02h-1.95v-1.95h1.95v1.95ZM441.22,55.02h-1.95v-1.95h1.95v1.95ZM438.3,55.02h-1.95v-1.95h1.95v1.95ZM435.38,55.02h-1.95v-1.95h1.95v1.95ZM432.46,55.02h-1.95v-1.95h1.95v1.95ZM429.54,55.02h-1.95v-1.95h1.95v1.95ZM426.62,55.02h-1.95v-1.95h1.95v1.95ZM423.7,55.02h-1.95v-1.95h1.95v1.95ZM420.78,55.02h-1.95v-1.95h1.95v1.95ZM417.86,55.02h-1.95v-1.95h1.95v1.95ZM414.94,55.02h-1.95v-1.95h1.95v1.95ZM412.02,55.02h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,52.1h-1.95v-1.95h1.95v1.95ZM476.27,52.1h-1.95v-1.95h1.95v1.95ZM473.35,52.1h-1.95v-1.95h1.95v1.95ZM470.43,52.1h-1.95v-1.95h1.95v1.95ZM467.51,52.1h-1.95v-1.95h1.95v1.95ZM464.59,52.1h-1.95v-1.95h1.95v1.95ZM461.67,52.1h-1.95v-1.95h1.95v1.95ZM458.75,52.1h-1.95v-1.95h1.95v1.95ZM455.82,52.1h-1.95v-1.95h1.95v1.95ZM452.9,52.1h-1.95v-1.95h1.95v1.95ZM449.98,52.1h-1.95v-1.95h1.95v1.95ZM447.06,52.1h-1.95v-1.95h1.95v1.95ZM444.14,52.1h-1.95v-1.95h1.95v1.95ZM441.22,52.1h-1.95v-1.95h1.95v1.95ZM438.3,52.1h-1.95v-1.95h1.95v1.95ZM435.38,52.1h-1.95v-1.95h1.95v1.95ZM432.46,52.1h-1.95v-1.95h1.95v1.95ZM429.54,52.1h-1.95v-1.95h1.95v1.95ZM426.62,52.1h-1.95v-1.95h1.95v1.95ZM423.7,52.1h-1.95v-1.95h1.95v1.95ZM420.78,52.1h-1.95v-1.95h1.95v1.95ZM417.86,52.1h-1.95v-1.95h1.95v1.95ZM414.94,52.1h-1.95v-1.95h1.95v1.95ZM412.02,52.1h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,49.18h-1.95v-1.95h1.95v1.95ZM476.27,49.18h-1.95v-1.95h1.95v1.95ZM473.35,49.18h-1.95v-1.95h1.95v1.95ZM470.43,49.18h-1.95v-1.95h1.95v1.95ZM467.51,49.18h-1.95v-1.95h1.95v1.95ZM464.59,49.18h-1.95v-1.95h1.95v1.95ZM461.67,49.18h-1.95v-1.95h1.95v1.95ZM458.75,49.18h-1.95v-1.95h1.95v1.95ZM455.82,49.18h-1.95v-1.95h1.95v1.95ZM452.9,49.18h-1.95v-1.95h1.95v1.95ZM449.98,49.18h-1.95v-1.95h1.95v1.95ZM447.06,49.18h-1.95v-1.95h1.95v1.95ZM444.14,49.18h-1.95v-1.95h1.95v1.95ZM441.22,49.18h-1.95v-1.95h1.95v1.95ZM438.3,49.18h-1.95v-1.95h1.95v1.95ZM435.38,49.18h-1.95v-1.95h1.95v1.95ZM432.46,49.18h-1.95v-1.95h1.95v1.95ZM429.54,49.18h-1.95v-1.95h1.95v1.95ZM426.62,49.18h-1.95v-1.95h1.95v1.95ZM423.7,49.18h-1.95v-1.95h1.95v1.95ZM420.78,49.18h-1.95v-1.95h1.95v1.95ZM417.86,49.18h-1.95v-1.95h1.95v1.95ZM414.94,49.18h-1.95v-1.95h1.95v1.95ZM412.02,49.18h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,46.26h-1.95v-1.95h1.95v1.95ZM476.27,46.26h-1.95v-1.95h1.95v1.95ZM473.35,46.26h-1.95v-1.95h1.95v1.95ZM470.43,46.26h-1.95v-1.95h1.95v1.95ZM467.51,46.26h-1.95v-1.95h1.95v1.95ZM464.59,46.26h-1.95v-1.95h1.95v1.95ZM461.67,46.26h-1.95v-1.95h1.95v1.95ZM458.75,46.26h-1.95v-1.95h1.95v1.95ZM455.82,46.26h-1.95v-1.95h1.95v1.95ZM452.9,46.26h-1.95v-1.95h1.95v1.95ZM449.98,46.26h-1.95v-1.95h1.95v1.95ZM447.06,46.26h-1.95v-1.95h1.95v1.95ZM444.14,46.26h-1.95v-1.95h1.95v1.95ZM441.22,46.26h-1.95v-1.95h1.95v1.95ZM438.3,46.26h-1.95v-1.95h1.95v1.95ZM435.38,46.26h-1.95v-1.95h1.95v1.95ZM432.46,46.26h-1.95v-1.95h1.95v1.95ZM429.54,46.26h-1.95v-1.95h1.95v1.95ZM426.62,46.26h-1.95v-1.95h1.95v1.95ZM423.7,46.26h-1.95v-1.95h1.95v1.95ZM420.78,46.26h-1.95v-1.95h1.95v1.95ZM417.86,46.26h-1.95v-1.95h1.95v1.95ZM414.94,46.26h-1.95v-1.95h1.95v1.95ZM412.02,46.26h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,43.34h-1.95v-1.95h1.95v1.95ZM476.27,43.34h-1.95v-1.95h1.95v1.95ZM473.35,43.34h-1.95v-1.95h1.95v1.95ZM470.43,43.34h-1.95v-1.95h1.95v1.95ZM467.51,43.34h-1.95v-1.95h1.95v1.95ZM464.59,43.34h-1.95v-1.95h1.95v1.95ZM461.67,43.34h-1.95v-1.95h1.95v1.95ZM458.75,43.34h-1.95v-1.95h1.95v1.95ZM455.82,43.34h-1.95v-1.95h1.95v1.95ZM452.9,43.34h-1.95v-1.95h1.95v1.95ZM449.98,43.34h-1.95v-1.95h1.95v1.95ZM447.06,43.34h-1.95v-1.95h1.95v1.95ZM444.14,43.34h-1.95v-1.95h1.95v1.95ZM441.22,43.34h-1.95v-1.95h1.95v1.95ZM438.3,43.34h-1.95v-1.95h1.95v1.95ZM435.38,43.34h-1.95v-1.95h1.95v1.95ZM432.46,43.34h-1.95v-1.95h1.95v1.95ZM429.54,43.34h-1.95v-1.95h1.95v1.95ZM426.62,43.34h-1.95v-1.95h1.95v1.95ZM423.7,43.34h-1.95v-1.95h1.95v1.95ZM420.78,43.34h-1.95v-1.95h1.95v1.95ZM417.86,43.34h-1.95v-1.95h1.95v1.95ZM414.94,43.34h-1.95v-1.95h1.95v1.95ZM412.02,43.34h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,40.42h-1.95v-1.95h1.95v1.95ZM476.27,40.42h-1.95v-1.95h1.95v1.95ZM473.35,40.42h-1.95v-1.95h1.95v1.95ZM470.43,40.42h-1.95v-1.95h1.95v1.95ZM467.51,40.42h-1.95v-1.95h1.95v1.95ZM464.59,40.42h-1.95v-1.95h1.95v1.95ZM461.67,40.42h-1.95v-1.95h1.95v1.95ZM458.75,40.42h-1.95v-1.95h1.95v1.95ZM455.82,40.42h-1.95v-1.95h1.95v1.95ZM452.9,40.42h-1.95v-1.95h1.95v1.95ZM449.98,40.42h-1.95v-1.95h1.95v1.95ZM447.06,40.42h-1.95v-1.95h1.95v1.95ZM444.14,40.42h-1.95v-1.95h1.95v1.95ZM441.22,40.42h-1.95v-1.95h1.95v1.95ZM438.3,40.42h-1.95v-1.95h1.95v1.95ZM435.38,40.42h-1.95v-1.95h1.95v1.95ZM432.46,40.42h-1.95v-1.95h1.95v1.95ZM429.54,40.42h-1.95v-1.95h1.95v1.95ZM426.62,40.42h-1.95v-1.95h1.95v1.95ZM423.7,40.42h-1.95v-1.95h1.95v1.95ZM420.78,40.42h-1.95v-1.95h1.95v1.95ZM417.86,40.42h-1.95v-1.95h1.95v1.95ZM414.94,40.42h-1.95v-1.95h1.95v1.95ZM412.02,40.42h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,37.5h-1.95v-1.95h1.95v1.95ZM476.27,37.5h-1.95v-1.95h1.95v1.95ZM473.35,37.5h-1.95v-1.95h1.95v1.95ZM470.43,37.5h-1.95v-1.95h1.95v1.95ZM467.51,37.5h-1.95v-1.95h1.95v1.95ZM464.59,37.5h-1.95v-1.95h1.95v1.95ZM461.67,37.5h-1.95v-1.95h1.95v1.95ZM458.75,37.5h-1.95v-1.95h1.95v1.95ZM455.82,37.5h-1.95v-1.95h1.95v1.95ZM452.9,37.5h-1.95v-1.95h1.95v1.95ZM449.98,37.5h-1.95v-1.95h1.95v1.95ZM447.06,37.5h-1.95v-1.95h1.95v1.95ZM444.14,37.5h-1.95v-1.95h1.95v1.95ZM441.22,37.5h-1.95v-1.95h1.95v1.95ZM438.3,37.5h-1.95v-1.95h1.95v1.95ZM435.38,37.5h-1.95v-1.95h1.95v1.95ZM432.46,37.5h-1.95v-1.95h1.95v1.95ZM429.54,37.5h-1.95v-1.95h1.95v1.95ZM426.62,37.5h-1.95v-1.95h1.95v1.95ZM423.7,37.5h-1.95v-1.95h1.95v1.95ZM420.78,37.5h-1.95v-1.95h1.95v1.95ZM417.86,37.5h-1.95v-1.95h1.95v1.95ZM414.94,37.5h-1.95v-1.95h1.95v1.95ZM412.02,37.5h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,34.58h-1.95v-1.95h1.95v1.95ZM476.27,34.58h-1.95v-1.95h1.95v1.95ZM473.35,34.58h-1.95v-1.95h1.95v1.95ZM470.43,34.58h-1.95v-1.95h1.95v1.95ZM467.51,34.58h-1.95v-1.95h1.95v1.95ZM464.59,34.58h-1.95v-1.95h1.95v1.95ZM461.67,34.58h-1.95v-1.95h1.95v1.95ZM458.75,34.58h-1.95v-1.95h1.95v1.95ZM455.82,34.58h-1.95v-1.95h1.95v1.95ZM452.9,34.58h-1.95v-1.95h1.95v1.95ZM449.98,34.58h-1.95v-1.95h1.95v1.95ZM447.06,34.58h-1.95v-1.95h1.95v1.95ZM444.14,34.58h-1.95v-1.95h1.95v1.95ZM441.22,34.58h-1.95v-1.95h1.95v1.95ZM438.3,34.58h-1.95v-1.95h1.95v1.95ZM435.38,34.58h-1.95v-1.95h1.95v1.95ZM432.46,34.58h-1.95v-1.95h1.95v1.95ZM429.54,34.58h-1.95v-1.95h1.95v1.95ZM426.62,34.58h-1.95v-1.95h1.95v1.95ZM423.7,34.58h-1.95v-1.95h1.95v1.95ZM420.78,34.58h-1.95v-1.95h1.95v1.95ZM417.86,34.58h-1.95v-1.95h1.95v1.95ZM414.94,34.58h-1.95v-1.95h1.95v1.95ZM412.02,34.58h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,31.66h-1.95v-1.95h1.95v1.95ZM476.27,31.66h-1.95v-1.95h1.95v1.95ZM473.35,31.66h-1.95v-1.95h1.95v1.95ZM470.43,31.66h-1.95v-1.95h1.95v1.95ZM467.51,31.66h-1.95v-1.95h1.95v1.95ZM464.59,31.66h-1.95v-1.95h1.95v1.95ZM461.67,31.66h-1.95v-1.95h1.95v1.95ZM458.75,31.66h-1.95v-1.95h1.95v1.95ZM455.82,31.66h-1.95v-1.95h1.95v1.95ZM452.9,31.66h-1.95v-1.95h1.95v1.95ZM449.98,31.66h-1.95v-1.95h1.95v1.95ZM447.06,31.66h-1.95v-1.95h1.95v1.95ZM444.14,31.66h-1.95v-1.95h1.95v1.95ZM441.22,31.66h-1.95v-1.95h1.95v1.95ZM438.3,31.66h-1.95v-1.95h1.95v1.95ZM435.38,31.66h-1.95v-1.95h1.95v1.95ZM432.46,31.66h-1.95v-1.95h1.95v1.95ZM429.54,31.66h-1.95v-1.95h1.95v1.95ZM426.62,31.66h-1.95v-1.95h1.95v1.95ZM423.7,31.66h-1.95v-1.95h1.95v1.95ZM420.78,31.66h-1.95v-1.95h1.95v1.95ZM417.86,31.66h-1.95v-1.95h1.95v1.95ZM414.94,31.66h-1.95v-1.95h1.95v1.95ZM412.02,31.66h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,28.74h-1.95v-1.95h1.95v1.95ZM476.27,28.74h-1.95v-1.95h1.95v1.95ZM473.35,28.74h-1.95v-1.95h1.95v1.95ZM470.43,28.74h-1.95v-1.95h1.95v1.95ZM467.51,28.74h-1.95v-1.95h1.95v1.95ZM464.59,28.74h-1.95v-1.95h1.95v1.95ZM461.67,28.74h-1.95v-1.95h1.95v1.95ZM458.75,28.74h-1.95v-1.95h1.95v1.95ZM455.82,28.74h-1.95v-1.95h1.95v1.95ZM452.9,28.74h-1.95v-1.95h1.95v1.95ZM449.98,28.74h-1.95v-1.95h1.95v1.95ZM447.06,28.74h-1.95v-1.95h1.95v1.95ZM444.14,28.74h-1.95v-1.95h1.95v1.95ZM441.22,28.74h-1.95v-1.95h1.95v1.95ZM438.3,28.74h-1.95v-1.95h1.95v1.95ZM435.38,28.74h-1.95v-1.95h1.95v1.95ZM432.46,28.74h-1.95v-1.95h1.95v1.95ZM429.54,28.74h-1.95v-1.95h1.95v1.95ZM426.62,28.74h-1.95v-1.95h1.95v1.95ZM423.7,28.74h-1.95v-1.95h1.95v1.95ZM420.78,28.74h-1.95v-1.95h1.95v1.95ZM417.86,28.74h-1.95v-1.95h1.95v1.95ZM414.94,28.74h-1.95v-1.95h1.95v1.95ZM412.02,28.74h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,25.82h-1.95v-1.95h1.95v1.95ZM476.27,25.82h-1.95v-1.95h1.95v1.95ZM473.35,25.82h-1.95v-1.95h1.95v1.95ZM470.43,25.82h-1.95v-1.95h1.95v1.95ZM467.51,25.82h-1.95v-1.95h1.95v1.95ZM464.59,25.82h-1.95v-1.95h1.95v1.95ZM461.67,25.82h-1.95v-1.95h1.95v1.95ZM458.75,25.82h-1.95v-1.95h1.95v1.95ZM455.82,25.82h-1.95v-1.95h1.95v1.95ZM452.9,25.82h-1.95v-1.95h1.95v1.95ZM449.98,25.82h-1.95v-1.95h1.95v1.95ZM447.06,25.82h-1.95v-1.95h1.95v1.95ZM444.14,25.82h-1.95v-1.95h1.95v1.95ZM441.22,25.82h-1.95v-1.95h1.95v1.95ZM438.3,25.82h-1.95v-1.95h1.95v1.95ZM435.38,25.82h-1.95v-1.95h1.95v1.95ZM432.46,25.82h-1.95v-1.95h1.95v1.95ZM429.54,25.82h-1.95v-1.95h1.95v1.95ZM426.62,25.82h-1.95v-1.95h1.95v1.95ZM423.7,25.82h-1.95v-1.95h1.95v1.95ZM420.78,25.82h-1.95v-1.95h1.95v1.95ZM417.86,25.82h-1.95v-1.95h1.95v1.95ZM414.94,25.82h-1.95v-1.95h1.95v1.95ZM412.02,25.82h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,22.9h-1.95v-1.95h1.95v1.95ZM476.27,22.9h-1.95v-1.95h1.95v1.95ZM473.35,22.9h-1.95v-1.95h1.95v1.95ZM470.43,22.9h-1.95v-1.95h1.95v1.95ZM467.51,22.9h-1.95v-1.95h1.95v1.95ZM464.59,22.9h-1.95v-1.95h1.95v1.95ZM461.67,22.9h-1.95v-1.95h1.95v1.95ZM458.75,22.9h-1.95v-1.95h1.95v1.95ZM455.82,22.9h-1.95v-1.95h1.95v1.95ZM452.9,22.9h-1.95v-1.95h1.95v1.95ZM449.98,22.9h-1.95v-1.95h1.95v1.95ZM447.06,22.9h-1.95v-1.95h1.95v1.95ZM444.14,22.9h-1.95v-1.95h1.95v1.95ZM441.22,22.9h-1.95v-1.95h1.95v1.95ZM438.3,22.9h-1.95v-1.95h1.95v1.95ZM435.38,22.9h-1.95v-1.95h1.95v1.95ZM432.46,22.9h-1.95v-1.95h1.95v1.95ZM429.54,22.9h-1.95v-1.95h1.95v1.95ZM426.62,22.9h-1.95v-1.95h1.95v1.95ZM423.7,22.9h-1.95v-1.95h1.95v1.95ZM420.78,22.9h-1.95v-1.95h1.95v1.95ZM417.86,22.9h-1.95v-1.95h1.95v1.95ZM414.94,22.9h-1.95v-1.95h1.95v1.95ZM412.02,22.9h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,19.98h-1.95v-1.95h1.95v1.95ZM476.27,19.98h-1.95v-1.95h1.95v1.95ZM473.35,19.98h-1.95v-1.95h1.95v1.95ZM470.43,19.98h-1.95v-1.95h1.95v1.95ZM467.51,19.98h-1.95v-1.95h1.95v1.95ZM464.59,19.98h-1.95v-1.95h1.95v1.95ZM461.67,19.98h-1.95v-1.95h1.95v1.95ZM458.75,19.98h-1.95v-1.95h1.95v1.95ZM455.82,19.98h-1.95v-1.95h1.95v1.95ZM452.9,19.98h-1.95v-1.95h1.95v1.95ZM449.98,19.98h-1.95v-1.95h1.95v1.95ZM447.06,19.98h-1.95v-1.95h1.95v1.95ZM444.14,19.98h-1.95v-1.95h1.95v1.95ZM441.22,19.98h-1.95v-1.95h1.95v1.95ZM438.3,19.98h-1.95v-1.95h1.95v1.95ZM435.38,19.98h-1.95v-1.95h1.95v1.95ZM432.46,19.98h-1.95v-1.95h1.95v1.95ZM429.54,19.98h-1.95v-1.95h1.95v1.95ZM426.62,19.98h-1.95v-1.95h1.95v1.95ZM423.7,19.98h-1.95v-1.95h1.95v1.95ZM420.78,19.98h-1.95v-1.95h1.95v1.95ZM417.86,19.98h-1.95v-1.95h1.95v1.95ZM414.94,19.98h-1.95v-1.95h1.95v1.95ZM412.02,19.98h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,17.06h-1.95v-1.95h1.95v1.95ZM476.27,17.06h-1.95v-1.95h1.95v1.95ZM473.35,17.06h-1.95v-1.95h1.95v1.95ZM470.43,17.06h-1.95v-1.95h1.95v1.95ZM467.51,17.06h-1.95v-1.95h1.95v1.95ZM464.59,17.06h-1.95v-1.95h1.95v1.95ZM461.67,17.06h-1.95v-1.95h1.95v1.95ZM458.75,17.06h-1.95v-1.95h1.95v1.95ZM455.82,17.06h-1.95v-1.95h1.95v1.95ZM452.9,17.06h-1.95v-1.95h1.95v1.95ZM449.98,17.06h-1.95v-1.95h1.95v1.95ZM447.06,17.06h-1.95v-1.95h1.95v1.95ZM444.14,17.06h-1.95v-1.95h1.95v1.95ZM441.22,17.06h-1.95v-1.95h1.95v1.95ZM438.3,17.06h-1.95v-1.95h1.95v1.95ZM435.38,17.06h-1.95v-1.95h1.95v1.95ZM432.46,17.06h-1.95v-1.95h1.95v1.95ZM429.54,17.06h-1.95v-1.95h1.95v1.95ZM426.62,17.06h-1.95v-1.95h1.95v1.95ZM423.7,17.06h-1.95v-1.95h1.95v1.95ZM420.78,17.06h-1.95v-1.95h1.95v1.95ZM417.86,17.06h-1.95v-1.95h1.95v1.95ZM414.94,17.06h-1.95v-1.95h1.95v1.95ZM412.02,17.06h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,14.14h-1.95v-1.95h1.95v1.95ZM476.27,14.14h-1.95v-1.95h1.95v1.95ZM473.35,14.14h-1.95v-1.95h1.95v1.95ZM470.43,14.14h-1.95v-1.95h1.95v1.95ZM467.51,14.14h-1.95v-1.95h1.95v1.95ZM464.59,14.14h-1.95v-1.95h1.95v1.95ZM461.67,14.14h-1.95v-1.95h1.95v1.95ZM458.75,14.14h-1.95v-1.95h1.95v1.95ZM455.82,14.14h-1.95v-1.95h1.95v1.95ZM452.9,14.14h-1.95v-1.95h1.95v1.95ZM449.98,14.14h-1.95v-1.95h1.95v1.95ZM447.06,14.14h-1.95v-1.95h1.95v1.95ZM444.14,14.14h-1.95v-1.95h1.95v1.95ZM441.22,14.14h-1.95v-1.95h1.95v1.95ZM438.3,14.14h-1.95v-1.95h1.95v1.95ZM435.38,14.14h-1.95v-1.95h1.95v1.95ZM432.46,14.14h-1.95v-1.95h1.95v1.95ZM429.54,14.14h-1.95v-1.95h1.95v1.95ZM426.62,14.14h-1.95v-1.95h1.95v1.95ZM423.7,14.14h-1.95v-1.95h1.95v1.95ZM420.78,14.14h-1.95v-1.95h1.95v1.95ZM417.86,14.14h-1.95v-1.95h1.95v1.95ZM414.94,14.14h-1.95v-1.95h1.95v1.95ZM412.02,14.14h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,11.22h-1.95v-1.95h1.95v1.95ZM476.27,11.22h-1.95v-1.95h1.95v1.95ZM473.35,11.22h-1.95v-1.95h1.95v1.95ZM470.43,11.22h-1.95v-1.95h1.95v1.95ZM467.51,11.22h-1.95v-1.95h1.95v1.95ZM464.59,11.22h-1.95v-1.95h1.95v1.95ZM461.67,11.22h-1.95v-1.95h1.95v1.95ZM458.75,11.22h-1.95v-1.95h1.95v1.95ZM455.82,11.22h-1.95v-1.95h1.95v1.95ZM452.9,11.22h-1.95v-1.95h1.95v1.95ZM449.98,11.22h-1.95v-1.95h1.95v1.95ZM447.06,11.22h-1.95v-1.95h1.95v1.95ZM444.14,11.22h-1.95v-1.95h1.95v1.95ZM441.22,11.22h-1.95v-1.95h1.95v1.95ZM438.3,11.22h-1.95v-1.95h1.95v1.95ZM435.38,11.22h-1.95v-1.95h1.95v1.95ZM432.46,11.22h-1.95v-1.95h1.95v1.95ZM429.54,11.22h-1.95v-1.95h1.95v1.95ZM426.62,11.22h-1.95v-1.95h1.95v1.95ZM423.7,11.22h-1.95v-1.95h1.95v1.95ZM420.78,11.22h-1.95v-1.95h1.95v1.95ZM417.86,11.22h-1.95v-1.95h1.95v1.95ZM414.94,11.22h-1.95v-1.95h1.95v1.95ZM412.02,11.22h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,8.3h-1.95v-1.95h1.95v1.95ZM476.27,8.3h-1.95v-1.95h1.95v1.95ZM473.35,8.3h-1.95v-1.95h1.95v1.95ZM470.43,8.3h-1.95v-1.95h1.95v1.95ZM467.51,8.3h-1.95v-1.95h1.95v1.95ZM464.59,8.3h-1.95v-1.95h1.95v1.95ZM461.67,8.3h-1.95v-1.95h1.95v1.95ZM458.75,8.3h-1.95v-1.95h1.95v1.95ZM455.82,8.3h-1.95v-1.95h1.95v1.95ZM452.9,8.3h-1.95v-1.95h1.95v1.95ZM449.98,8.3h-1.95v-1.95h1.95v1.95ZM447.06,8.3h-1.95v-1.95h1.95v1.95ZM444.14,8.3h-1.95v-1.95h1.95v1.95ZM441.22,8.3h-1.95v-1.95h1.95v1.95ZM438.3,8.3h-1.95v-1.95h1.95v1.95ZM435.38,8.3h-1.95v-1.95h1.95v1.95ZM432.46,8.3h-1.95v-1.95h1.95v1.95ZM429.54,8.3h-1.95v-1.95h1.95v1.95ZM426.62,8.3h-1.95v-1.95h1.95v1.95ZM423.7,8.3h-1.95v-1.95h1.95v1.95ZM420.78,8.3h-1.95v-1.95h1.95v1.95ZM417.86,8.3h-1.95v-1.95h1.95v1.95ZM414.94,8.3h-1.95v-1.95h1.95v1.95ZM412.02,8.3h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,5.38h-1.95v-1.95h1.95v1.95ZM476.27,5.38h-1.95v-1.95h1.95v1.95ZM473.35,5.38h-1.95v-1.95h1.95v1.95ZM470.43,5.38h-1.95v-1.95h1.95v1.95ZM467.51,5.38h-1.95v-1.95h1.95v1.95ZM464.59,5.38h-1.95v-1.95h1.95v1.95ZM461.67,5.38h-1.95v-1.95h1.95v1.95ZM458.75,5.38h-1.95v-1.95h1.95v1.95ZM455.82,5.38h-1.95v-1.95h1.95v1.95ZM452.9,5.38h-1.95v-1.95h1.95v1.95ZM449.98,5.38h-1.95v-1.95h1.95v1.95ZM447.06,5.38h-1.95v-1.95h1.95v1.95ZM444.14,5.38h-1.95v-1.95h1.95v1.95ZM441.22,5.38h-1.95v-1.95h1.95v1.95ZM438.3,5.38h-1.95v-1.95h1.95v1.95ZM435.38,5.38h-1.95v-1.95h1.95v1.95ZM432.46,5.38h-1.95v-1.95h1.95v1.95ZM429.54,5.38h-1.95v-1.95h1.95v1.95ZM426.62,5.38h-1.95v-1.95h1.95v1.95ZM423.7,5.38h-1.95v-1.95h1.95v1.95ZM420.78,5.38h-1.95v-1.95h1.95v1.95ZM417.86,5.38h-1.95v-1.95h1.95v1.95ZM414.94,5.38h-1.95v-1.95h1.95v1.95ZM412.02,5.38h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,2.46h-1.95V.51h1.95v1.95ZM476.27,2.46h-1.95V.51h1.95v1.95ZM473.35,2.46h-1.95V.51h1.95v1.95ZM470.43,2.46h-1.95V.51h1.95v1.95ZM467.51,2.46h-1.95V.51h1.95v1.95ZM464.59,2.46h-1.95V.51h1.95v1.95ZM461.67,2.46h-1.95V.51h1.95v1.95ZM458.75,2.46h-1.95V.51h1.95v1.95ZM455.82,2.46h-1.95V.51h1.95v1.95ZM452.9,2.46h-1.95V.51h1.95v1.95ZM449.98,2.46h-1.95V.51h1.95v1.95ZM447.06,2.46h-1.95V.51h1.95v1.95ZM444.14,2.46h-1.95V.51h1.95v1.95ZM441.22,2.46h-1.95V.51h1.95v1.95ZM438.3,2.46h-1.95V.51h1.95v1.95ZM435.38,2.46h-1.95V.51h1.95v1.95ZM432.46,2.46h-1.95V.51h1.95v1.95ZM429.54,2.46h-1.95V.51h1.95v1.95ZM426.62,2.46h-1.95V.51h1.95v1.95ZM423.7,2.46h-1.95V.51h1.95v1.95ZM420.78,2.46h-1.95V.51h1.95v1.95ZM417.86,2.46h-1.95V.51h1.95v1.95ZM414.94,2.46h-1.95V.51h1.95v1.95ZM412.02,2.46h-1.95V.51h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-12)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.28,125.11h-1.95v-1.95h1.95v1.95ZM546.35,125.11h-1.95v-1.95h1.95v1.95ZM543.43,125.11h-1.95v-1.95h1.95v1.95ZM540.51,125.11h-1.95v-1.95h1.95v1.95ZM537.59,125.11h-1.95v-1.95h1.95v1.95ZM534.67,125.11h-1.95v-1.95h1.95v1.95ZM531.75,125.11h-1.95v-1.95h1.95v1.95ZM528.83,125.11h-1.95v-1.95h1.95v1.95ZM525.91,125.11h-1.95v-1.95h1.95v1.95ZM522.99,125.11h-1.95v-1.95h1.95v1.95ZM520.07,125.11h-1.95v-1.95h1.95v1.95ZM517.15,125.11h-1.95v-1.95h1.95v1.95ZM514.23,125.11h-1.95v-1.95h1.95v1.95ZM511.31,125.11h-1.95v-1.95h1.95v1.95ZM508.39,125.11h-1.95v-1.95h1.95v1.95ZM505.47,125.11h-1.95v-1.95h1.95v1.95ZM502.55,125.11h-1.95v-1.95h1.95v1.95ZM499.63,125.11h-1.95v-1.95h1.95v1.95ZM496.71,125.11h-1.95v-1.95h1.95v1.95ZM493.79,125.11h-1.95v-1.95h1.95v1.95ZM490.87,125.11h-1.95v-1.95h1.95v1.95ZM487.95,125.11h-1.95v-1.95h1.95v1.95ZM485.03,125.11h-1.95v-1.95h1.95v1.95ZM482.11,125.11h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,122.19h-1.95v-1.95h1.95v1.95ZM546.35,122.19h-1.95v-1.95h1.95v1.95ZM543.43,122.19h-1.95v-1.95h1.95v1.95ZM540.51,122.19h-1.95v-1.95h1.95v1.95ZM537.59,122.19h-1.95v-1.95h1.95v1.95ZM534.67,122.19h-1.95v-1.95h1.95v1.95ZM531.75,122.19h-1.95v-1.95h1.95v1.95ZM528.83,122.19h-1.95v-1.95h1.95v1.95ZM525.91,122.19h-1.95v-1.95h1.95v1.95ZM522.99,122.19h-1.95v-1.95h1.95v1.95ZM520.07,122.19h-1.95v-1.95h1.95v1.95ZM517.15,122.19h-1.95v-1.95h1.95v1.95ZM514.23,122.19h-1.95v-1.95h1.95v1.95ZM511.31,122.19h-1.95v-1.95h1.95v1.95ZM508.39,122.19h-1.95v-1.95h1.95v1.95ZM505.47,122.19h-1.95v-1.95h1.95v1.95ZM502.55,122.19h-1.95v-1.95h1.95v1.95ZM499.63,122.19h-1.95v-1.95h1.95v1.95ZM496.71,122.19h-1.95v-1.95h1.95v1.95ZM493.79,122.19h-1.95v-1.95h1.95v1.95ZM490.87,122.19h-1.95v-1.95h1.95v1.95ZM487.95,122.19h-1.95v-1.95h1.95v1.95ZM485.03,122.19h-1.95v-1.95h1.95v1.95ZM482.11,122.19h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,119.27h-1.95v-1.95h1.95v1.95ZM546.35,119.27h-1.95v-1.95h1.95v1.95ZM543.43,119.27h-1.95v-1.95h1.95v1.95ZM540.51,119.27h-1.95v-1.95h1.95v1.95ZM537.59,119.27h-1.95v-1.95h1.95v1.95ZM534.67,119.27h-1.95v-1.95h1.95v1.95ZM531.75,119.27h-1.95v-1.95h1.95v1.95ZM528.83,119.27h-1.95v-1.95h1.95v1.95ZM525.91,119.27h-1.95v-1.95h1.95v1.95ZM522.99,119.27h-1.95v-1.95h1.95v1.95ZM520.07,119.27h-1.95v-1.95h1.95v1.95ZM517.15,119.27h-1.95v-1.95h1.95v1.95ZM514.23,119.27h-1.95v-1.95h1.95v1.95ZM511.31,119.27h-1.95v-1.95h1.95v1.95ZM508.39,119.27h-1.95v-1.95h1.95v1.95ZM505.47,119.27h-1.95v-1.95h1.95v1.95ZM502.55,119.27h-1.95v-1.95h1.95v1.95ZM499.63,119.27h-1.95v-1.95h1.95v1.95ZM496.71,119.27h-1.95v-1.95h1.95v1.95ZM493.79,119.27h-1.95v-1.95h1.95v1.95ZM490.87,119.27h-1.95v-1.95h1.95v1.95ZM487.95,119.27h-1.95v-1.95h1.95v1.95ZM485.03,119.27h-1.95v-1.95h1.95v1.95ZM482.11,119.27h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,116.35h-1.95v-1.95h1.95v1.95ZM546.35,116.35h-1.95v-1.95h1.95v1.95ZM543.43,116.35h-1.95v-1.95h1.95v1.95ZM540.51,116.35h-1.95v-1.95h1.95v1.95ZM537.59,116.35h-1.95v-1.95h1.95v1.95ZM534.67,116.35h-1.95v-1.95h1.95v1.95ZM531.75,116.35h-1.95v-1.95h1.95v1.95ZM528.83,116.35h-1.95v-1.95h1.95v1.95ZM525.91,116.35h-1.95v-1.95h1.95v1.95ZM522.99,116.35h-1.95v-1.95h1.95v1.95ZM520.07,116.35h-1.95v-1.95h1.95v1.95ZM517.15,116.35h-1.95v-1.95h1.95v1.95ZM514.23,116.35h-1.95v-1.95h1.95v1.95ZM511.31,116.35h-1.95v-1.95h1.95v1.95ZM508.39,116.35h-1.95v-1.95h1.95v1.95ZM505.47,116.35h-1.95v-1.95h1.95v1.95ZM502.55,116.35h-1.95v-1.95h1.95v1.95ZM499.63,116.35h-1.95v-1.95h1.95v1.95ZM496.71,116.35h-1.95v-1.95h1.95v1.95ZM493.79,116.35h-1.95v-1.95h1.95v1.95ZM490.87,116.35h-1.95v-1.95h1.95v1.95ZM487.95,116.35h-1.95v-1.95h1.95v1.95ZM485.03,116.35h-1.95v-1.95h1.95v1.95ZM482.11,116.35h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,113.43h-1.95v-1.95h1.95v1.95ZM546.35,113.43h-1.95v-1.95h1.95v1.95ZM543.43,113.43h-1.95v-1.95h1.95v1.95ZM540.51,113.43h-1.95v-1.95h1.95v1.95ZM537.59,113.43h-1.95v-1.95h1.95v1.95ZM534.67,113.43h-1.95v-1.95h1.95v1.95ZM531.75,113.43h-1.95v-1.95h1.95v1.95ZM528.83,113.43h-1.95v-1.95h1.95v1.95ZM525.91,113.43h-1.95v-1.95h1.95v1.95ZM522.99,113.43h-1.95v-1.95h1.95v1.95ZM520.07,113.43h-1.95v-1.95h1.95v1.95ZM517.15,113.43h-1.95v-1.95h1.95v1.95ZM514.23,113.43h-1.95v-1.95h1.95v1.95ZM511.31,113.43h-1.95v-1.95h1.95v1.95ZM508.39,113.43h-1.95v-1.95h1.95v1.95ZM505.47,113.43h-1.95v-1.95h1.95v1.95ZM502.55,113.43h-1.95v-1.95h1.95v1.95ZM499.63,113.43h-1.95v-1.95h1.95v1.95ZM496.71,113.43h-1.95v-1.95h1.95v1.95ZM493.79,113.43h-1.95v-1.95h1.95v1.95ZM490.87,113.43h-1.95v-1.95h1.95v1.95ZM487.95,113.43h-1.95v-1.95h1.95v1.95ZM485.03,113.43h-1.95v-1.95h1.95v1.95ZM482.11,113.43h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,110.51h-1.95v-1.95h1.95v1.95ZM546.35,110.51h-1.95v-1.95h1.95v1.95ZM543.43,110.51h-1.95v-1.95h1.95v1.95ZM540.51,110.51h-1.95v-1.95h1.95v1.95ZM537.59,110.51h-1.95v-1.95h1.95v1.95ZM534.67,110.51h-1.95v-1.95h1.95v1.95ZM531.75,110.51h-1.95v-1.95h1.95v1.95ZM528.83,110.51h-1.95v-1.95h1.95v1.95ZM525.91,110.51h-1.95v-1.95h1.95v1.95ZM522.99,110.51h-1.95v-1.95h1.95v1.95ZM520.07,110.51h-1.95v-1.95h1.95v1.95ZM517.15,110.51h-1.95v-1.95h1.95v1.95ZM514.23,110.51h-1.95v-1.95h1.95v1.95ZM511.31,110.51h-1.95v-1.95h1.95v1.95ZM508.39,110.51h-1.95v-1.95h1.95v1.95ZM505.47,110.51h-1.95v-1.95h1.95v1.95ZM502.55,110.51h-1.95v-1.95h1.95v1.95ZM499.63,110.51h-1.95v-1.95h1.95v1.95ZM496.71,110.51h-1.95v-1.95h1.95v1.95ZM493.79,110.51h-1.95v-1.95h1.95v1.95ZM490.87,110.51h-1.95v-1.95h1.95v1.95ZM487.95,110.51h-1.95v-1.95h1.95v1.95ZM485.03,110.51h-1.95v-1.95h1.95v1.95ZM482.11,110.51h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,107.59h-1.95v-1.95h1.95v1.95ZM546.35,107.59h-1.95v-1.95h1.95v1.95ZM543.43,107.59h-1.95v-1.95h1.95v1.95ZM540.51,107.59h-1.95v-1.95h1.95v1.95ZM537.59,107.59h-1.95v-1.95h1.95v1.95ZM534.67,107.59h-1.95v-1.95h1.95v1.95ZM531.75,107.59h-1.95v-1.95h1.95v1.95ZM528.83,107.59h-1.95v-1.95h1.95v1.95ZM525.91,107.59h-1.95v-1.95h1.95v1.95ZM522.99,107.59h-1.95v-1.95h1.95v1.95ZM520.07,107.59h-1.95v-1.95h1.95v1.95ZM517.15,107.59h-1.95v-1.95h1.95v1.95ZM514.23,107.59h-1.95v-1.95h1.95v1.95ZM511.31,107.59h-1.95v-1.95h1.95v1.95ZM508.39,107.59h-1.95v-1.95h1.95v1.95ZM505.47,107.59h-1.95v-1.95h1.95v1.95ZM502.55,107.59h-1.95v-1.95h1.95v1.95ZM499.63,107.59h-1.95v-1.95h1.95v1.95ZM496.71,107.59h-1.95v-1.95h1.95v1.95ZM493.79,107.59h-1.95v-1.95h1.95v1.95ZM490.87,107.59h-1.95v-1.95h1.95v1.95ZM487.95,107.59h-1.95v-1.95h1.95v1.95ZM485.03,107.59h-1.95v-1.95h1.95v1.95ZM482.11,107.59h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,104.67h-1.95v-1.95h1.95v1.95ZM546.35,104.67h-1.95v-1.95h1.95v1.95ZM543.43,104.67h-1.95v-1.95h1.95v1.95ZM540.51,104.67h-1.95v-1.95h1.95v1.95ZM537.59,104.67h-1.95v-1.95h1.95v1.95ZM534.67,104.67h-1.95v-1.95h1.95v1.95ZM531.75,104.67h-1.95v-1.95h1.95v1.95ZM528.83,104.67h-1.95v-1.95h1.95v1.95ZM525.91,104.67h-1.95v-1.95h1.95v1.95ZM522.99,104.67h-1.95v-1.95h1.95v1.95ZM520.07,104.67h-1.95v-1.95h1.95v1.95ZM517.15,104.67h-1.95v-1.95h1.95v1.95ZM514.23,104.67h-1.95v-1.95h1.95v1.95ZM511.31,104.67h-1.95v-1.95h1.95v1.95ZM508.39,104.67h-1.95v-1.95h1.95v1.95ZM505.47,104.67h-1.95v-1.95h1.95v1.95ZM502.55,104.67h-1.95v-1.95h1.95v1.95ZM499.63,104.67h-1.95v-1.95h1.95v1.95ZM496.71,104.67h-1.95v-1.95h1.95v1.95ZM493.79,104.67h-1.95v-1.95h1.95v1.95ZM490.87,104.67h-1.95v-1.95h1.95v1.95ZM487.95,104.67h-1.95v-1.95h1.95v1.95ZM485.03,104.67h-1.95v-1.95h1.95v1.95ZM482.11,104.67h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,101.75h-1.95v-1.95h1.95v1.95ZM546.35,101.75h-1.95v-1.95h1.95v1.95ZM543.43,101.75h-1.95v-1.95h1.95v1.95ZM540.51,101.75h-1.95v-1.95h1.95v1.95ZM537.59,101.75h-1.95v-1.95h1.95v1.95ZM534.67,101.75h-1.95v-1.95h1.95v1.95ZM531.75,101.75h-1.95v-1.95h1.95v1.95ZM528.83,101.75h-1.95v-1.95h1.95v1.95ZM525.91,101.75h-1.95v-1.95h1.95v1.95ZM522.99,101.75h-1.95v-1.95h1.95v1.95ZM520.07,101.75h-1.95v-1.95h1.95v1.95ZM517.15,101.75h-1.95v-1.95h1.95v1.95ZM514.23,101.75h-1.95v-1.95h1.95v1.95ZM511.31,101.75h-1.95v-1.95h1.95v1.95ZM508.39,101.75h-1.95v-1.95h1.95v1.95ZM505.47,101.75h-1.95v-1.95h1.95v1.95ZM502.55,101.75h-1.95v-1.95h1.95v1.95ZM499.63,101.75h-1.95v-1.95h1.95v1.95ZM496.71,101.75h-1.95v-1.95h1.95v1.95ZM493.79,101.75h-1.95v-1.95h1.95v1.95ZM490.87,101.75h-1.95v-1.95h1.95v1.95ZM487.95,101.75h-1.95v-1.95h1.95v1.95ZM485.03,101.75h-1.95v-1.95h1.95v1.95ZM482.11,101.75h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,98.83h-1.95v-1.95h1.95v1.95ZM546.35,98.83h-1.95v-1.95h1.95v1.95ZM543.43,98.83h-1.95v-1.95h1.95v1.95ZM540.51,98.83h-1.95v-1.95h1.95v1.95ZM537.59,98.83h-1.95v-1.95h1.95v1.95ZM534.67,98.83h-1.95v-1.95h1.95v1.95ZM531.75,98.83h-1.95v-1.95h1.95v1.95ZM528.83,98.83h-1.95v-1.95h1.95v1.95ZM525.91,98.83h-1.95v-1.95h1.95v1.95ZM522.99,98.83h-1.95v-1.95h1.95v1.95ZM520.07,98.83h-1.95v-1.95h1.95v1.95ZM517.15,98.83h-1.95v-1.95h1.95v1.95ZM514.23,98.83h-1.95v-1.95h1.95v1.95ZM511.31,98.83h-1.95v-1.95h1.95v1.95ZM508.39,98.83h-1.95v-1.95h1.95v1.95ZM505.47,98.83h-1.95v-1.95h1.95v1.95ZM502.55,98.83h-1.95v-1.95h1.95v1.95ZM499.63,98.83h-1.95v-1.95h1.95v1.95ZM496.71,98.83h-1.95v-1.95h1.95v1.95ZM493.79,98.83h-1.95v-1.95h1.95v1.95ZM490.87,98.83h-1.95v-1.95h1.95v1.95ZM487.95,98.83h-1.95v-1.95h1.95v1.95ZM485.03,98.83h-1.95v-1.95h1.95v1.95ZM482.11,98.83h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,95.91h-1.95v-1.95h1.95v1.95ZM546.35,95.91h-1.95v-1.95h1.95v1.95ZM543.43,95.91h-1.95v-1.95h1.95v1.95ZM540.51,95.91h-1.95v-1.95h1.95v1.95ZM537.59,95.91h-1.95v-1.95h1.95v1.95ZM534.67,95.91h-1.95v-1.95h1.95v1.95ZM531.75,95.91h-1.95v-1.95h1.95v1.95ZM528.83,95.91h-1.95v-1.95h1.95v1.95ZM525.91,95.91h-1.95v-1.95h1.95v1.95ZM522.99,95.91h-1.95v-1.95h1.95v1.95ZM520.07,95.91h-1.95v-1.95h1.95v1.95ZM517.15,95.91h-1.95v-1.95h1.95v1.95ZM514.23,95.91h-1.95v-1.95h1.95v1.95ZM511.31,95.91h-1.95v-1.95h1.95v1.95ZM508.39,95.91h-1.95v-1.95h1.95v1.95ZM505.47,95.91h-1.95v-1.95h1.95v1.95ZM502.55,95.91h-1.95v-1.95h1.95v1.95ZM499.63,95.91h-1.95v-1.95h1.95v1.95ZM496.71,95.91h-1.95v-1.95h1.95v1.95ZM493.79,95.91h-1.95v-1.95h1.95v1.95ZM490.87,95.91h-1.95v-1.95h1.95v1.95ZM487.95,95.91h-1.95v-1.95h1.95v1.95ZM485.03,95.91h-1.95v-1.95h1.95v1.95ZM482.11,95.91h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,92.99h-1.95v-1.95h1.95v1.95ZM546.35,92.99h-1.95v-1.95h1.95v1.95ZM543.43,92.99h-1.95v-1.95h1.95v1.95ZM540.51,92.99h-1.95v-1.95h1.95v1.95ZM537.59,92.99h-1.95v-1.95h1.95v1.95ZM534.67,92.99h-1.95v-1.95h1.95v1.95ZM531.75,92.99h-1.95v-1.95h1.95v1.95ZM528.83,92.99h-1.95v-1.95h1.95v1.95ZM525.91,92.99h-1.95v-1.95h1.95v1.95ZM522.99,92.99h-1.95v-1.95h1.95v1.95ZM520.07,92.99h-1.95v-1.95h1.95v1.95ZM517.15,92.99h-1.95v-1.95h1.95v1.95ZM514.23,92.99h-1.95v-1.95h1.95v1.95ZM511.31,92.99h-1.95v-1.95h1.95v1.95ZM508.39,92.99h-1.95v-1.95h1.95v1.95ZM505.47,92.99h-1.95v-1.95h1.95v1.95ZM502.55,92.99h-1.95v-1.95h1.95v1.95ZM499.63,92.99h-1.95v-1.95h1.95v1.95ZM496.71,92.99h-1.95v-1.95h1.95v1.95ZM493.79,92.99h-1.95v-1.95h1.95v1.95ZM490.87,92.99h-1.95v-1.95h1.95v1.95ZM487.95,92.99h-1.95v-1.95h1.95v1.95ZM485.03,92.99h-1.95v-1.95h1.95v1.95ZM482.11,92.99h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,90.07h-1.95v-1.95h1.95v1.95ZM546.35,90.07h-1.95v-1.95h1.95v1.95ZM543.43,90.07h-1.95v-1.95h1.95v1.95ZM540.51,90.07h-1.95v-1.95h1.95v1.95ZM537.59,90.07h-1.95v-1.95h1.95v1.95ZM534.67,90.07h-1.95v-1.95h1.95v1.95ZM531.75,90.07h-1.95v-1.95h1.95v1.95ZM528.83,90.07h-1.95v-1.95h1.95v1.95ZM525.91,90.07h-1.95v-1.95h1.95v1.95ZM522.99,90.07h-1.95v-1.95h1.95v1.95ZM520.07,90.07h-1.95v-1.95h1.95v1.95ZM517.15,90.07h-1.95v-1.95h1.95v1.95ZM514.23,90.07h-1.95v-1.95h1.95v1.95ZM511.31,90.07h-1.95v-1.95h1.95v1.95ZM508.39,90.07h-1.95v-1.95h1.95v1.95ZM505.47,90.07h-1.95v-1.95h1.95v1.95ZM502.55,90.07h-1.95v-1.95h1.95v1.95ZM499.63,90.07h-1.95v-1.95h1.95v1.95ZM496.71,90.07h-1.95v-1.95h1.95v1.95ZM493.79,90.07h-1.95v-1.95h1.95v1.95ZM490.87,90.07h-1.95v-1.95h1.95v1.95ZM487.95,90.07h-1.95v-1.95h1.95v1.95ZM485.03,90.07h-1.95v-1.95h1.95v1.95ZM482.11,90.07h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,87.15h-1.95v-1.95h1.95v1.95ZM546.35,87.15h-1.95v-1.95h1.95v1.95ZM543.43,87.15h-1.95v-1.95h1.95v1.95ZM540.51,87.15h-1.95v-1.95h1.95v1.95ZM537.59,87.15h-1.95v-1.95h1.95v1.95ZM534.67,87.15h-1.95v-1.95h1.95v1.95ZM531.75,87.15h-1.95v-1.95h1.95v1.95ZM528.83,87.15h-1.95v-1.95h1.95v1.95ZM525.91,87.15h-1.95v-1.95h1.95v1.95ZM522.99,87.15h-1.95v-1.95h1.95v1.95ZM520.07,87.15h-1.95v-1.95h1.95v1.95ZM517.15,87.15h-1.95v-1.95h1.95v1.95ZM514.23,87.15h-1.95v-1.95h1.95v1.95ZM511.31,87.15h-1.95v-1.95h1.95v1.95ZM508.39,87.15h-1.95v-1.95h1.95v1.95ZM505.47,87.15h-1.95v-1.95h1.95v1.95ZM502.55,87.15h-1.95v-1.95h1.95v1.95ZM499.63,87.15h-1.95v-1.95h1.95v1.95ZM496.71,87.15h-1.95v-1.95h1.95v1.95ZM493.79,87.15h-1.95v-1.95h1.95v1.95ZM490.87,87.15h-1.95v-1.95h1.95v1.95ZM487.95,87.15h-1.95v-1.95h1.95v1.95ZM485.03,87.15h-1.95v-1.95h1.95v1.95ZM482.11,87.15h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,84.23h-1.95v-1.95h1.95v1.95ZM546.35,84.23h-1.95v-1.95h1.95v1.95ZM543.43,84.23h-1.95v-1.95h1.95v1.95ZM540.51,84.23h-1.95v-1.95h1.95v1.95ZM537.59,84.23h-1.95v-1.95h1.95v1.95ZM534.67,84.23h-1.95v-1.95h1.95v1.95ZM531.75,84.23h-1.95v-1.95h1.95v1.95ZM528.83,84.23h-1.95v-1.95h1.95v1.95ZM525.91,84.23h-1.95v-1.95h1.95v1.95ZM522.99,84.23h-1.95v-1.95h1.95v1.95ZM520.07,84.23h-1.95v-1.95h1.95v1.95ZM517.15,84.23h-1.95v-1.95h1.95v1.95ZM514.23,84.23h-1.95v-1.95h1.95v1.95ZM511.31,84.23h-1.95v-1.95h1.95v1.95ZM508.39,84.23h-1.95v-1.95h1.95v1.95ZM505.47,84.23h-1.95v-1.95h1.95v1.95ZM502.55,84.23h-1.95v-1.95h1.95v1.95ZM499.63,84.23h-1.95v-1.95h1.95v1.95ZM496.71,84.23h-1.95v-1.95h1.95v1.95ZM493.79,84.23h-1.95v-1.95h1.95v1.95ZM490.87,84.23h-1.95v-1.95h1.95v1.95ZM487.95,84.23h-1.95v-1.95h1.95v1.95ZM485.03,84.23h-1.95v-1.95h1.95v1.95ZM482.11,84.23h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,81.31h-1.95v-1.95h1.95v1.95ZM546.35,81.31h-1.95v-1.95h1.95v1.95ZM543.43,81.31h-1.95v-1.95h1.95v1.95ZM540.51,81.31h-1.95v-1.95h1.95v1.95ZM537.59,81.31h-1.95v-1.95h1.95v1.95ZM534.67,81.31h-1.95v-1.95h1.95v1.95ZM531.75,81.31h-1.95v-1.95h1.95v1.95ZM528.83,81.31h-1.95v-1.95h1.95v1.95ZM525.91,81.31h-1.95v-1.95h1.95v1.95ZM522.99,81.31h-1.95v-1.95h1.95v1.95ZM520.07,81.31h-1.95v-1.95h1.95v1.95ZM517.15,81.31h-1.95v-1.95h1.95v1.95ZM514.23,81.31h-1.95v-1.95h1.95v1.95ZM511.31,81.31h-1.95v-1.95h1.95v1.95ZM508.39,81.31h-1.95v-1.95h1.95v1.95ZM505.47,81.31h-1.95v-1.95h1.95v1.95ZM502.55,81.31h-1.95v-1.95h1.95v1.95ZM499.63,81.31h-1.95v-1.95h1.95v1.95ZM496.71,81.31h-1.95v-1.95h1.95v1.95ZM493.79,81.31h-1.95v-1.95h1.95v1.95ZM490.87,81.31h-1.95v-1.95h1.95v1.95ZM487.95,81.31h-1.95v-1.95h1.95v1.95ZM485.03,81.31h-1.95v-1.95h1.95v1.95ZM482.11,81.31h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,78.39h-1.95v-1.95h1.95v1.95ZM546.35,78.39h-1.95v-1.95h1.95v1.95ZM543.43,78.39h-1.95v-1.95h1.95v1.95ZM540.51,78.39h-1.95v-1.95h1.95v1.95ZM537.59,78.39h-1.95v-1.95h1.95v1.95ZM534.67,78.39h-1.95v-1.95h1.95v1.95ZM531.75,78.39h-1.95v-1.95h1.95v1.95ZM528.83,78.39h-1.95v-1.95h1.95v1.95ZM525.91,78.39h-1.95v-1.95h1.95v1.95ZM522.99,78.39h-1.95v-1.95h1.95v1.95ZM520.07,78.39h-1.95v-1.95h1.95v1.95ZM517.15,78.39h-1.95v-1.95h1.95v1.95ZM514.23,78.39h-1.95v-1.95h1.95v1.95ZM511.31,78.39h-1.95v-1.95h1.95v1.95ZM508.39,78.39h-1.95v-1.95h1.95v1.95ZM505.47,78.39h-1.95v-1.95h1.95v1.95ZM502.55,78.39h-1.95v-1.95h1.95v1.95ZM499.63,78.39h-1.95v-1.95h1.95v1.95ZM496.71,78.39h-1.95v-1.95h1.95v1.95ZM493.79,78.39h-1.95v-1.95h1.95v1.95ZM490.87,78.39h-1.95v-1.95h1.95v1.95ZM487.95,78.39h-1.95v-1.95h1.95v1.95ZM485.03,78.39h-1.95v-1.95h1.95v1.95ZM482.11,78.39h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,75.47h-1.95v-1.95h1.95v1.95ZM546.35,75.47h-1.95v-1.95h1.95v1.95ZM543.43,75.47h-1.95v-1.95h1.95v1.95ZM540.51,75.47h-1.95v-1.95h1.95v1.95ZM537.59,75.47h-1.95v-1.95h1.95v1.95ZM534.67,75.47h-1.95v-1.95h1.95v1.95ZM531.75,75.47h-1.95v-1.95h1.95v1.95ZM528.83,75.47h-1.95v-1.95h1.95v1.95ZM525.91,75.47h-1.95v-1.95h1.95v1.95ZM522.99,75.47h-1.95v-1.95h1.95v1.95ZM520.07,75.47h-1.95v-1.95h1.95v1.95ZM517.15,75.47h-1.95v-1.95h1.95v1.95ZM514.23,75.47h-1.95v-1.95h1.95v1.95ZM511.31,75.47h-1.95v-1.95h1.95v1.95ZM508.39,75.47h-1.95v-1.95h1.95v1.95ZM505.47,75.47h-1.95v-1.95h1.95v1.95ZM502.55,75.47h-1.95v-1.95h1.95v1.95ZM499.63,75.47h-1.95v-1.95h1.95v1.95ZM496.71,75.47h-1.95v-1.95h1.95v1.95ZM493.79,75.47h-1.95v-1.95h1.95v1.95ZM490.87,75.47h-1.95v-1.95h1.95v1.95ZM487.95,75.47h-1.95v-1.95h1.95v1.95ZM485.03,75.47h-1.95v-1.95h1.95v1.95ZM482.11,75.47h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,72.54h-1.95v-1.95h1.95v1.95ZM546.35,72.54h-1.95v-1.95h1.95v1.95ZM543.43,72.54h-1.95v-1.95h1.95v1.95ZM540.51,72.54h-1.95v-1.95h1.95v1.95ZM537.59,72.54h-1.95v-1.95h1.95v1.95ZM534.67,72.54h-1.95v-1.95h1.95v1.95ZM531.75,72.54h-1.95v-1.95h1.95v1.95ZM528.83,72.54h-1.95v-1.95h1.95v1.95ZM525.91,72.54h-1.95v-1.95h1.95v1.95ZM522.99,72.54h-1.95v-1.95h1.95v1.95ZM520.07,72.54h-1.95v-1.95h1.95v1.95ZM517.15,72.54h-1.95v-1.95h1.95v1.95ZM514.23,72.54h-1.95v-1.95h1.95v1.95ZM511.31,72.54h-1.95v-1.95h1.95v1.95ZM508.39,72.54h-1.95v-1.95h1.95v1.95ZM505.47,72.54h-1.95v-1.95h1.95v1.95ZM502.55,72.54h-1.95v-1.95h1.95v1.95ZM499.63,72.54h-1.95v-1.95h1.95v1.95ZM496.71,72.54h-1.95v-1.95h1.95v1.95ZM493.79,72.54h-1.95v-1.95h1.95v1.95ZM490.87,72.54h-1.95v-1.95h1.95v1.95ZM487.95,72.54h-1.95v-1.95h1.95v1.95ZM485.03,72.54h-1.95v-1.95h1.95v1.95ZM482.11,72.54h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,69.62h-1.95v-1.95h1.95v1.95ZM546.35,69.62h-1.95v-1.95h1.95v1.95ZM543.43,69.62h-1.95v-1.95h1.95v1.95ZM540.51,69.62h-1.95v-1.95h1.95v1.95ZM537.59,69.62h-1.95v-1.95h1.95v1.95ZM534.67,69.62h-1.95v-1.95h1.95v1.95ZM531.75,69.62h-1.95v-1.95h1.95v1.95ZM528.83,69.62h-1.95v-1.95h1.95v1.95ZM525.91,69.62h-1.95v-1.95h1.95v1.95ZM522.99,69.62h-1.95v-1.95h1.95v1.95ZM520.07,69.62h-1.95v-1.95h1.95v1.95ZM517.15,69.62h-1.95v-1.95h1.95v1.95ZM514.23,69.62h-1.95v-1.95h1.95v1.95ZM511.31,69.62h-1.95v-1.95h1.95v1.95ZM508.39,69.62h-1.95v-1.95h1.95v1.95ZM505.47,69.62h-1.95v-1.95h1.95v1.95ZM502.55,69.62h-1.95v-1.95h1.95v1.95ZM499.63,69.62h-1.95v-1.95h1.95v1.95ZM496.71,69.62h-1.95v-1.95h1.95v1.95ZM493.79,69.62h-1.95v-1.95h1.95v1.95ZM490.87,69.62h-1.95v-1.95h1.95v1.95ZM487.95,69.62h-1.95v-1.95h1.95v1.95ZM485.03,69.62h-1.95v-1.95h1.95v1.95ZM482.11,69.62h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,66.7h-1.95v-1.95h1.95v1.95ZM546.35,66.7h-1.95v-1.95h1.95v1.95ZM543.43,66.7h-1.95v-1.95h1.95v1.95ZM540.51,66.7h-1.95v-1.95h1.95v1.95ZM537.59,66.7h-1.95v-1.95h1.95v1.95ZM534.67,66.7h-1.95v-1.95h1.95v1.95ZM531.75,66.7h-1.95v-1.95h1.95v1.95ZM528.83,66.7h-1.95v-1.95h1.95v1.95ZM525.91,66.7h-1.95v-1.95h1.95v1.95ZM522.99,66.7h-1.95v-1.95h1.95v1.95ZM520.07,66.7h-1.95v-1.95h1.95v1.95ZM517.15,66.7h-1.95v-1.95h1.95v1.95ZM514.23,66.7h-1.95v-1.95h1.95v1.95ZM511.31,66.7h-1.95v-1.95h1.95v1.95ZM508.39,66.7h-1.95v-1.95h1.95v1.95ZM505.47,66.7h-1.95v-1.95h1.95v1.95ZM502.55,66.7h-1.95v-1.95h1.95v1.95ZM499.63,66.7h-1.95v-1.95h1.95v1.95ZM496.71,66.7h-1.95v-1.95h1.95v1.95ZM493.79,66.7h-1.95v-1.95h1.95v1.95ZM490.87,66.7h-1.95v-1.95h1.95v1.95ZM487.95,66.7h-1.95v-1.95h1.95v1.95ZM485.03,66.7h-1.95v-1.95h1.95v1.95ZM482.11,66.7h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,63.78h-1.95v-1.95h1.95v1.95ZM546.35,63.78h-1.95v-1.95h1.95v1.95ZM543.43,63.78h-1.95v-1.95h1.95v1.95ZM540.51,63.78h-1.95v-1.95h1.95v1.95ZM537.59,63.78h-1.95v-1.95h1.95v1.95ZM534.67,63.78h-1.95v-1.95h1.95v1.95ZM531.75,63.78h-1.95v-1.95h1.95v1.95ZM528.83,63.78h-1.95v-1.95h1.95v1.95ZM525.91,63.78h-1.95v-1.95h1.95v1.95ZM522.99,63.78h-1.95v-1.95h1.95v1.95ZM520.07,63.78h-1.95v-1.95h1.95v1.95ZM517.15,63.78h-1.95v-1.95h1.95v1.95ZM514.23,63.78h-1.95v-1.95h1.95v1.95ZM511.31,63.78h-1.95v-1.95h1.95v1.95ZM508.39,63.78h-1.95v-1.95h1.95v1.95ZM505.47,63.78h-1.95v-1.95h1.95v1.95ZM502.55,63.78h-1.95v-1.95h1.95v1.95ZM499.63,63.78h-1.95v-1.95h1.95v1.95ZM496.71,63.78h-1.95v-1.95h1.95v1.95ZM493.79,63.78h-1.95v-1.95h1.95v1.95ZM490.87,63.78h-1.95v-1.95h1.95v1.95ZM487.95,63.78h-1.95v-1.95h1.95v1.95ZM485.03,63.78h-1.95v-1.95h1.95v1.95ZM482.11,63.78h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,60.86h-1.95v-1.95h1.95v1.95ZM546.35,60.86h-1.95v-1.95h1.95v1.95ZM543.43,60.86h-1.95v-1.95h1.95v1.95ZM540.51,60.86h-1.95v-1.95h1.95v1.95ZM537.59,60.86h-1.95v-1.95h1.95v1.95ZM534.67,60.86h-1.95v-1.95h1.95v1.95ZM531.75,60.86h-1.95v-1.95h1.95v1.95ZM528.83,60.86h-1.95v-1.95h1.95v1.95ZM525.91,60.86h-1.95v-1.95h1.95v1.95ZM522.99,60.86h-1.95v-1.95h1.95v1.95ZM520.07,60.86h-1.95v-1.95h1.95v1.95ZM517.15,60.86h-1.95v-1.95h1.95v1.95ZM514.23,60.86h-1.95v-1.95h1.95v1.95ZM511.31,60.86h-1.95v-1.95h1.95v1.95ZM508.39,60.86h-1.95v-1.95h1.95v1.95ZM505.47,60.86h-1.95v-1.95h1.95v1.95ZM502.55,60.86h-1.95v-1.95h1.95v1.95ZM499.63,60.86h-1.95v-1.95h1.95v1.95ZM496.71,60.86h-1.95v-1.95h1.95v1.95ZM493.79,60.86h-1.95v-1.95h1.95v1.95ZM490.87,60.86h-1.95v-1.95h1.95v1.95ZM487.95,60.86h-1.95v-1.95h1.95v1.95ZM485.03,60.86h-1.95v-1.95h1.95v1.95ZM482.11,60.86h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,57.94h-1.95v-1.95h1.95v1.95ZM546.35,57.94h-1.95v-1.95h1.95v1.95ZM543.43,57.94h-1.95v-1.95h1.95v1.95ZM540.51,57.94h-1.95v-1.95h1.95v1.95ZM537.59,57.94h-1.95v-1.95h1.95v1.95ZM534.67,57.94h-1.95v-1.95h1.95v1.95ZM531.75,57.94h-1.95v-1.95h1.95v1.95ZM528.83,57.94h-1.95v-1.95h1.95v1.95ZM525.91,57.94h-1.95v-1.95h1.95v1.95ZM522.99,57.94h-1.95v-1.95h1.95v1.95ZM520.07,57.94h-1.95v-1.95h1.95v1.95ZM517.15,57.94h-1.95v-1.95h1.95v1.95ZM514.23,57.94h-1.95v-1.95h1.95v1.95ZM511.31,57.94h-1.95v-1.95h1.95v1.95ZM508.39,57.94h-1.95v-1.95h1.95v1.95ZM505.47,57.94h-1.95v-1.95h1.95v1.95ZM502.55,57.94h-1.95v-1.95h1.95v1.95ZM499.63,57.94h-1.95v-1.95h1.95v1.95ZM496.71,57.94h-1.95v-1.95h1.95v1.95ZM493.79,57.94h-1.95v-1.95h1.95v1.95ZM490.87,57.94h-1.95v-1.95h1.95v1.95ZM487.95,57.94h-1.95v-1.95h1.95v1.95ZM485.03,57.94h-1.95v-1.95h1.95v1.95ZM482.11,57.94h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,125.11h-1.95v-1.95h1.95v1.95ZM476.27,125.11h-1.95v-1.95h1.95v1.95ZM473.35,125.11h-1.95v-1.95h1.95v1.95ZM470.43,125.11h-1.95v-1.95h1.95v1.95ZM467.51,125.11h-1.95v-1.95h1.95v1.95ZM464.59,125.11h-1.95v-1.95h1.95v1.95ZM461.67,125.11h-1.95v-1.95h1.95v1.95ZM458.75,125.11h-1.95v-1.95h1.95v1.95ZM455.82,125.11h-1.95v-1.95h1.95v1.95ZM452.9,125.11h-1.95v-1.95h1.95v1.95ZM449.98,125.11h-1.95v-1.95h1.95v1.95ZM447.06,125.11h-1.95v-1.95h1.95v1.95ZM444.14,125.11h-1.95v-1.95h1.95v1.95ZM441.22,125.11h-1.95v-1.95h1.95v1.95ZM438.3,125.11h-1.95v-1.95h1.95v1.95ZM435.38,125.11h-1.95v-1.95h1.95v1.95ZM432.46,125.11h-1.95v-1.95h1.95v1.95ZM429.54,125.11h-1.95v-1.95h1.95v1.95ZM426.62,125.11h-1.95v-1.95h1.95v1.95ZM423.7,125.11h-1.95v-1.95h1.95v1.95ZM420.78,125.11h-1.95v-1.95h1.95v1.95ZM417.86,125.11h-1.95v-1.95h1.95v1.95ZM414.94,125.11h-1.95v-1.95h1.95v1.95ZM412.02,125.11h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,122.19h-1.95v-1.95h1.95v1.95ZM476.27,122.19h-1.95v-1.95h1.95v1.95ZM473.35,122.19h-1.95v-1.95h1.95v1.95ZM470.43,122.19h-1.95v-1.95h1.95v1.95ZM467.51,122.19h-1.95v-1.95h1.95v1.95ZM464.59,122.19h-1.95v-1.95h1.95v1.95ZM461.67,122.19h-1.95v-1.95h1.95v1.95ZM458.75,122.19h-1.95v-1.95h1.95v1.95ZM455.82,122.19h-1.95v-1.95h1.95v1.95ZM452.9,122.19h-1.95v-1.95h1.95v1.95ZM449.98,122.19h-1.95v-1.95h1.95v1.95ZM447.06,122.19h-1.95v-1.95h1.95v1.95ZM444.14,122.19h-1.95v-1.95h1.95v1.95ZM441.22,122.19h-1.95v-1.95h1.95v1.95ZM438.3,122.19h-1.95v-1.95h1.95v1.95ZM435.38,122.19h-1.95v-1.95h1.95v1.95ZM432.46,122.19h-1.95v-1.95h1.95v1.95ZM429.54,122.19h-1.95v-1.95h1.95v1.95ZM426.62,122.19h-1.95v-1.95h1.95v1.95ZM423.7,122.19h-1.95v-1.95h1.95v1.95ZM420.78,122.19h-1.95v-1.95h1.95v1.95ZM417.86,122.19h-1.95v-1.95h1.95v1.95ZM414.94,122.19h-1.95v-1.95h1.95v1.95ZM412.02,122.19h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,119.27h-1.95v-1.95h1.95v1.95ZM476.27,119.27h-1.95v-1.95h1.95v1.95ZM473.35,119.27h-1.95v-1.95h1.95v1.95ZM470.43,119.27h-1.95v-1.95h1.95v1.95ZM467.51,119.27h-1.95v-1.95h1.95v1.95ZM464.59,119.27h-1.95v-1.95h1.95v1.95ZM461.67,119.27h-1.95v-1.95h1.95v1.95ZM458.75,119.27h-1.95v-1.95h1.95v1.95ZM455.82,119.27h-1.95v-1.95h1.95v1.95ZM452.9,119.27h-1.95v-1.95h1.95v1.95ZM449.98,119.27h-1.95v-1.95h1.95v1.95ZM447.06,119.27h-1.95v-1.95h1.95v1.95ZM444.14,119.27h-1.95v-1.95h1.95v1.95ZM441.22,119.27h-1.95v-1.95h1.95v1.95ZM438.3,119.27h-1.95v-1.95h1.95v1.95ZM435.38,119.27h-1.95v-1.95h1.95v1.95ZM432.46,119.27h-1.95v-1.95h1.95v1.95ZM429.54,119.27h-1.95v-1.95h1.95v1.95ZM426.62,119.27h-1.95v-1.95h1.95v1.95ZM423.7,119.27h-1.95v-1.95h1.95v1.95ZM420.78,119.27h-1.95v-1.95h1.95v1.95ZM417.86,119.27h-1.95v-1.95h1.95v1.95ZM414.94,119.27h-1.95v-1.95h1.95v1.95ZM412.02,119.27h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,116.35h-1.95v-1.95h1.95v1.95ZM476.27,116.35h-1.95v-1.95h1.95v1.95ZM473.35,116.35h-1.95v-1.95h1.95v1.95ZM470.43,116.35h-1.95v-1.95h1.95v1.95ZM467.51,116.35h-1.95v-1.95h1.95v1.95ZM464.59,116.35h-1.95v-1.95h1.95v1.95ZM461.67,116.35h-1.95v-1.95h1.95v1.95ZM458.75,116.35h-1.95v-1.95h1.95v1.95ZM455.82,116.35h-1.95v-1.95h1.95v1.95ZM452.9,116.35h-1.95v-1.95h1.95v1.95ZM449.98,116.35h-1.95v-1.95h1.95v1.95ZM447.06,116.35h-1.95v-1.95h1.95v1.95ZM444.14,116.35h-1.95v-1.95h1.95v1.95ZM441.22,116.35h-1.95v-1.95h1.95v1.95ZM438.3,116.35h-1.95v-1.95h1.95v1.95ZM435.38,116.35h-1.95v-1.95h1.95v1.95ZM432.46,116.35h-1.95v-1.95h1.95v1.95ZM429.54,116.35h-1.95v-1.95h1.95v1.95ZM426.62,116.35h-1.95v-1.95h1.95v1.95ZM423.7,116.35h-1.95v-1.95h1.95v1.95ZM420.78,116.35h-1.95v-1.95h1.95v1.95ZM417.86,116.35h-1.95v-1.95h1.95v1.95ZM414.94,116.35h-1.95v-1.95h1.95v1.95ZM412.02,116.35h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,113.43h-1.95v-1.95h1.95v1.95ZM476.27,113.43h-1.95v-1.95h1.95v1.95ZM473.35,113.43h-1.95v-1.95h1.95v1.95ZM470.43,113.43h-1.95v-1.95h1.95v1.95ZM467.51,113.43h-1.95v-1.95h1.95v1.95ZM464.59,113.43h-1.95v-1.95h1.95v1.95ZM461.67,113.43h-1.95v-1.95h1.95v1.95ZM458.75,113.43h-1.95v-1.95h1.95v1.95ZM455.82,113.43h-1.95v-1.95h1.95v1.95ZM452.9,113.43h-1.95v-1.95h1.95v1.95ZM449.98,113.43h-1.95v-1.95h1.95v1.95ZM447.06,113.43h-1.95v-1.95h1.95v1.95ZM444.14,113.43h-1.95v-1.95h1.95v1.95ZM441.22,113.43h-1.95v-1.95h1.95v1.95ZM438.3,113.43h-1.95v-1.95h1.95v1.95ZM435.38,113.43h-1.95v-1.95h1.95v1.95ZM432.46,113.43h-1.95v-1.95h1.95v1.95ZM429.54,113.43h-1.95v-1.95h1.95v1.95ZM426.62,113.43h-1.95v-1.95h1.95v1.95ZM423.7,113.43h-1.95v-1.95h1.95v1.95ZM420.78,113.43h-1.95v-1.95h1.95v1.95ZM417.86,113.43h-1.95v-1.95h1.95v1.95ZM414.94,113.43h-1.95v-1.95h1.95v1.95ZM412.02,113.43h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,110.51h-1.95v-1.95h1.95v1.95ZM476.27,110.51h-1.95v-1.95h1.95v1.95ZM473.35,110.51h-1.95v-1.95h1.95v1.95ZM470.43,110.51h-1.95v-1.95h1.95v1.95ZM467.51,110.51h-1.95v-1.95h1.95v1.95ZM464.59,110.51h-1.95v-1.95h1.95v1.95ZM461.67,110.51h-1.95v-1.95h1.95v1.95ZM458.75,110.51h-1.95v-1.95h1.95v1.95ZM455.82,110.51h-1.95v-1.95h1.95v1.95ZM452.9,110.51h-1.95v-1.95h1.95v1.95ZM449.98,110.51h-1.95v-1.95h1.95v1.95ZM447.06,110.51h-1.95v-1.95h1.95v1.95ZM444.14,110.51h-1.95v-1.95h1.95v1.95ZM441.22,110.51h-1.95v-1.95h1.95v1.95ZM438.3,110.51h-1.95v-1.95h1.95v1.95ZM435.38,110.51h-1.95v-1.95h1.95v1.95ZM432.46,110.51h-1.95v-1.95h1.95v1.95ZM429.54,110.51h-1.95v-1.95h1.95v1.95ZM426.62,110.51h-1.95v-1.95h1.95v1.95ZM423.7,110.51h-1.95v-1.95h1.95v1.95ZM420.78,110.51h-1.95v-1.95h1.95v1.95ZM417.86,110.51h-1.95v-1.95h1.95v1.95ZM414.94,110.51h-1.95v-1.95h1.95v1.95ZM412.02,110.51h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,107.59h-1.95v-1.95h1.95v1.95ZM476.27,107.59h-1.95v-1.95h1.95v1.95ZM473.35,107.59h-1.95v-1.95h1.95v1.95ZM470.43,107.59h-1.95v-1.95h1.95v1.95ZM467.51,107.59h-1.95v-1.95h1.95v1.95ZM464.59,107.59h-1.95v-1.95h1.95v1.95ZM461.67,107.59h-1.95v-1.95h1.95v1.95ZM458.75,107.59h-1.95v-1.95h1.95v1.95ZM455.82,107.59h-1.95v-1.95h1.95v1.95ZM452.9,107.59h-1.95v-1.95h1.95v1.95ZM449.98,107.59h-1.95v-1.95h1.95v1.95ZM447.06,107.59h-1.95v-1.95h1.95v1.95ZM444.14,107.59h-1.95v-1.95h1.95v1.95ZM441.22,107.59h-1.95v-1.95h1.95v1.95ZM438.3,107.59h-1.95v-1.95h1.95v1.95ZM435.38,107.59h-1.95v-1.95h1.95v1.95ZM432.46,107.59h-1.95v-1.95h1.95v1.95ZM429.54,107.59h-1.95v-1.95h1.95v1.95ZM426.62,107.59h-1.95v-1.95h1.95v1.95ZM423.7,107.59h-1.95v-1.95h1.95v1.95ZM420.78,107.59h-1.95v-1.95h1.95v1.95ZM417.86,107.59h-1.95v-1.95h1.95v1.95ZM414.94,107.59h-1.95v-1.95h1.95v1.95ZM412.02,107.59h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,104.67h-1.95v-1.95h1.95v1.95ZM476.27,104.67h-1.95v-1.95h1.95v1.95ZM473.35,104.67h-1.95v-1.95h1.95v1.95ZM470.43,104.67h-1.95v-1.95h1.95v1.95ZM467.51,104.67h-1.95v-1.95h1.95v1.95ZM464.59,104.67h-1.95v-1.95h1.95v1.95ZM461.67,104.67h-1.95v-1.95h1.95v1.95ZM458.75,104.67h-1.95v-1.95h1.95v1.95ZM455.82,104.67h-1.95v-1.95h1.95v1.95ZM452.9,104.67h-1.95v-1.95h1.95v1.95ZM449.98,104.67h-1.95v-1.95h1.95v1.95ZM447.06,104.67h-1.95v-1.95h1.95v1.95ZM444.14,104.67h-1.95v-1.95h1.95v1.95ZM441.22,104.67h-1.95v-1.95h1.95v1.95ZM438.3,104.67h-1.95v-1.95h1.95v1.95ZM435.38,104.67h-1.95v-1.95h1.95v1.95ZM432.46,104.67h-1.95v-1.95h1.95v1.95ZM429.54,104.67h-1.95v-1.95h1.95v1.95ZM426.62,104.67h-1.95v-1.95h1.95v1.95ZM423.7,104.67h-1.95v-1.95h1.95v1.95ZM420.78,104.67h-1.95v-1.95h1.95v1.95ZM417.86,104.67h-1.95v-1.95h1.95v1.95ZM414.94,104.67h-1.95v-1.95h1.95v1.95ZM412.02,104.67h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,101.75h-1.95v-1.95h1.95v1.95ZM476.27,101.75h-1.95v-1.95h1.95v1.95ZM473.35,101.75h-1.95v-1.95h1.95v1.95ZM470.43,101.75h-1.95v-1.95h1.95v1.95ZM467.51,101.75h-1.95v-1.95h1.95v1.95ZM464.59,101.75h-1.95v-1.95h1.95v1.95ZM461.67,101.75h-1.95v-1.95h1.95v1.95ZM458.75,101.75h-1.95v-1.95h1.95v1.95ZM455.82,101.75h-1.95v-1.95h1.95v1.95ZM452.9,101.75h-1.95v-1.95h1.95v1.95ZM449.98,101.75h-1.95v-1.95h1.95v1.95ZM447.06,101.75h-1.95v-1.95h1.95v1.95ZM444.14,101.75h-1.95v-1.95h1.95v1.95ZM441.22,101.75h-1.95v-1.95h1.95v1.95ZM438.3,101.75h-1.95v-1.95h1.95v1.95ZM435.38,101.75h-1.95v-1.95h1.95v1.95ZM432.46,101.75h-1.95v-1.95h1.95v1.95ZM429.54,101.75h-1.95v-1.95h1.95v1.95ZM426.62,101.75h-1.95v-1.95h1.95v1.95ZM423.7,101.75h-1.95v-1.95h1.95v1.95ZM420.78,101.75h-1.95v-1.95h1.95v1.95ZM417.86,101.75h-1.95v-1.95h1.95v1.95ZM414.94,101.75h-1.95v-1.95h1.95v1.95ZM412.02,101.75h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,98.83h-1.95v-1.95h1.95v1.95ZM476.27,98.83h-1.95v-1.95h1.95v1.95ZM473.35,98.83h-1.95v-1.95h1.95v1.95ZM470.43,98.83h-1.95v-1.95h1.95v1.95ZM467.51,98.83h-1.95v-1.95h1.95v1.95ZM464.59,98.83h-1.95v-1.95h1.95v1.95ZM461.67,98.83h-1.95v-1.95h1.95v1.95ZM458.75,98.83h-1.95v-1.95h1.95v1.95ZM455.82,98.83h-1.95v-1.95h1.95v1.95ZM452.9,98.83h-1.95v-1.95h1.95v1.95ZM449.98,98.83h-1.95v-1.95h1.95v1.95ZM447.06,98.83h-1.95v-1.95h1.95v1.95ZM444.14,98.83h-1.95v-1.95h1.95v1.95ZM441.22,98.83h-1.95v-1.95h1.95v1.95ZM438.3,98.83h-1.95v-1.95h1.95v1.95ZM435.38,98.83h-1.95v-1.95h1.95v1.95ZM432.46,98.83h-1.95v-1.95h1.95v1.95ZM429.54,98.83h-1.95v-1.95h1.95v1.95ZM426.62,98.83h-1.95v-1.95h1.95v1.95ZM423.7,98.83h-1.95v-1.95h1.95v1.95ZM420.78,98.83h-1.95v-1.95h1.95v1.95ZM417.86,98.83h-1.95v-1.95h1.95v1.95ZM414.94,98.83h-1.95v-1.95h1.95v1.95ZM412.02,98.83h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,95.91h-1.95v-1.95h1.95v1.95ZM476.27,95.91h-1.95v-1.95h1.95v1.95ZM473.35,95.91h-1.95v-1.95h1.95v1.95ZM470.43,95.91h-1.95v-1.95h1.95v1.95ZM467.51,95.91h-1.95v-1.95h1.95v1.95ZM464.59,95.91h-1.95v-1.95h1.95v1.95ZM461.67,95.91h-1.95v-1.95h1.95v1.95ZM458.75,95.91h-1.95v-1.95h1.95v1.95ZM455.82,95.91h-1.95v-1.95h1.95v1.95ZM452.9,95.91h-1.95v-1.95h1.95v1.95ZM449.98,95.91h-1.95v-1.95h1.95v1.95ZM447.06,95.91h-1.95v-1.95h1.95v1.95ZM444.14,95.91h-1.95v-1.95h1.95v1.95ZM441.22,95.91h-1.95v-1.95h1.95v1.95ZM438.3,95.91h-1.95v-1.95h1.95v1.95ZM435.38,95.91h-1.95v-1.95h1.95v1.95ZM432.46,95.91h-1.95v-1.95h1.95v1.95ZM429.54,95.91h-1.95v-1.95h1.95v1.95ZM426.62,95.91h-1.95v-1.95h1.95v1.95ZM423.7,95.91h-1.95v-1.95h1.95v1.95ZM420.78,95.91h-1.95v-1.95h1.95v1.95ZM417.86,95.91h-1.95v-1.95h1.95v1.95ZM414.94,95.91h-1.95v-1.95h1.95v1.95ZM412.02,95.91h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,92.99h-1.95v-1.95h1.95v1.95ZM476.27,92.99h-1.95v-1.95h1.95v1.95ZM473.35,92.99h-1.95v-1.95h1.95v1.95ZM470.43,92.99h-1.95v-1.95h1.95v1.95ZM467.51,92.99h-1.95v-1.95h1.95v1.95ZM464.59,92.99h-1.95v-1.95h1.95v1.95ZM461.67,92.99h-1.95v-1.95h1.95v1.95ZM458.75,92.99h-1.95v-1.95h1.95v1.95ZM455.82,92.99h-1.95v-1.95h1.95v1.95ZM452.9,92.99h-1.95v-1.95h1.95v1.95ZM449.98,92.99h-1.95v-1.95h1.95v1.95ZM447.06,92.99h-1.95v-1.95h1.95v1.95ZM444.14,92.99h-1.95v-1.95h1.95v1.95ZM441.22,92.99h-1.95v-1.95h1.95v1.95ZM438.3,92.99h-1.95v-1.95h1.95v1.95ZM435.38,92.99h-1.95v-1.95h1.95v1.95ZM432.46,92.99h-1.95v-1.95h1.95v1.95ZM429.54,92.99h-1.95v-1.95h1.95v1.95ZM426.62,92.99h-1.95v-1.95h1.95v1.95ZM423.7,92.99h-1.95v-1.95h1.95v1.95ZM420.78,92.99h-1.95v-1.95h1.95v1.95ZM417.86,92.99h-1.95v-1.95h1.95v1.95ZM414.94,92.99h-1.95v-1.95h1.95v1.95ZM412.02,92.99h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,90.07h-1.95v-1.95h1.95v1.95ZM476.27,90.07h-1.95v-1.95h1.95v1.95ZM473.35,90.07h-1.95v-1.95h1.95v1.95ZM470.43,90.07h-1.95v-1.95h1.95v1.95ZM467.51,90.07h-1.95v-1.95h1.95v1.95ZM464.59,90.07h-1.95v-1.95h1.95v1.95ZM461.67,90.07h-1.95v-1.95h1.95v1.95ZM458.75,90.07h-1.95v-1.95h1.95v1.95ZM455.82,90.07h-1.95v-1.95h1.95v1.95ZM452.9,90.07h-1.95v-1.95h1.95v1.95ZM449.98,90.07h-1.95v-1.95h1.95v1.95ZM447.06,90.07h-1.95v-1.95h1.95v1.95ZM444.14,90.07h-1.95v-1.95h1.95v1.95ZM441.22,90.07h-1.95v-1.95h1.95v1.95ZM438.3,90.07h-1.95v-1.95h1.95v1.95ZM435.38,90.07h-1.95v-1.95h1.95v1.95ZM432.46,90.07h-1.95v-1.95h1.95v1.95ZM429.54,90.07h-1.95v-1.95h1.95v1.95ZM426.62,90.07h-1.95v-1.95h1.95v1.95ZM423.7,90.07h-1.95v-1.95h1.95v1.95ZM420.78,90.07h-1.95v-1.95h1.95v1.95ZM417.86,90.07h-1.95v-1.95h1.95v1.95ZM414.94,90.07h-1.95v-1.95h1.95v1.95ZM412.02,90.07h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,87.15h-1.95v-1.95h1.95v1.95ZM476.27,87.15h-1.95v-1.95h1.95v1.95ZM473.35,87.15h-1.95v-1.95h1.95v1.95ZM470.43,87.15h-1.95v-1.95h1.95v1.95ZM467.51,87.15h-1.95v-1.95h1.95v1.95ZM464.59,87.15h-1.95v-1.95h1.95v1.95ZM461.67,87.15h-1.95v-1.95h1.95v1.95ZM458.75,87.15h-1.95v-1.95h1.95v1.95ZM455.82,87.15h-1.95v-1.95h1.95v1.95ZM452.9,87.15h-1.95v-1.95h1.95v1.95ZM449.98,87.15h-1.95v-1.95h1.95v1.95ZM447.06,87.15h-1.95v-1.95h1.95v1.95ZM444.14,87.15h-1.95v-1.95h1.95v1.95ZM441.22,87.15h-1.95v-1.95h1.95v1.95ZM438.3,87.15h-1.95v-1.95h1.95v1.95ZM435.38,87.15h-1.95v-1.95h1.95v1.95ZM432.46,87.15h-1.95v-1.95h1.95v1.95ZM429.54,87.15h-1.95v-1.95h1.95v1.95ZM426.62,87.15h-1.95v-1.95h1.95v1.95ZM423.7,87.15h-1.95v-1.95h1.95v1.95ZM420.78,87.15h-1.95v-1.95h1.95v1.95ZM417.86,87.15h-1.95v-1.95h1.95v1.95ZM414.94,87.15h-1.95v-1.95h1.95v1.95ZM412.02,87.15h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,84.23h-1.95v-1.95h1.95v1.95ZM476.27,84.23h-1.95v-1.95h1.95v1.95ZM473.35,84.23h-1.95v-1.95h1.95v1.95ZM470.43,84.23h-1.95v-1.95h1.95v1.95ZM467.51,84.23h-1.95v-1.95h1.95v1.95ZM464.59,84.23h-1.95v-1.95h1.95v1.95ZM461.67,84.23h-1.95v-1.95h1.95v1.95ZM458.75,84.23h-1.95v-1.95h1.95v1.95ZM455.82,84.23h-1.95v-1.95h1.95v1.95ZM452.9,84.23h-1.95v-1.95h1.95v1.95ZM449.98,84.23h-1.95v-1.95h1.95v1.95ZM447.06,84.23h-1.95v-1.95h1.95v1.95ZM444.14,84.23h-1.95v-1.95h1.95v1.95ZM441.22,84.23h-1.95v-1.95h1.95v1.95ZM438.3,84.23h-1.95v-1.95h1.95v1.95ZM435.38,84.23h-1.95v-1.95h1.95v1.95ZM432.46,84.23h-1.95v-1.95h1.95v1.95ZM429.54,84.23h-1.95v-1.95h1.95v1.95ZM426.62,84.23h-1.95v-1.95h1.95v1.95ZM423.7,84.23h-1.95v-1.95h1.95v1.95ZM420.78,84.23h-1.95v-1.95h1.95v1.95ZM417.86,84.23h-1.95v-1.95h1.95v1.95ZM414.94,84.23h-1.95v-1.95h1.95v1.95ZM412.02,84.23h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,81.31h-1.95v-1.95h1.95v1.95ZM476.27,81.31h-1.95v-1.95h1.95v1.95ZM473.35,81.31h-1.95v-1.95h1.95v1.95ZM470.43,81.31h-1.95v-1.95h1.95v1.95ZM467.51,81.31h-1.95v-1.95h1.95v1.95ZM464.59,81.31h-1.95v-1.95h1.95v1.95ZM461.67,81.31h-1.95v-1.95h1.95v1.95ZM458.75,81.31h-1.95v-1.95h1.95v1.95ZM455.82,81.31h-1.95v-1.95h1.95v1.95ZM452.9,81.31h-1.95v-1.95h1.95v1.95ZM449.98,81.31h-1.95v-1.95h1.95v1.95ZM447.06,81.31h-1.95v-1.95h1.95v1.95ZM444.14,81.31h-1.95v-1.95h1.95v1.95ZM441.22,81.31h-1.95v-1.95h1.95v1.95ZM438.3,81.31h-1.95v-1.95h1.95v1.95ZM435.38,81.31h-1.95v-1.95h1.95v1.95ZM432.46,81.31h-1.95v-1.95h1.95v1.95ZM429.54,81.31h-1.95v-1.95h1.95v1.95ZM426.62,81.31h-1.95v-1.95h1.95v1.95ZM423.7,81.31h-1.95v-1.95h1.95v1.95ZM420.78,81.31h-1.95v-1.95h1.95v1.95ZM417.86,81.31h-1.95v-1.95h1.95v1.95ZM414.94,81.31h-1.95v-1.95h1.95v1.95ZM412.02,81.31h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,78.39h-1.95v-1.95h1.95v1.95ZM476.27,78.39h-1.95v-1.95h1.95v1.95ZM473.35,78.39h-1.95v-1.95h1.95v1.95ZM470.43,78.39h-1.95v-1.95h1.95v1.95ZM467.51,78.39h-1.95v-1.95h1.95v1.95ZM464.59,78.39h-1.95v-1.95h1.95v1.95ZM461.67,78.39h-1.95v-1.95h1.95v1.95ZM458.75,78.39h-1.95v-1.95h1.95v1.95ZM455.82,78.39h-1.95v-1.95h1.95v1.95ZM452.9,78.39h-1.95v-1.95h1.95v1.95ZM449.98,78.39h-1.95v-1.95h1.95v1.95ZM447.06,78.39h-1.95v-1.95h1.95v1.95ZM444.14,78.39h-1.95v-1.95h1.95v1.95ZM441.22,78.39h-1.95v-1.95h1.95v1.95ZM438.3,78.39h-1.95v-1.95h1.95v1.95ZM435.38,78.39h-1.95v-1.95h1.95v1.95ZM432.46,78.39h-1.95v-1.95h1.95v1.95ZM429.54,78.39h-1.95v-1.95h1.95v1.95ZM426.62,78.39h-1.95v-1.95h1.95v1.95ZM423.7,78.39h-1.95v-1.95h1.95v1.95ZM420.78,78.39h-1.95v-1.95h1.95v1.95ZM417.86,78.39h-1.95v-1.95h1.95v1.95ZM414.94,78.39h-1.95v-1.95h1.95v1.95ZM412.02,78.39h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,75.47h-1.95v-1.95h1.95v1.95ZM476.27,75.47h-1.95v-1.95h1.95v1.95ZM473.35,75.47h-1.95v-1.95h1.95v1.95ZM470.43,75.47h-1.95v-1.95h1.95v1.95ZM467.51,75.47h-1.95v-1.95h1.95v1.95ZM464.59,75.47h-1.95v-1.95h1.95v1.95ZM461.67,75.47h-1.95v-1.95h1.95v1.95ZM458.75,75.47h-1.95v-1.95h1.95v1.95ZM455.82,75.47h-1.95v-1.95h1.95v1.95ZM452.9,75.47h-1.95v-1.95h1.95v1.95ZM449.98,75.47h-1.95v-1.95h1.95v1.95ZM447.06,75.47h-1.95v-1.95h1.95v1.95ZM444.14,75.47h-1.95v-1.95h1.95v1.95ZM441.22,75.47h-1.95v-1.95h1.95v1.95ZM438.3,75.47h-1.95v-1.95h1.95v1.95ZM435.38,75.47h-1.95v-1.95h1.95v1.95ZM432.46,75.47h-1.95v-1.95h1.95v1.95ZM429.54,75.47h-1.95v-1.95h1.95v1.95ZM426.62,75.47h-1.95v-1.95h1.95v1.95ZM423.7,75.47h-1.95v-1.95h1.95v1.95ZM420.78,75.47h-1.95v-1.95h1.95v1.95ZM417.86,75.47h-1.95v-1.95h1.95v1.95ZM414.94,75.47h-1.95v-1.95h1.95v1.95ZM412.02,75.47h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,72.54h-1.95v-1.95h1.95v1.95ZM476.27,72.54h-1.95v-1.95h1.95v1.95ZM473.35,72.54h-1.95v-1.95h1.95v1.95ZM470.43,72.54h-1.95v-1.95h1.95v1.95ZM467.51,72.54h-1.95v-1.95h1.95v1.95ZM464.59,72.54h-1.95v-1.95h1.95v1.95ZM461.67,72.54h-1.95v-1.95h1.95v1.95ZM458.75,72.54h-1.95v-1.95h1.95v1.95ZM455.82,72.54h-1.95v-1.95h1.95v1.95ZM452.9,72.54h-1.95v-1.95h1.95v1.95ZM449.98,72.54h-1.95v-1.95h1.95v1.95ZM447.06,72.54h-1.95v-1.95h1.95v1.95ZM444.14,72.54h-1.95v-1.95h1.95v1.95ZM441.22,72.54h-1.95v-1.95h1.95v1.95ZM438.3,72.54h-1.95v-1.95h1.95v1.95ZM435.38,72.54h-1.95v-1.95h1.95v1.95ZM432.46,72.54h-1.95v-1.95h1.95v1.95ZM429.54,72.54h-1.95v-1.95h1.95v1.95ZM426.62,72.54h-1.95v-1.95h1.95v1.95ZM423.7,72.54h-1.95v-1.95h1.95v1.95ZM420.78,72.54h-1.95v-1.95h1.95v1.95ZM417.86,72.54h-1.95v-1.95h1.95v1.95ZM414.94,72.54h-1.95v-1.95h1.95v1.95ZM412.02,72.54h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,69.62h-1.95v-1.95h1.95v1.95ZM476.27,69.62h-1.95v-1.95h1.95v1.95ZM473.35,69.62h-1.95v-1.95h1.95v1.95ZM470.43,69.62h-1.95v-1.95h1.95v1.95ZM467.51,69.62h-1.95v-1.95h1.95v1.95ZM464.59,69.62h-1.95v-1.95h1.95v1.95ZM461.67,69.62h-1.95v-1.95h1.95v1.95ZM458.75,69.62h-1.95v-1.95h1.95v1.95ZM455.82,69.62h-1.95v-1.95h1.95v1.95ZM452.9,69.62h-1.95v-1.95h1.95v1.95ZM449.98,69.62h-1.95v-1.95h1.95v1.95ZM447.06,69.62h-1.95v-1.95h1.95v1.95ZM444.14,69.62h-1.95v-1.95h1.95v1.95ZM441.22,69.62h-1.95v-1.95h1.95v1.95ZM438.3,69.62h-1.95v-1.95h1.95v1.95ZM435.38,69.62h-1.95v-1.95h1.95v1.95ZM432.46,69.62h-1.95v-1.95h1.95v1.95ZM429.54,69.62h-1.95v-1.95h1.95v1.95ZM426.62,69.62h-1.95v-1.95h1.95v1.95ZM423.7,69.62h-1.95v-1.95h1.95v1.95ZM420.78,69.62h-1.95v-1.95h1.95v1.95ZM417.86,69.62h-1.95v-1.95h1.95v1.95ZM414.94,69.62h-1.95v-1.95h1.95v1.95ZM412.02,69.62h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,66.7h-1.95v-1.95h1.95v1.95ZM476.27,66.7h-1.95v-1.95h1.95v1.95ZM473.35,66.7h-1.95v-1.95h1.95v1.95ZM470.43,66.7h-1.95v-1.95h1.95v1.95ZM467.51,66.7h-1.95v-1.95h1.95v1.95ZM464.59,66.7h-1.95v-1.95h1.95v1.95ZM461.67,66.7h-1.95v-1.95h1.95v1.95ZM458.75,66.7h-1.95v-1.95h1.95v1.95ZM455.82,66.7h-1.95v-1.95h1.95v1.95ZM452.9,66.7h-1.95v-1.95h1.95v1.95ZM449.98,66.7h-1.95v-1.95h1.95v1.95ZM447.06,66.7h-1.95v-1.95h1.95v1.95ZM444.14,66.7h-1.95v-1.95h1.95v1.95ZM441.22,66.7h-1.95v-1.95h1.95v1.95ZM438.3,66.7h-1.95v-1.95h1.95v1.95ZM435.38,66.7h-1.95v-1.95h1.95v1.95ZM432.46,66.7h-1.95v-1.95h1.95v1.95ZM429.54,66.7h-1.95v-1.95h1.95v1.95ZM426.62,66.7h-1.95v-1.95h1.95v1.95ZM423.7,66.7h-1.95v-1.95h1.95v1.95ZM420.78,66.7h-1.95v-1.95h1.95v1.95ZM417.86,66.7h-1.95v-1.95h1.95v1.95ZM414.94,66.7h-1.95v-1.95h1.95v1.95ZM412.02,66.7h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,63.78h-1.95v-1.95h1.95v1.95ZM476.27,63.78h-1.95v-1.95h1.95v1.95ZM473.35,63.78h-1.95v-1.95h1.95v1.95ZM470.43,63.78h-1.95v-1.95h1.95v1.95ZM467.51,63.78h-1.95v-1.95h1.95v1.95ZM464.59,63.78h-1.95v-1.95h1.95v1.95ZM461.67,63.78h-1.95v-1.95h1.95v1.95ZM458.75,63.78h-1.95v-1.95h1.95v1.95ZM455.82,63.78h-1.95v-1.95h1.95v1.95ZM452.9,63.78h-1.95v-1.95h1.95v1.95ZM449.98,63.78h-1.95v-1.95h1.95v1.95ZM447.06,63.78h-1.95v-1.95h1.95v1.95ZM444.14,63.78h-1.95v-1.95h1.95v1.95ZM441.22,63.78h-1.95v-1.95h1.95v1.95ZM438.3,63.78h-1.95v-1.95h1.95v1.95ZM435.38,63.78h-1.95v-1.95h1.95v1.95ZM432.46,63.78h-1.95v-1.95h1.95v1.95ZM429.54,63.78h-1.95v-1.95h1.95v1.95ZM426.62,63.78h-1.95v-1.95h1.95v1.95ZM423.7,63.78h-1.95v-1.95h1.95v1.95ZM420.78,63.78h-1.95v-1.95h1.95v1.95ZM417.86,63.78h-1.95v-1.95h1.95v1.95ZM414.94,63.78h-1.95v-1.95h1.95v1.95ZM412.02,63.78h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,60.86h-1.95v-1.95h1.95v1.95ZM476.27,60.86h-1.95v-1.95h1.95v1.95ZM473.35,60.86h-1.95v-1.95h1.95v1.95ZM470.43,60.86h-1.95v-1.95h1.95v1.95ZM467.51,60.86h-1.95v-1.95h1.95v1.95ZM464.59,60.86h-1.95v-1.95h1.95v1.95ZM461.67,60.86h-1.95v-1.95h1.95v1.95ZM458.75,60.86h-1.95v-1.95h1.95v1.95ZM455.82,60.86h-1.95v-1.95h1.95v1.95ZM452.9,60.86h-1.95v-1.95h1.95v1.95ZM449.98,60.86h-1.95v-1.95h1.95v1.95ZM447.06,60.86h-1.95v-1.95h1.95v1.95ZM444.14,60.86h-1.95v-1.95h1.95v1.95ZM441.22,60.86h-1.95v-1.95h1.95v1.95ZM438.3,60.86h-1.95v-1.95h1.95v1.95ZM435.38,60.86h-1.95v-1.95h1.95v1.95ZM432.46,60.86h-1.95v-1.95h1.95v1.95ZM429.54,60.86h-1.95v-1.95h1.95v1.95ZM426.62,60.86h-1.95v-1.95h1.95v1.95ZM423.7,60.86h-1.95v-1.95h1.95v1.95ZM420.78,60.86h-1.95v-1.95h1.95v1.95ZM417.86,60.86h-1.95v-1.95h1.95v1.95ZM414.94,60.86h-1.95v-1.95h1.95v1.95ZM412.02,60.86h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,57.94h-1.95v-1.95h1.95v1.95ZM476.27,57.94h-1.95v-1.95h1.95v1.95ZM473.35,57.94h-1.95v-1.95h1.95v1.95ZM470.43,57.94h-1.95v-1.95h1.95v1.95ZM467.51,57.94h-1.95v-1.95h1.95v1.95ZM464.59,57.94h-1.95v-1.95h1.95v1.95ZM461.67,57.94h-1.95v-1.95h1.95v1.95ZM458.75,57.94h-1.95v-1.95h1.95v1.95ZM455.82,57.94h-1.95v-1.95h1.95v1.95ZM452.9,57.94h-1.95v-1.95h1.95v1.95ZM449.98,57.94h-1.95v-1.95h1.95v1.95ZM447.06,57.94h-1.95v-1.95h1.95v1.95ZM444.14,57.94h-1.95v-1.95h1.95v1.95ZM441.22,57.94h-1.95v-1.95h1.95v1.95ZM438.3,57.94h-1.95v-1.95h1.95v1.95ZM435.38,57.94h-1.95v-1.95h1.95v1.95ZM432.46,57.94h-1.95v-1.95h1.95v1.95ZM429.54,57.94h-1.95v-1.95h1.95v1.95ZM426.62,57.94h-1.95v-1.95h1.95v1.95ZM423.7,57.94h-1.95v-1.95h1.95v1.95ZM420.78,57.94h-1.95v-1.95h1.95v1.95ZM417.86,57.94h-1.95v-1.95h1.95v1.95ZM414.94,57.94h-1.95v-1.95h1.95v1.95ZM412.02,57.94h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-13)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.19,55.02h-1.95v-1.95h1.95v1.95ZM476.27,55.02h-1.95v-1.95h1.95v1.95ZM473.35,55.02h-1.95v-1.95h1.95v1.95ZM470.43,55.02h-1.95v-1.95h1.95v1.95ZM467.51,55.02h-1.95v-1.95h1.95v1.95ZM464.59,55.02h-1.95v-1.95h1.95v1.95ZM461.67,55.02h-1.95v-1.95h1.95v1.95ZM458.75,55.02h-1.95v-1.95h1.95v1.95ZM455.82,55.02h-1.95v-1.95h1.95v1.95ZM452.9,55.02h-1.95v-1.95h1.95v1.95ZM449.98,55.02h-1.95v-1.95h1.95v1.95ZM447.06,55.02h-1.95v-1.95h1.95v1.95ZM444.14,55.02h-1.95v-1.95h1.95v1.95ZM441.22,55.02h-1.95v-1.95h1.95v1.95ZM438.3,55.02h-1.95v-1.95h1.95v1.95ZM435.38,55.02h-1.95v-1.95h1.95v1.95ZM432.46,55.02h-1.95v-1.95h1.95v1.95ZM429.54,55.02h-1.95v-1.95h1.95v1.95ZM426.62,55.02h-1.95v-1.95h1.95v1.95ZM423.7,55.02h-1.95v-1.95h1.95v1.95ZM420.78,55.02h-1.95v-1.95h1.95v1.95ZM417.86,55.02h-1.95v-1.95h1.95v1.95ZM414.94,55.02h-1.95v-1.95h1.95v1.95ZM412.02,55.02h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,52.1h-1.95v-1.95h1.95v1.95ZM476.27,52.1h-1.95v-1.95h1.95v1.95ZM473.35,52.1h-1.95v-1.95h1.95v1.95ZM470.43,52.1h-1.95v-1.95h1.95v1.95ZM467.51,52.1h-1.95v-1.95h1.95v1.95ZM464.59,52.1h-1.95v-1.95h1.95v1.95ZM461.67,52.1h-1.95v-1.95h1.95v1.95ZM458.75,52.1h-1.95v-1.95h1.95v1.95ZM455.82,52.1h-1.95v-1.95h1.95v1.95ZM452.9,52.1h-1.95v-1.95h1.95v1.95ZM449.98,52.1h-1.95v-1.95h1.95v1.95ZM447.06,52.1h-1.95v-1.95h1.95v1.95ZM444.14,52.1h-1.95v-1.95h1.95v1.95ZM441.22,52.1h-1.95v-1.95h1.95v1.95ZM438.3,52.1h-1.95v-1.95h1.95v1.95ZM435.38,52.1h-1.95v-1.95h1.95v1.95ZM432.46,52.1h-1.95v-1.95h1.95v1.95ZM429.54,52.1h-1.95v-1.95h1.95v1.95ZM426.62,52.1h-1.95v-1.95h1.95v1.95ZM423.7,52.1h-1.95v-1.95h1.95v1.95ZM420.78,52.1h-1.95v-1.95h1.95v1.95ZM417.86,52.1h-1.95v-1.95h1.95v1.95ZM414.94,52.1h-1.95v-1.95h1.95v1.95ZM412.02,52.1h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,49.18h-1.95v-1.95h1.95v1.95ZM476.27,49.18h-1.95v-1.95h1.95v1.95ZM473.35,49.18h-1.95v-1.95h1.95v1.95ZM470.43,49.18h-1.95v-1.95h1.95v1.95ZM467.51,49.18h-1.95v-1.95h1.95v1.95ZM464.59,49.18h-1.95v-1.95h1.95v1.95ZM461.67,49.18h-1.95v-1.95h1.95v1.95ZM458.75,49.18h-1.95v-1.95h1.95v1.95ZM455.82,49.18h-1.95v-1.95h1.95v1.95ZM452.9,49.18h-1.95v-1.95h1.95v1.95ZM449.98,49.18h-1.95v-1.95h1.95v1.95ZM447.06,49.18h-1.95v-1.95h1.95v1.95ZM444.14,49.18h-1.95v-1.95h1.95v1.95ZM441.22,49.18h-1.95v-1.95h1.95v1.95ZM438.3,49.18h-1.95v-1.95h1.95v1.95ZM435.38,49.18h-1.95v-1.95h1.95v1.95ZM432.46,49.18h-1.95v-1.95h1.95v1.95ZM429.54,49.18h-1.95v-1.95h1.95v1.95ZM426.62,49.18h-1.95v-1.95h1.95v1.95ZM423.7,49.18h-1.95v-1.95h1.95v1.95ZM420.78,49.18h-1.95v-1.95h1.95v1.95ZM417.86,49.18h-1.95v-1.95h1.95v1.95ZM414.94,49.18h-1.95v-1.95h1.95v1.95ZM412.02,49.18h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,46.26h-1.95v-1.95h1.95v1.95ZM476.27,46.26h-1.95v-1.95h1.95v1.95ZM473.35,46.26h-1.95v-1.95h1.95v1.95ZM470.43,46.26h-1.95v-1.95h1.95v1.95ZM467.51,46.26h-1.95v-1.95h1.95v1.95ZM464.59,46.26h-1.95v-1.95h1.95v1.95ZM461.67,46.26h-1.95v-1.95h1.95v1.95ZM458.75,46.26h-1.95v-1.95h1.95v1.95ZM455.82,46.26h-1.95v-1.95h1.95v1.95ZM452.9,46.26h-1.95v-1.95h1.95v1.95ZM449.98,46.26h-1.95v-1.95h1.95v1.95ZM447.06,46.26h-1.95v-1.95h1.95v1.95ZM444.14,46.26h-1.95v-1.95h1.95v1.95ZM441.22,46.26h-1.95v-1.95h1.95v1.95ZM438.3,46.26h-1.95v-1.95h1.95v1.95ZM435.38,46.26h-1.95v-1.95h1.95v1.95ZM432.46,46.26h-1.95v-1.95h1.95v1.95ZM429.54,46.26h-1.95v-1.95h1.95v1.95ZM426.62,46.26h-1.95v-1.95h1.95v1.95ZM423.7,46.26h-1.95v-1.95h1.95v1.95ZM420.78,46.26h-1.95v-1.95h1.95v1.95ZM417.86,46.26h-1.95v-1.95h1.95v1.95ZM414.94,46.26h-1.95v-1.95h1.95v1.95ZM412.02,46.26h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,43.34h-1.95v-1.95h1.95v1.95ZM476.27,43.34h-1.95v-1.95h1.95v1.95ZM473.35,43.34h-1.95v-1.95h1.95v1.95ZM470.43,43.34h-1.95v-1.95h1.95v1.95ZM467.51,43.34h-1.95v-1.95h1.95v1.95ZM464.59,43.34h-1.95v-1.95h1.95v1.95ZM461.67,43.34h-1.95v-1.95h1.95v1.95ZM458.75,43.34h-1.95v-1.95h1.95v1.95ZM455.82,43.34h-1.95v-1.95h1.95v1.95ZM452.9,43.34h-1.95v-1.95h1.95v1.95ZM449.98,43.34h-1.95v-1.95h1.95v1.95ZM447.06,43.34h-1.95v-1.95h1.95v1.95ZM444.14,43.34h-1.95v-1.95h1.95v1.95ZM441.22,43.34h-1.95v-1.95h1.95v1.95ZM438.3,43.34h-1.95v-1.95h1.95v1.95ZM435.38,43.34h-1.95v-1.95h1.95v1.95ZM432.46,43.34h-1.95v-1.95h1.95v1.95ZM429.54,43.34h-1.95v-1.95h1.95v1.95ZM426.62,43.34h-1.95v-1.95h1.95v1.95ZM423.7,43.34h-1.95v-1.95h1.95v1.95ZM420.78,43.34h-1.95v-1.95h1.95v1.95ZM417.86,43.34h-1.95v-1.95h1.95v1.95ZM414.94,43.34h-1.95v-1.95h1.95v1.95ZM412.02,43.34h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,40.42h-1.95v-1.95h1.95v1.95ZM476.27,40.42h-1.95v-1.95h1.95v1.95ZM473.35,40.42h-1.95v-1.95h1.95v1.95ZM470.43,40.42h-1.95v-1.95h1.95v1.95ZM467.51,40.42h-1.95v-1.95h1.95v1.95ZM464.59,40.42h-1.95v-1.95h1.95v1.95ZM461.67,40.42h-1.95v-1.95h1.95v1.95ZM458.75,40.42h-1.95v-1.95h1.95v1.95ZM455.82,40.42h-1.95v-1.95h1.95v1.95ZM452.9,40.42h-1.95v-1.95h1.95v1.95ZM449.98,40.42h-1.95v-1.95h1.95v1.95ZM447.06,40.42h-1.95v-1.95h1.95v1.95ZM444.14,40.42h-1.95v-1.95h1.95v1.95ZM441.22,40.42h-1.95v-1.95h1.95v1.95ZM438.3,40.42h-1.95v-1.95h1.95v1.95ZM435.38,40.42h-1.95v-1.95h1.95v1.95ZM432.46,40.42h-1.95v-1.95h1.95v1.95ZM429.54,40.42h-1.95v-1.95h1.95v1.95ZM426.62,40.42h-1.95v-1.95h1.95v1.95ZM423.7,40.42h-1.95v-1.95h1.95v1.95ZM420.78,40.42h-1.95v-1.95h1.95v1.95ZM417.86,40.42h-1.95v-1.95h1.95v1.95ZM414.94,40.42h-1.95v-1.95h1.95v1.95ZM412.02,40.42h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,37.5h-1.95v-1.95h1.95v1.95ZM476.27,37.5h-1.95v-1.95h1.95v1.95ZM473.35,37.5h-1.95v-1.95h1.95v1.95ZM470.43,37.5h-1.95v-1.95h1.95v1.95ZM467.51,37.5h-1.95v-1.95h1.95v1.95ZM464.59,37.5h-1.95v-1.95h1.95v1.95ZM461.67,37.5h-1.95v-1.95h1.95v1.95ZM458.75,37.5h-1.95v-1.95h1.95v1.95ZM455.82,37.5h-1.95v-1.95h1.95v1.95ZM452.9,37.5h-1.95v-1.95h1.95v1.95ZM449.98,37.5h-1.95v-1.95h1.95v1.95ZM447.06,37.5h-1.95v-1.95h1.95v1.95ZM444.14,37.5h-1.95v-1.95h1.95v1.95ZM441.22,37.5h-1.95v-1.95h1.95v1.95ZM438.3,37.5h-1.95v-1.95h1.95v1.95ZM435.38,37.5h-1.95v-1.95h1.95v1.95ZM432.46,37.5h-1.95v-1.95h1.95v1.95ZM429.54,37.5h-1.95v-1.95h1.95v1.95ZM426.62,37.5h-1.95v-1.95h1.95v1.95ZM423.7,37.5h-1.95v-1.95h1.95v1.95ZM420.78,37.5h-1.95v-1.95h1.95v1.95ZM417.86,37.5h-1.95v-1.95h1.95v1.95ZM414.94,37.5h-1.95v-1.95h1.95v1.95ZM412.02,37.5h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,34.58h-1.95v-1.95h1.95v1.95ZM476.27,34.58h-1.95v-1.95h1.95v1.95ZM473.35,34.58h-1.95v-1.95h1.95v1.95ZM470.43,34.58h-1.95v-1.95h1.95v1.95ZM467.51,34.58h-1.95v-1.95h1.95v1.95ZM464.59,34.58h-1.95v-1.95h1.95v1.95ZM461.67,34.58h-1.95v-1.95h1.95v1.95ZM458.75,34.58h-1.95v-1.95h1.95v1.95ZM455.82,34.58h-1.95v-1.95h1.95v1.95ZM452.9,34.58h-1.95v-1.95h1.95v1.95ZM449.98,34.58h-1.95v-1.95h1.95v1.95ZM447.06,34.58h-1.95v-1.95h1.95v1.95ZM444.14,34.58h-1.95v-1.95h1.95v1.95ZM441.22,34.58h-1.95v-1.95h1.95v1.95ZM438.3,34.58h-1.95v-1.95h1.95v1.95ZM435.38,34.58h-1.95v-1.95h1.95v1.95ZM432.46,34.58h-1.95v-1.95h1.95v1.95ZM429.54,34.58h-1.95v-1.95h1.95v1.95ZM426.62,34.58h-1.95v-1.95h1.95v1.95ZM423.7,34.58h-1.95v-1.95h1.95v1.95ZM420.78,34.58h-1.95v-1.95h1.95v1.95ZM417.86,34.58h-1.95v-1.95h1.95v1.95ZM414.94,34.58h-1.95v-1.95h1.95v1.95ZM412.02,34.58h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,31.66h-1.95v-1.95h1.95v1.95ZM476.27,31.66h-1.95v-1.95h1.95v1.95ZM473.35,31.66h-1.95v-1.95h1.95v1.95ZM470.43,31.66h-1.95v-1.95h1.95v1.95ZM467.51,31.66h-1.95v-1.95h1.95v1.95ZM464.59,31.66h-1.95v-1.95h1.95v1.95ZM461.67,31.66h-1.95v-1.95h1.95v1.95ZM458.75,31.66h-1.95v-1.95h1.95v1.95ZM455.82,31.66h-1.95v-1.95h1.95v1.95ZM452.9,31.66h-1.95v-1.95h1.95v1.95ZM449.98,31.66h-1.95v-1.95h1.95v1.95ZM447.06,31.66h-1.95v-1.95h1.95v1.95ZM444.14,31.66h-1.95v-1.95h1.95v1.95ZM441.22,31.66h-1.95v-1.95h1.95v1.95ZM438.3,31.66h-1.95v-1.95h1.95v1.95ZM435.38,31.66h-1.95v-1.95h1.95v1.95ZM432.46,31.66h-1.95v-1.95h1.95v1.95ZM429.54,31.66h-1.95v-1.95h1.95v1.95ZM426.62,31.66h-1.95v-1.95h1.95v1.95ZM423.7,31.66h-1.95v-1.95h1.95v1.95ZM420.78,31.66h-1.95v-1.95h1.95v1.95ZM417.86,31.66h-1.95v-1.95h1.95v1.95ZM414.94,31.66h-1.95v-1.95h1.95v1.95ZM412.02,31.66h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,28.74h-1.95v-1.95h1.95v1.95ZM476.27,28.74h-1.95v-1.95h1.95v1.95ZM473.35,28.74h-1.95v-1.95h1.95v1.95ZM470.43,28.74h-1.95v-1.95h1.95v1.95ZM467.51,28.74h-1.95v-1.95h1.95v1.95ZM464.59,28.74h-1.95v-1.95h1.95v1.95ZM461.67,28.74h-1.95v-1.95h1.95v1.95ZM458.75,28.74h-1.95v-1.95h1.95v1.95ZM455.82,28.74h-1.95v-1.95h1.95v1.95ZM452.9,28.74h-1.95v-1.95h1.95v1.95ZM449.98,28.74h-1.95v-1.95h1.95v1.95ZM447.06,28.74h-1.95v-1.95h1.95v1.95ZM444.14,28.74h-1.95v-1.95h1.95v1.95ZM441.22,28.74h-1.95v-1.95h1.95v1.95ZM438.3,28.74h-1.95v-1.95h1.95v1.95ZM435.38,28.74h-1.95v-1.95h1.95v1.95ZM432.46,28.74h-1.95v-1.95h1.95v1.95ZM429.54,28.74h-1.95v-1.95h1.95v1.95ZM426.62,28.74h-1.95v-1.95h1.95v1.95ZM423.7,28.74h-1.95v-1.95h1.95v1.95ZM420.78,28.74h-1.95v-1.95h1.95v1.95ZM417.86,28.74h-1.95v-1.95h1.95v1.95ZM414.94,28.74h-1.95v-1.95h1.95v1.95ZM412.02,28.74h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,25.82h-1.95v-1.95h1.95v1.95ZM476.27,25.82h-1.95v-1.95h1.95v1.95ZM473.35,25.82h-1.95v-1.95h1.95v1.95ZM470.43,25.82h-1.95v-1.95h1.95v1.95ZM467.51,25.82h-1.95v-1.95h1.95v1.95ZM464.59,25.82h-1.95v-1.95h1.95v1.95ZM461.67,25.82h-1.95v-1.95h1.95v1.95ZM458.75,25.82h-1.95v-1.95h1.95v1.95ZM455.82,25.82h-1.95v-1.95h1.95v1.95ZM452.9,25.82h-1.95v-1.95h1.95v1.95ZM449.98,25.82h-1.95v-1.95h1.95v1.95ZM447.06,25.82h-1.95v-1.95h1.95v1.95ZM444.14,25.82h-1.95v-1.95h1.95v1.95ZM441.22,25.82h-1.95v-1.95h1.95v1.95ZM438.3,25.82h-1.95v-1.95h1.95v1.95ZM435.38,25.82h-1.95v-1.95h1.95v1.95ZM432.46,25.82h-1.95v-1.95h1.95v1.95ZM429.54,25.82h-1.95v-1.95h1.95v1.95ZM426.62,25.82h-1.95v-1.95h1.95v1.95ZM423.7,25.82h-1.95v-1.95h1.95v1.95ZM420.78,25.82h-1.95v-1.95h1.95v1.95ZM417.86,25.82h-1.95v-1.95h1.95v1.95ZM414.94,25.82h-1.95v-1.95h1.95v1.95ZM412.02,25.82h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,22.9h-1.95v-1.95h1.95v1.95ZM476.27,22.9h-1.95v-1.95h1.95v1.95ZM473.35,22.9h-1.95v-1.95h1.95v1.95ZM470.43,22.9h-1.95v-1.95h1.95v1.95ZM467.51,22.9h-1.95v-1.95h1.95v1.95ZM464.59,22.9h-1.95v-1.95h1.95v1.95ZM461.67,22.9h-1.95v-1.95h1.95v1.95ZM458.75,22.9h-1.95v-1.95h1.95v1.95ZM455.82,22.9h-1.95v-1.95h1.95v1.95ZM452.9,22.9h-1.95v-1.95h1.95v1.95ZM449.98,22.9h-1.95v-1.95h1.95v1.95ZM447.06,22.9h-1.95v-1.95h1.95v1.95ZM444.14,22.9h-1.95v-1.95h1.95v1.95ZM441.22,22.9h-1.95v-1.95h1.95v1.95ZM438.3,22.9h-1.95v-1.95h1.95v1.95ZM435.38,22.9h-1.95v-1.95h1.95v1.95ZM432.46,22.9h-1.95v-1.95h1.95v1.95ZM429.54,22.9h-1.95v-1.95h1.95v1.95ZM426.62,22.9h-1.95v-1.95h1.95v1.95ZM423.7,22.9h-1.95v-1.95h1.95v1.95ZM420.78,22.9h-1.95v-1.95h1.95v1.95ZM417.86,22.9h-1.95v-1.95h1.95v1.95ZM414.94,22.9h-1.95v-1.95h1.95v1.95ZM412.02,22.9h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,19.98h-1.95v-1.95h1.95v1.95ZM476.27,19.98h-1.95v-1.95h1.95v1.95ZM473.35,19.98h-1.95v-1.95h1.95v1.95ZM470.43,19.98h-1.95v-1.95h1.95v1.95ZM467.51,19.98h-1.95v-1.95h1.95v1.95ZM464.59,19.98h-1.95v-1.95h1.95v1.95ZM461.67,19.98h-1.95v-1.95h1.95v1.95ZM458.75,19.98h-1.95v-1.95h1.95v1.95ZM455.82,19.98h-1.95v-1.95h1.95v1.95ZM452.9,19.98h-1.95v-1.95h1.95v1.95ZM449.98,19.98h-1.95v-1.95h1.95v1.95ZM447.06,19.98h-1.95v-1.95h1.95v1.95ZM444.14,19.98h-1.95v-1.95h1.95v1.95ZM441.22,19.98h-1.95v-1.95h1.95v1.95ZM438.3,19.98h-1.95v-1.95h1.95v1.95ZM435.38,19.98h-1.95v-1.95h1.95v1.95ZM432.46,19.98h-1.95v-1.95h1.95v1.95ZM429.54,19.98h-1.95v-1.95h1.95v1.95ZM426.62,19.98h-1.95v-1.95h1.95v1.95ZM423.7,19.98h-1.95v-1.95h1.95v1.95ZM420.78,19.98h-1.95v-1.95h1.95v1.95ZM417.86,19.98h-1.95v-1.95h1.95v1.95ZM414.94,19.98h-1.95v-1.95h1.95v1.95ZM412.02,19.98h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,17.06h-1.95v-1.95h1.95v1.95ZM476.27,17.06h-1.95v-1.95h1.95v1.95ZM473.35,17.06h-1.95v-1.95h1.95v1.95ZM470.43,17.06h-1.95v-1.95h1.95v1.95ZM467.51,17.06h-1.95v-1.95h1.95v1.95ZM464.59,17.06h-1.95v-1.95h1.95v1.95ZM461.67,17.06h-1.95v-1.95h1.95v1.95ZM458.75,17.06h-1.95v-1.95h1.95v1.95ZM455.82,17.06h-1.95v-1.95h1.95v1.95ZM452.9,17.06h-1.95v-1.95h1.95v1.95ZM449.98,17.06h-1.95v-1.95h1.95v1.95ZM447.06,17.06h-1.95v-1.95h1.95v1.95ZM444.14,17.06h-1.95v-1.95h1.95v1.95ZM441.22,17.06h-1.95v-1.95h1.95v1.95ZM438.3,17.06h-1.95v-1.95h1.95v1.95ZM435.38,17.06h-1.95v-1.95h1.95v1.95ZM432.46,17.06h-1.95v-1.95h1.95v1.95ZM429.54,17.06h-1.95v-1.95h1.95v1.95ZM426.62,17.06h-1.95v-1.95h1.95v1.95ZM423.7,17.06h-1.95v-1.95h1.95v1.95ZM420.78,17.06h-1.95v-1.95h1.95v1.95ZM417.86,17.06h-1.95v-1.95h1.95v1.95ZM414.94,17.06h-1.95v-1.95h1.95v1.95ZM412.02,17.06h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,14.14h-1.95v-1.95h1.95v1.95ZM476.27,14.14h-1.95v-1.95h1.95v1.95ZM473.35,14.14h-1.95v-1.95h1.95v1.95ZM470.43,14.14h-1.95v-1.95h1.95v1.95ZM467.51,14.14h-1.95v-1.95h1.95v1.95ZM464.59,14.14h-1.95v-1.95h1.95v1.95ZM461.67,14.14h-1.95v-1.95h1.95v1.95ZM458.75,14.14h-1.95v-1.95h1.95v1.95ZM455.82,14.14h-1.95v-1.95h1.95v1.95ZM452.9,14.14h-1.95v-1.95h1.95v1.95ZM449.98,14.14h-1.95v-1.95h1.95v1.95ZM447.06,14.14h-1.95v-1.95h1.95v1.95ZM444.14,14.14h-1.95v-1.95h1.95v1.95ZM441.22,14.14h-1.95v-1.95h1.95v1.95ZM438.3,14.14h-1.95v-1.95h1.95v1.95ZM435.38,14.14h-1.95v-1.95h1.95v1.95ZM432.46,14.14h-1.95v-1.95h1.95v1.95ZM429.54,14.14h-1.95v-1.95h1.95v1.95ZM426.62,14.14h-1.95v-1.95h1.95v1.95ZM423.7,14.14h-1.95v-1.95h1.95v1.95ZM420.78,14.14h-1.95v-1.95h1.95v1.95ZM417.86,14.14h-1.95v-1.95h1.95v1.95ZM414.94,14.14h-1.95v-1.95h1.95v1.95ZM412.02,14.14h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,11.22h-1.95v-1.95h1.95v1.95ZM476.27,11.22h-1.95v-1.95h1.95v1.95ZM473.35,11.22h-1.95v-1.95h1.95v1.95ZM470.43,11.22h-1.95v-1.95h1.95v1.95ZM467.51,11.22h-1.95v-1.95h1.95v1.95ZM464.59,11.22h-1.95v-1.95h1.95v1.95ZM461.67,11.22h-1.95v-1.95h1.95v1.95ZM458.75,11.22h-1.95v-1.95h1.95v1.95ZM455.82,11.22h-1.95v-1.95h1.95v1.95ZM452.9,11.22h-1.95v-1.95h1.95v1.95ZM449.98,11.22h-1.95v-1.95h1.95v1.95ZM447.06,11.22h-1.95v-1.95h1.95v1.95ZM444.14,11.22h-1.95v-1.95h1.95v1.95ZM441.22,11.22h-1.95v-1.95h1.95v1.95ZM438.3,11.22h-1.95v-1.95h1.95v1.95ZM435.38,11.22h-1.95v-1.95h1.95v1.95ZM432.46,11.22h-1.95v-1.95h1.95v1.95ZM429.54,11.22h-1.95v-1.95h1.95v1.95ZM426.62,11.22h-1.95v-1.95h1.95v1.95ZM423.7,11.22h-1.95v-1.95h1.95v1.95ZM420.78,11.22h-1.95v-1.95h1.95v1.95ZM417.86,11.22h-1.95v-1.95h1.95v1.95ZM414.94,11.22h-1.95v-1.95h1.95v1.95ZM412.02,11.22h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,8.3h-1.95v-1.95h1.95v1.95ZM476.27,8.3h-1.95v-1.95h1.95v1.95ZM473.35,8.3h-1.95v-1.95h1.95v1.95ZM470.43,8.3h-1.95v-1.95h1.95v1.95ZM467.51,8.3h-1.95v-1.95h1.95v1.95ZM464.59,8.3h-1.95v-1.95h1.95v1.95ZM461.67,8.3h-1.95v-1.95h1.95v1.95ZM458.75,8.3h-1.95v-1.95h1.95v1.95ZM455.82,8.3h-1.95v-1.95h1.95v1.95ZM452.9,8.3h-1.95v-1.95h1.95v1.95ZM449.98,8.3h-1.95v-1.95h1.95v1.95ZM447.06,8.3h-1.95v-1.95h1.95v1.95ZM444.14,8.3h-1.95v-1.95h1.95v1.95ZM441.22,8.3h-1.95v-1.95h1.95v1.95ZM438.3,8.3h-1.95v-1.95h1.95v1.95ZM435.38,8.3h-1.95v-1.95h1.95v1.95ZM432.46,8.3h-1.95v-1.95h1.95v1.95ZM429.54,8.3h-1.95v-1.95h1.95v1.95ZM426.62,8.3h-1.95v-1.95h1.95v1.95ZM423.7,8.3h-1.95v-1.95h1.95v1.95ZM420.78,8.3h-1.95v-1.95h1.95v1.95ZM417.86,8.3h-1.95v-1.95h1.95v1.95ZM414.94,8.3h-1.95v-1.95h1.95v1.95ZM412.02,8.3h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,5.38h-1.95v-1.95h1.95v1.95ZM476.27,5.38h-1.95v-1.95h1.95v1.95ZM473.35,5.38h-1.95v-1.95h1.95v1.95ZM470.43,5.38h-1.95v-1.95h1.95v1.95ZM467.51,5.38h-1.95v-1.95h1.95v1.95ZM464.59,5.38h-1.95v-1.95h1.95v1.95ZM461.67,5.38h-1.95v-1.95h1.95v1.95ZM458.75,5.38h-1.95v-1.95h1.95v1.95ZM455.82,5.38h-1.95v-1.95h1.95v1.95ZM452.9,5.38h-1.95v-1.95h1.95v1.95ZM449.98,5.38h-1.95v-1.95h1.95v1.95ZM447.06,5.38h-1.95v-1.95h1.95v1.95ZM444.14,5.38h-1.95v-1.95h1.95v1.95ZM441.22,5.38h-1.95v-1.95h1.95v1.95ZM438.3,5.38h-1.95v-1.95h1.95v1.95ZM435.38,5.38h-1.95v-1.95h1.95v1.95ZM432.46,5.38h-1.95v-1.95h1.95v1.95ZM429.54,5.38h-1.95v-1.95h1.95v1.95ZM426.62,5.38h-1.95v-1.95h1.95v1.95ZM423.7,5.38h-1.95v-1.95h1.95v1.95ZM420.78,5.38h-1.95v-1.95h1.95v1.95ZM417.86,5.38h-1.95v-1.95h1.95v1.95ZM414.94,5.38h-1.95v-1.95h1.95v1.95ZM412.02,5.38h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,2.46h-1.95V.51h1.95v1.95ZM476.27,2.46h-1.95V.51h1.95v1.95ZM473.35,2.46h-1.95V.51h1.95v1.95ZM470.43,2.46h-1.95V.51h1.95v1.95ZM467.51,2.46h-1.95V.51h1.95v1.95ZM464.59,2.46h-1.95V.51h1.95v1.95ZM461.67,2.46h-1.95V.51h1.95v1.95ZM458.75,2.46h-1.95V.51h1.95v1.95ZM455.82,2.46h-1.95V.51h1.95v1.95ZM452.9,2.46h-1.95V.51h1.95v1.95ZM449.98,2.46h-1.95V.51h1.95v1.95ZM447.06,2.46h-1.95V.51h1.95v1.95ZM444.14,2.46h-1.95V.51h1.95v1.95ZM441.22,2.46h-1.95V.51h1.95v1.95ZM438.3,2.46h-1.95V.51h1.95v1.95ZM435.38,2.46h-1.95V.51h1.95v1.95ZM432.46,2.46h-1.95V.51h1.95v1.95ZM429.54,2.46h-1.95V.51h1.95v1.95ZM426.62,2.46h-1.95V.51h1.95v1.95ZM423.7,2.46h-1.95V.51h1.95v1.95ZM420.78,2.46h-1.95V.51h1.95v1.95ZM417.86,2.46h-1.95V.51h1.95v1.95ZM414.94,2.46h-1.95V.51h1.95v1.95ZM412.02,2.46h-1.95V.51h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,55.02h-1.95v-1.95h1.95v1.95ZM406.18,55.02h-1.95v-1.95h1.95v1.95ZM403.26,55.02h-1.95v-1.95h1.95v1.95ZM400.34,55.02h-1.95v-1.95h1.95v1.95ZM397.42,55.02h-1.95v-1.95h1.95v1.95ZM394.5,55.02h-1.95v-1.95h1.95v1.95ZM391.58,55.02h-1.95v-1.95h1.95v1.95ZM388.66,55.02h-1.95v-1.95h1.95v1.95ZM385.74,55.02h-1.95v-1.95h1.95v1.95ZM382.82,55.02h-1.95v-1.95h1.95v1.95ZM379.89,55.02h-1.95v-1.95h1.95v1.95ZM376.97,55.02h-1.95v-1.95h1.95v1.95ZM374.05,55.02h-1.95v-1.95h1.95v1.95ZM371.13,55.02h-1.95v-1.95h1.95v1.95ZM368.21,55.02h-1.95v-1.95h1.95v1.95ZM365.29,55.02h-1.95v-1.95h1.95v1.95ZM362.37,55.02h-1.95v-1.95h1.95v1.95ZM359.45,55.02h-1.95v-1.95h1.95v1.95ZM356.53,55.02h-1.95v-1.95h1.95v1.95ZM353.61,55.02h-1.95v-1.95h1.95v1.95ZM350.69,55.02h-1.95v-1.95h1.95v1.95ZM347.77,55.02h-1.95v-1.95h1.95v1.95ZM344.85,55.02h-1.95v-1.95h1.95v1.95ZM341.93,55.02h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,52.1h-1.95v-1.95h1.95v1.95ZM406.18,52.1h-1.95v-1.95h1.95v1.95ZM403.26,52.1h-1.95v-1.95h1.95v1.95ZM400.34,52.1h-1.95v-1.95h1.95v1.95ZM397.42,52.1h-1.95v-1.95h1.95v1.95ZM394.5,52.1h-1.95v-1.95h1.95v1.95ZM391.58,52.1h-1.95v-1.95h1.95v1.95ZM388.66,52.1h-1.95v-1.95h1.95v1.95ZM385.74,52.1h-1.95v-1.95h1.95v1.95ZM382.82,52.1h-1.95v-1.95h1.95v1.95ZM379.89,52.1h-1.95v-1.95h1.95v1.95ZM376.97,52.1h-1.95v-1.95h1.95v1.95ZM374.05,52.1h-1.95v-1.95h1.95v1.95ZM371.13,52.1h-1.95v-1.95h1.95v1.95ZM368.21,52.1h-1.95v-1.95h1.95v1.95ZM365.29,52.1h-1.95v-1.95h1.95v1.95ZM362.37,52.1h-1.95v-1.95h1.95v1.95ZM359.45,52.1h-1.95v-1.95h1.95v1.95ZM356.53,52.1h-1.95v-1.95h1.95v1.95ZM353.61,52.1h-1.95v-1.95h1.95v1.95ZM350.69,52.1h-1.95v-1.95h1.95v1.95ZM347.77,52.1h-1.95v-1.95h1.95v1.95ZM344.85,52.1h-1.95v-1.95h1.95v1.95ZM341.93,52.1h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,49.18h-1.95v-1.95h1.95v1.95ZM406.18,49.18h-1.95v-1.95h1.95v1.95ZM403.26,49.18h-1.95v-1.95h1.95v1.95ZM400.34,49.18h-1.95v-1.95h1.95v1.95ZM397.42,49.18h-1.95v-1.95h1.95v1.95ZM394.5,49.18h-1.95v-1.95h1.95v1.95ZM391.58,49.18h-1.95v-1.95h1.95v1.95ZM388.66,49.18h-1.95v-1.95h1.95v1.95ZM385.74,49.18h-1.95v-1.95h1.95v1.95ZM382.82,49.18h-1.95v-1.95h1.95v1.95ZM379.89,49.18h-1.95v-1.95h1.95v1.95ZM376.97,49.18h-1.95v-1.95h1.95v1.95ZM374.05,49.18h-1.95v-1.95h1.95v1.95ZM371.13,49.18h-1.95v-1.95h1.95v1.95ZM368.21,49.18h-1.95v-1.95h1.95v1.95ZM365.29,49.18h-1.95v-1.95h1.95v1.95ZM362.37,49.18h-1.95v-1.95h1.95v1.95ZM359.45,49.18h-1.95v-1.95h1.95v1.95ZM356.53,49.18h-1.95v-1.95h1.95v1.95ZM353.61,49.18h-1.95v-1.95h1.95v1.95ZM350.69,49.18h-1.95v-1.95h1.95v1.95ZM347.77,49.18h-1.95v-1.95h1.95v1.95ZM344.85,49.18h-1.95v-1.95h1.95v1.95ZM341.93,49.18h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,46.26h-1.95v-1.95h1.95v1.95ZM406.18,46.26h-1.95v-1.95h1.95v1.95ZM403.26,46.26h-1.95v-1.95h1.95v1.95ZM400.34,46.26h-1.95v-1.95h1.95v1.95ZM397.42,46.26h-1.95v-1.95h1.95v1.95ZM394.5,46.26h-1.95v-1.95h1.95v1.95ZM391.58,46.26h-1.95v-1.95h1.95v1.95ZM388.66,46.26h-1.95v-1.95h1.95v1.95ZM385.74,46.26h-1.95v-1.95h1.95v1.95ZM382.82,46.26h-1.95v-1.95h1.95v1.95ZM379.89,46.26h-1.95v-1.95h1.95v1.95ZM376.97,46.26h-1.95v-1.95h1.95v1.95ZM374.05,46.26h-1.95v-1.95h1.95v1.95ZM371.13,46.26h-1.95v-1.95h1.95v1.95ZM368.21,46.26h-1.95v-1.95h1.95v1.95ZM365.29,46.26h-1.95v-1.95h1.95v1.95ZM362.37,46.26h-1.95v-1.95h1.95v1.95ZM359.45,46.26h-1.95v-1.95h1.95v1.95ZM356.53,46.26h-1.95v-1.95h1.95v1.95ZM353.61,46.26h-1.95v-1.95h1.95v1.95ZM350.69,46.26h-1.95v-1.95h1.95v1.95ZM347.77,46.26h-1.95v-1.95h1.95v1.95ZM344.85,46.26h-1.95v-1.95h1.95v1.95ZM341.93,46.26h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,43.34h-1.95v-1.95h1.95v1.95ZM406.18,43.34h-1.95v-1.95h1.95v1.95ZM403.26,43.34h-1.95v-1.95h1.95v1.95ZM400.34,43.34h-1.95v-1.95h1.95v1.95ZM397.42,43.34h-1.95v-1.95h1.95v1.95ZM394.5,43.34h-1.95v-1.95h1.95v1.95ZM391.58,43.34h-1.95v-1.95h1.95v1.95ZM388.66,43.34h-1.95v-1.95h1.95v1.95ZM385.74,43.34h-1.95v-1.95h1.95v1.95ZM382.82,43.34h-1.95v-1.95h1.95v1.95ZM379.89,43.34h-1.95v-1.95h1.95v1.95ZM376.97,43.34h-1.95v-1.95h1.95v1.95ZM374.05,43.34h-1.95v-1.95h1.95v1.95ZM371.13,43.34h-1.95v-1.95h1.95v1.95ZM368.21,43.34h-1.95v-1.95h1.95v1.95ZM365.29,43.34h-1.95v-1.95h1.95v1.95ZM362.37,43.34h-1.95v-1.95h1.95v1.95ZM359.45,43.34h-1.95v-1.95h1.95v1.95ZM356.53,43.34h-1.95v-1.95h1.95v1.95ZM353.61,43.34h-1.95v-1.95h1.95v1.95ZM350.69,43.34h-1.95v-1.95h1.95v1.95ZM347.77,43.34h-1.95v-1.95h1.95v1.95ZM344.85,43.34h-1.95v-1.95h1.95v1.95ZM341.93,43.34h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,40.42h-1.95v-1.95h1.95v1.95ZM406.18,40.42h-1.95v-1.95h1.95v1.95ZM403.26,40.42h-1.95v-1.95h1.95v1.95ZM400.34,40.42h-1.95v-1.95h1.95v1.95ZM397.42,40.42h-1.95v-1.95h1.95v1.95ZM394.5,40.42h-1.95v-1.95h1.95v1.95ZM391.58,40.42h-1.95v-1.95h1.95v1.95ZM388.66,40.42h-1.95v-1.95h1.95v1.95ZM385.74,40.42h-1.95v-1.95h1.95v1.95ZM382.82,40.42h-1.95v-1.95h1.95v1.95ZM379.89,40.42h-1.95v-1.95h1.95v1.95ZM376.97,40.42h-1.95v-1.95h1.95v1.95ZM374.05,40.42h-1.95v-1.95h1.95v1.95ZM371.13,40.42h-1.95v-1.95h1.95v1.95ZM368.21,40.42h-1.95v-1.95h1.95v1.95ZM365.29,40.42h-1.95v-1.95h1.95v1.95ZM362.37,40.42h-1.95v-1.95h1.95v1.95ZM359.45,40.42h-1.95v-1.95h1.95v1.95ZM356.53,40.42h-1.95v-1.95h1.95v1.95ZM353.61,40.42h-1.95v-1.95h1.95v1.95ZM350.69,40.42h-1.95v-1.95h1.95v1.95ZM347.77,40.42h-1.95v-1.95h1.95v1.95ZM344.85,40.42h-1.95v-1.95h1.95v1.95ZM341.93,40.42h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,37.5h-1.95v-1.95h1.95v1.95ZM406.18,37.5h-1.95v-1.95h1.95v1.95ZM403.26,37.5h-1.95v-1.95h1.95v1.95ZM400.34,37.5h-1.95v-1.95h1.95v1.95ZM397.42,37.5h-1.95v-1.95h1.95v1.95ZM394.5,37.5h-1.95v-1.95h1.95v1.95ZM391.58,37.5h-1.95v-1.95h1.95v1.95ZM388.66,37.5h-1.95v-1.95h1.95v1.95ZM385.74,37.5h-1.95v-1.95h1.95v1.95ZM382.82,37.5h-1.95v-1.95h1.95v1.95ZM379.89,37.5h-1.95v-1.95h1.95v1.95ZM376.97,37.5h-1.95v-1.95h1.95v1.95ZM374.05,37.5h-1.95v-1.95h1.95v1.95ZM371.13,37.5h-1.95v-1.95h1.95v1.95ZM368.21,37.5h-1.95v-1.95h1.95v1.95ZM365.29,37.5h-1.95v-1.95h1.95v1.95ZM362.37,37.5h-1.95v-1.95h1.95v1.95ZM359.45,37.5h-1.95v-1.95h1.95v1.95ZM356.53,37.5h-1.95v-1.95h1.95v1.95ZM353.61,37.5h-1.95v-1.95h1.95v1.95ZM350.69,37.5h-1.95v-1.95h1.95v1.95ZM347.77,37.5h-1.95v-1.95h1.95v1.95ZM344.85,37.5h-1.95v-1.95h1.95v1.95ZM341.93,37.5h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,34.58h-1.95v-1.95h1.95v1.95ZM406.18,34.58h-1.95v-1.95h1.95v1.95ZM403.26,34.58h-1.95v-1.95h1.95v1.95ZM400.34,34.58h-1.95v-1.95h1.95v1.95ZM397.42,34.58h-1.95v-1.95h1.95v1.95ZM394.5,34.58h-1.95v-1.95h1.95v1.95ZM391.58,34.58h-1.95v-1.95h1.95v1.95ZM388.66,34.58h-1.95v-1.95h1.95v1.95ZM385.74,34.58h-1.95v-1.95h1.95v1.95ZM382.82,34.58h-1.95v-1.95h1.95v1.95ZM379.89,34.58h-1.95v-1.95h1.95v1.95ZM376.97,34.58h-1.95v-1.95h1.95v1.95ZM374.05,34.58h-1.95v-1.95h1.95v1.95ZM371.13,34.58h-1.95v-1.95h1.95v1.95ZM368.21,34.58h-1.95v-1.95h1.95v1.95ZM365.29,34.58h-1.95v-1.95h1.95v1.95ZM362.37,34.58h-1.95v-1.95h1.95v1.95ZM359.45,34.58h-1.95v-1.95h1.95v1.95ZM356.53,34.58h-1.95v-1.95h1.95v1.95ZM353.61,34.58h-1.95v-1.95h1.95v1.95ZM350.69,34.58h-1.95v-1.95h1.95v1.95ZM347.77,34.58h-1.95v-1.95h1.95v1.95ZM344.85,34.58h-1.95v-1.95h1.95v1.95ZM341.93,34.58h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,31.66h-1.95v-1.95h1.95v1.95ZM406.18,31.66h-1.95v-1.95h1.95v1.95ZM403.26,31.66h-1.95v-1.95h1.95v1.95ZM400.34,31.66h-1.95v-1.95h1.95v1.95ZM397.42,31.66h-1.95v-1.95h1.95v1.95ZM394.5,31.66h-1.95v-1.95h1.95v1.95ZM391.58,31.66h-1.95v-1.95h1.95v1.95ZM388.66,31.66h-1.95v-1.95h1.95v1.95ZM385.74,31.66h-1.95v-1.95h1.95v1.95ZM382.82,31.66h-1.95v-1.95h1.95v1.95ZM379.89,31.66h-1.95v-1.95h1.95v1.95ZM376.97,31.66h-1.95v-1.95h1.95v1.95ZM374.05,31.66h-1.95v-1.95h1.95v1.95ZM371.13,31.66h-1.95v-1.95h1.95v1.95ZM368.21,31.66h-1.95v-1.95h1.95v1.95ZM365.29,31.66h-1.95v-1.95h1.95v1.95ZM362.37,31.66h-1.95v-1.95h1.95v1.95ZM359.45,31.66h-1.95v-1.95h1.95v1.95ZM356.53,31.66h-1.95v-1.95h1.95v1.95ZM353.61,31.66h-1.95v-1.95h1.95v1.95ZM350.69,31.66h-1.95v-1.95h1.95v1.95ZM347.77,31.66h-1.95v-1.95h1.95v1.95ZM344.85,31.66h-1.95v-1.95h1.95v1.95ZM341.93,31.66h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,28.74h-1.95v-1.95h1.95v1.95ZM406.18,28.74h-1.95v-1.95h1.95v1.95ZM403.26,28.74h-1.95v-1.95h1.95v1.95ZM400.34,28.74h-1.95v-1.95h1.95v1.95ZM397.42,28.74h-1.95v-1.95h1.95v1.95ZM394.5,28.74h-1.95v-1.95h1.95v1.95ZM391.58,28.74h-1.95v-1.95h1.95v1.95ZM388.66,28.74h-1.95v-1.95h1.95v1.95ZM385.74,28.74h-1.95v-1.95h1.95v1.95ZM382.82,28.74h-1.95v-1.95h1.95v1.95ZM379.89,28.74h-1.95v-1.95h1.95v1.95ZM376.97,28.74h-1.95v-1.95h1.95v1.95ZM374.05,28.74h-1.95v-1.95h1.95v1.95ZM371.13,28.74h-1.95v-1.95h1.95v1.95ZM368.21,28.74h-1.95v-1.95h1.95v1.95ZM365.29,28.74h-1.95v-1.95h1.95v1.95ZM362.37,28.74h-1.95v-1.95h1.95v1.95ZM359.45,28.74h-1.95v-1.95h1.95v1.95ZM356.53,28.74h-1.95v-1.95h1.95v1.95ZM353.61,28.74h-1.95v-1.95h1.95v1.95ZM350.69,28.74h-1.95v-1.95h1.95v1.95ZM347.77,28.74h-1.95v-1.95h1.95v1.95ZM344.85,28.74h-1.95v-1.95h1.95v1.95ZM341.93,28.74h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,25.82h-1.95v-1.95h1.95v1.95ZM406.18,25.82h-1.95v-1.95h1.95v1.95ZM403.26,25.82h-1.95v-1.95h1.95v1.95ZM400.34,25.82h-1.95v-1.95h1.95v1.95ZM397.42,25.82h-1.95v-1.95h1.95v1.95ZM394.5,25.82h-1.95v-1.95h1.95v1.95ZM391.58,25.82h-1.95v-1.95h1.95v1.95ZM388.66,25.82h-1.95v-1.95h1.95v1.95ZM385.74,25.82h-1.95v-1.95h1.95v1.95ZM382.82,25.82h-1.95v-1.95h1.95v1.95ZM379.89,25.82h-1.95v-1.95h1.95v1.95ZM376.97,25.82h-1.95v-1.95h1.95v1.95ZM374.05,25.82h-1.95v-1.95h1.95v1.95ZM371.13,25.82h-1.95v-1.95h1.95v1.95ZM368.21,25.82h-1.95v-1.95h1.95v1.95ZM365.29,25.82h-1.95v-1.95h1.95v1.95ZM362.37,25.82h-1.95v-1.95h1.95v1.95ZM359.45,25.82h-1.95v-1.95h1.95v1.95ZM356.53,25.82h-1.95v-1.95h1.95v1.95ZM353.61,25.82h-1.95v-1.95h1.95v1.95ZM350.69,25.82h-1.95v-1.95h1.95v1.95ZM347.77,25.82h-1.95v-1.95h1.95v1.95ZM344.85,25.82h-1.95v-1.95h1.95v1.95ZM341.93,25.82h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,22.9h-1.95v-1.95h1.95v1.95ZM406.18,22.9h-1.95v-1.95h1.95v1.95ZM403.26,22.9h-1.95v-1.95h1.95v1.95ZM400.34,22.9h-1.95v-1.95h1.95v1.95ZM397.42,22.9h-1.95v-1.95h1.95v1.95ZM394.5,22.9h-1.95v-1.95h1.95v1.95ZM391.58,22.9h-1.95v-1.95h1.95v1.95ZM388.66,22.9h-1.95v-1.95h1.95v1.95ZM385.74,22.9h-1.95v-1.95h1.95v1.95ZM382.82,22.9h-1.95v-1.95h1.95v1.95ZM379.89,22.9h-1.95v-1.95h1.95v1.95ZM376.97,22.9h-1.95v-1.95h1.95v1.95ZM374.05,22.9h-1.95v-1.95h1.95v1.95ZM371.13,22.9h-1.95v-1.95h1.95v1.95ZM368.21,22.9h-1.95v-1.95h1.95v1.95ZM365.29,22.9h-1.95v-1.95h1.95v1.95ZM362.37,22.9h-1.95v-1.95h1.95v1.95ZM359.45,22.9h-1.95v-1.95h1.95v1.95ZM356.53,22.9h-1.95v-1.95h1.95v1.95ZM353.61,22.9h-1.95v-1.95h1.95v1.95ZM350.69,22.9h-1.95v-1.95h1.95v1.95ZM347.77,22.9h-1.95v-1.95h1.95v1.95ZM344.85,22.9h-1.95v-1.95h1.95v1.95ZM341.93,22.9h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,19.98h-1.95v-1.95h1.95v1.95ZM406.18,19.98h-1.95v-1.95h1.95v1.95ZM403.26,19.98h-1.95v-1.95h1.95v1.95ZM400.34,19.98h-1.95v-1.95h1.95v1.95ZM397.42,19.98h-1.95v-1.95h1.95v1.95ZM394.5,19.98h-1.95v-1.95h1.95v1.95ZM391.58,19.98h-1.95v-1.95h1.95v1.95ZM388.66,19.98h-1.95v-1.95h1.95v1.95ZM385.74,19.98h-1.95v-1.95h1.95v1.95ZM382.82,19.98h-1.95v-1.95h1.95v1.95ZM379.89,19.98h-1.95v-1.95h1.95v1.95ZM376.97,19.98h-1.95v-1.95h1.95v1.95ZM374.05,19.98h-1.95v-1.95h1.95v1.95ZM371.13,19.98h-1.95v-1.95h1.95v1.95ZM368.21,19.98h-1.95v-1.95h1.95v1.95ZM365.29,19.98h-1.95v-1.95h1.95v1.95ZM362.37,19.98h-1.95v-1.95h1.95v1.95ZM359.45,19.98h-1.95v-1.95h1.95v1.95ZM356.53,19.98h-1.95v-1.95h1.95v1.95ZM353.61,19.98h-1.95v-1.95h1.95v1.95ZM350.69,19.98h-1.95v-1.95h1.95v1.95ZM347.77,19.98h-1.95v-1.95h1.95v1.95ZM344.85,19.98h-1.95v-1.95h1.95v1.95ZM341.93,19.98h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,17.06h-1.95v-1.95h1.95v1.95ZM406.18,17.06h-1.95v-1.95h1.95v1.95ZM403.26,17.06h-1.95v-1.95h1.95v1.95ZM400.34,17.06h-1.95v-1.95h1.95v1.95ZM397.42,17.06h-1.95v-1.95h1.95v1.95ZM394.5,17.06h-1.95v-1.95h1.95v1.95ZM391.58,17.06h-1.95v-1.95h1.95v1.95ZM388.66,17.06h-1.95v-1.95h1.95v1.95ZM385.74,17.06h-1.95v-1.95h1.95v1.95ZM382.82,17.06h-1.95v-1.95h1.95v1.95ZM379.89,17.06h-1.95v-1.95h1.95v1.95ZM376.97,17.06h-1.95v-1.95h1.95v1.95ZM374.05,17.06h-1.95v-1.95h1.95v1.95ZM371.13,17.06h-1.95v-1.95h1.95v1.95ZM368.21,17.06h-1.95v-1.95h1.95v1.95ZM365.29,17.06h-1.95v-1.95h1.95v1.95ZM362.37,17.06h-1.95v-1.95h1.95v1.95ZM359.45,17.06h-1.95v-1.95h1.95v1.95ZM356.53,17.06h-1.95v-1.95h1.95v1.95ZM353.61,17.06h-1.95v-1.95h1.95v1.95ZM350.69,17.06h-1.95v-1.95h1.95v1.95ZM347.77,17.06h-1.95v-1.95h1.95v1.95ZM344.85,17.06h-1.95v-1.95h1.95v1.95ZM341.93,17.06h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,14.14h-1.95v-1.95h1.95v1.95ZM406.18,14.14h-1.95v-1.95h1.95v1.95ZM403.26,14.14h-1.95v-1.95h1.95v1.95ZM400.34,14.14h-1.95v-1.95h1.95v1.95ZM397.42,14.14h-1.95v-1.95h1.95v1.95ZM394.5,14.14h-1.95v-1.95h1.95v1.95ZM391.58,14.14h-1.95v-1.95h1.95v1.95ZM388.66,14.14h-1.95v-1.95h1.95v1.95ZM385.74,14.14h-1.95v-1.95h1.95v1.95ZM382.82,14.14h-1.95v-1.95h1.95v1.95ZM379.89,14.14h-1.95v-1.95h1.95v1.95ZM376.97,14.14h-1.95v-1.95h1.95v1.95ZM374.05,14.14h-1.95v-1.95h1.95v1.95ZM371.13,14.14h-1.95v-1.95h1.95v1.95ZM368.21,14.14h-1.95v-1.95h1.95v1.95ZM365.29,14.14h-1.95v-1.95h1.95v1.95ZM362.37,14.14h-1.95v-1.95h1.95v1.95ZM359.45,14.14h-1.95v-1.95h1.95v1.95ZM356.53,14.14h-1.95v-1.95h1.95v1.95ZM353.61,14.14h-1.95v-1.95h1.95v1.95ZM350.69,14.14h-1.95v-1.95h1.95v1.95ZM347.77,14.14h-1.95v-1.95h1.95v1.95ZM344.85,14.14h-1.95v-1.95h1.95v1.95ZM341.93,14.14h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,11.22h-1.95v-1.95h1.95v1.95ZM406.18,11.22h-1.95v-1.95h1.95v1.95ZM403.26,11.22h-1.95v-1.95h1.95v1.95ZM400.34,11.22h-1.95v-1.95h1.95v1.95ZM397.42,11.22h-1.95v-1.95h1.95v1.95ZM394.5,11.22h-1.95v-1.95h1.95v1.95ZM391.58,11.22h-1.95v-1.95h1.95v1.95ZM388.66,11.22h-1.95v-1.95h1.95v1.95ZM385.74,11.22h-1.95v-1.95h1.95v1.95ZM382.82,11.22h-1.95v-1.95h1.95v1.95ZM379.89,11.22h-1.95v-1.95h1.95v1.95ZM376.97,11.22h-1.95v-1.95h1.95v1.95ZM374.05,11.22h-1.95v-1.95h1.95v1.95ZM371.13,11.22h-1.95v-1.95h1.95v1.95ZM368.21,11.22h-1.95v-1.95h1.95v1.95ZM365.29,11.22h-1.95v-1.95h1.95v1.95ZM362.37,11.22h-1.95v-1.95h1.95v1.95ZM359.45,11.22h-1.95v-1.95h1.95v1.95ZM356.53,11.22h-1.95v-1.95h1.95v1.95ZM353.61,11.22h-1.95v-1.95h1.95v1.95ZM350.69,11.22h-1.95v-1.95h1.95v1.95ZM347.77,11.22h-1.95v-1.95h1.95v1.95ZM344.85,11.22h-1.95v-1.95h1.95v1.95ZM341.93,11.22h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,8.3h-1.95v-1.95h1.95v1.95ZM406.18,8.3h-1.95v-1.95h1.95v1.95ZM403.26,8.3h-1.95v-1.95h1.95v1.95ZM400.34,8.3h-1.95v-1.95h1.95v1.95ZM397.42,8.3h-1.95v-1.95h1.95v1.95ZM394.5,8.3h-1.95v-1.95h1.95v1.95ZM391.58,8.3h-1.95v-1.95h1.95v1.95ZM388.66,8.3h-1.95v-1.95h1.95v1.95ZM385.74,8.3h-1.95v-1.95h1.95v1.95ZM382.82,8.3h-1.95v-1.95h1.95v1.95ZM379.89,8.3h-1.95v-1.95h1.95v1.95ZM376.97,8.3h-1.95v-1.95h1.95v1.95ZM374.05,8.3h-1.95v-1.95h1.95v1.95ZM371.13,8.3h-1.95v-1.95h1.95v1.95ZM368.21,8.3h-1.95v-1.95h1.95v1.95ZM365.29,8.3h-1.95v-1.95h1.95v1.95ZM362.37,8.3h-1.95v-1.95h1.95v1.95ZM359.45,8.3h-1.95v-1.95h1.95v1.95ZM356.53,8.3h-1.95v-1.95h1.95v1.95ZM353.61,8.3h-1.95v-1.95h1.95v1.95ZM350.69,8.3h-1.95v-1.95h1.95v1.95ZM347.77,8.3h-1.95v-1.95h1.95v1.95ZM344.85,8.3h-1.95v-1.95h1.95v1.95ZM341.93,8.3h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,5.38h-1.95v-1.95h1.95v1.95ZM406.18,5.38h-1.95v-1.95h1.95v1.95ZM403.26,5.38h-1.95v-1.95h1.95v1.95ZM400.34,5.38h-1.95v-1.95h1.95v1.95ZM397.42,5.38h-1.95v-1.95h1.95v1.95ZM394.5,5.38h-1.95v-1.95h1.95v1.95ZM391.58,5.38h-1.95v-1.95h1.95v1.95ZM388.66,5.38h-1.95v-1.95h1.95v1.95ZM385.74,5.38h-1.95v-1.95h1.95v1.95ZM382.82,5.38h-1.95v-1.95h1.95v1.95ZM379.89,5.38h-1.95v-1.95h1.95v1.95ZM376.97,5.38h-1.95v-1.95h1.95v1.95ZM374.05,5.38h-1.95v-1.95h1.95v1.95ZM371.13,5.38h-1.95v-1.95h1.95v1.95ZM368.21,5.38h-1.95v-1.95h1.95v1.95ZM365.29,5.38h-1.95v-1.95h1.95v1.95ZM362.37,5.38h-1.95v-1.95h1.95v1.95ZM359.45,5.38h-1.95v-1.95h1.95v1.95ZM356.53,5.38h-1.95v-1.95h1.95v1.95ZM353.61,5.38h-1.95v-1.95h1.95v1.95ZM350.69,5.38h-1.95v-1.95h1.95v1.95ZM347.77,5.38h-1.95v-1.95h1.95v1.95ZM344.85,5.38h-1.95v-1.95h1.95v1.95ZM341.93,5.38h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,2.46h-1.95V.51h1.95v1.95ZM406.18,2.46h-1.95V.51h1.95v1.95ZM403.26,2.46h-1.95V.51h1.95v1.95ZM400.34,2.46h-1.95V.51h1.95v1.95ZM397.42,2.46h-1.95V.51h1.95v1.95ZM394.5,2.46h-1.95V.51h1.95v1.95ZM391.58,2.46h-1.95V.51h1.95v1.95ZM388.66,2.46h-1.95V.51h1.95v1.95ZM385.74,2.46h-1.95V.51h1.95v1.95ZM382.82,2.46h-1.95V.51h1.95v1.95ZM379.89,2.46h-1.95V.51h1.95v1.95ZM376.97,2.46h-1.95V.51h1.95v1.95ZM374.05,2.46h-1.95V.51h1.95v1.95ZM371.13,2.46h-1.95V.51h1.95v1.95ZM368.21,2.46h-1.95V.51h1.95v1.95ZM365.29,2.46h-1.95V.51h1.95v1.95ZM362.37,2.46h-1.95V.51h1.95v1.95ZM359.45,2.46h-1.95V.51h1.95v1.95ZM356.53,2.46h-1.95V.51h1.95v1.95ZM353.61,2.46h-1.95V.51h1.95v1.95ZM350.69,2.46h-1.95V.51h1.95v1.95ZM347.77,2.46h-1.95V.51h1.95v1.95ZM344.85,2.46h-1.95V.51h1.95v1.95ZM341.93,2.46h-1.95V.51h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-14)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.19,125.11h-1.95v-1.95h1.95v1.95ZM476.27,125.11h-1.95v-1.95h1.95v1.95ZM473.35,125.11h-1.95v-1.95h1.95v1.95ZM470.43,125.11h-1.95v-1.95h1.95v1.95ZM467.51,125.11h-1.95v-1.95h1.95v1.95ZM464.59,125.11h-1.95v-1.95h1.95v1.95ZM461.67,125.11h-1.95v-1.95h1.95v1.95ZM458.75,125.11h-1.95v-1.95h1.95v1.95ZM455.82,125.11h-1.95v-1.95h1.95v1.95ZM452.9,125.11h-1.95v-1.95h1.95v1.95ZM449.98,125.11h-1.95v-1.95h1.95v1.95ZM447.06,125.11h-1.95v-1.95h1.95v1.95ZM444.14,125.11h-1.95v-1.95h1.95v1.95ZM441.22,125.11h-1.95v-1.95h1.95v1.95ZM438.3,125.11h-1.95v-1.95h1.95v1.95ZM435.38,125.11h-1.95v-1.95h1.95v1.95ZM432.46,125.11h-1.95v-1.95h1.95v1.95ZM429.54,125.11h-1.95v-1.95h1.95v1.95ZM426.62,125.11h-1.95v-1.95h1.95v1.95ZM423.7,125.11h-1.95v-1.95h1.95v1.95ZM420.78,125.11h-1.95v-1.95h1.95v1.95ZM417.86,125.11h-1.95v-1.95h1.95v1.95ZM414.94,125.11h-1.95v-1.95h1.95v1.95ZM412.02,125.11h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,122.19h-1.95v-1.95h1.95v1.95ZM476.27,122.19h-1.95v-1.95h1.95v1.95ZM473.35,122.19h-1.95v-1.95h1.95v1.95ZM470.43,122.19h-1.95v-1.95h1.95v1.95ZM467.51,122.19h-1.95v-1.95h1.95v1.95ZM464.59,122.19h-1.95v-1.95h1.95v1.95ZM461.67,122.19h-1.95v-1.95h1.95v1.95ZM458.75,122.19h-1.95v-1.95h1.95v1.95ZM455.82,122.19h-1.95v-1.95h1.95v1.95ZM452.9,122.19h-1.95v-1.95h1.95v1.95ZM449.98,122.19h-1.95v-1.95h1.95v1.95ZM447.06,122.19h-1.95v-1.95h1.95v1.95ZM444.14,122.19h-1.95v-1.95h1.95v1.95ZM441.22,122.19h-1.95v-1.95h1.95v1.95ZM438.3,122.19h-1.95v-1.95h1.95v1.95ZM435.38,122.19h-1.95v-1.95h1.95v1.95ZM432.46,122.19h-1.95v-1.95h1.95v1.95ZM429.54,122.19h-1.95v-1.95h1.95v1.95ZM426.62,122.19h-1.95v-1.95h1.95v1.95ZM423.7,122.19h-1.95v-1.95h1.95v1.95ZM420.78,122.19h-1.95v-1.95h1.95v1.95ZM417.86,122.19h-1.95v-1.95h1.95v1.95ZM414.94,122.19h-1.95v-1.95h1.95v1.95ZM412.02,122.19h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,119.27h-1.95v-1.95h1.95v1.95ZM476.27,119.27h-1.95v-1.95h1.95v1.95ZM473.35,119.27h-1.95v-1.95h1.95v1.95ZM470.43,119.27h-1.95v-1.95h1.95v1.95ZM467.51,119.27h-1.95v-1.95h1.95v1.95ZM464.59,119.27h-1.95v-1.95h1.95v1.95ZM461.67,119.27h-1.95v-1.95h1.95v1.95ZM458.75,119.27h-1.95v-1.95h1.95v1.95ZM455.82,119.27h-1.95v-1.95h1.95v1.95ZM452.9,119.27h-1.95v-1.95h1.95v1.95ZM449.98,119.27h-1.95v-1.95h1.95v1.95ZM447.06,119.27h-1.95v-1.95h1.95v1.95ZM444.14,119.27h-1.95v-1.95h1.95v1.95ZM441.22,119.27h-1.95v-1.95h1.95v1.95ZM438.3,119.27h-1.95v-1.95h1.95v1.95ZM435.38,119.27h-1.95v-1.95h1.95v1.95ZM432.46,119.27h-1.95v-1.95h1.95v1.95ZM429.54,119.27h-1.95v-1.95h1.95v1.95ZM426.62,119.27h-1.95v-1.95h1.95v1.95ZM423.7,119.27h-1.95v-1.95h1.95v1.95ZM420.78,119.27h-1.95v-1.95h1.95v1.95ZM417.86,119.27h-1.95v-1.95h1.95v1.95ZM414.94,119.27h-1.95v-1.95h1.95v1.95ZM412.02,119.27h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,116.35h-1.95v-1.95h1.95v1.95ZM476.27,116.35h-1.95v-1.95h1.95v1.95ZM473.35,116.35h-1.95v-1.95h1.95v1.95ZM470.43,116.35h-1.95v-1.95h1.95v1.95ZM467.51,116.35h-1.95v-1.95h1.95v1.95ZM464.59,116.35h-1.95v-1.95h1.95v1.95ZM461.67,116.35h-1.95v-1.95h1.95v1.95ZM458.75,116.35h-1.95v-1.95h1.95v1.95ZM455.82,116.35h-1.95v-1.95h1.95v1.95ZM452.9,116.35h-1.95v-1.95h1.95v1.95ZM449.98,116.35h-1.95v-1.95h1.95v1.95ZM447.06,116.35h-1.95v-1.95h1.95v1.95ZM444.14,116.35h-1.95v-1.95h1.95v1.95ZM441.22,116.35h-1.95v-1.95h1.95v1.95ZM438.3,116.35h-1.95v-1.95h1.95v1.95ZM435.38,116.35h-1.95v-1.95h1.95v1.95ZM432.46,116.35h-1.95v-1.95h1.95v1.95ZM429.54,116.35h-1.95v-1.95h1.95v1.95ZM426.62,116.35h-1.95v-1.95h1.95v1.95ZM423.7,116.35h-1.95v-1.95h1.95v1.95ZM420.78,116.35h-1.95v-1.95h1.95v1.95ZM417.86,116.35h-1.95v-1.95h1.95v1.95ZM414.94,116.35h-1.95v-1.95h1.95v1.95ZM412.02,116.35h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,113.43h-1.95v-1.95h1.95v1.95ZM476.27,113.43h-1.95v-1.95h1.95v1.95ZM473.35,113.43h-1.95v-1.95h1.95v1.95ZM470.43,113.43h-1.95v-1.95h1.95v1.95ZM467.51,113.43h-1.95v-1.95h1.95v1.95ZM464.59,113.43h-1.95v-1.95h1.95v1.95ZM461.67,113.43h-1.95v-1.95h1.95v1.95ZM458.75,113.43h-1.95v-1.95h1.95v1.95ZM455.82,113.43h-1.95v-1.95h1.95v1.95ZM452.9,113.43h-1.95v-1.95h1.95v1.95ZM449.98,113.43h-1.95v-1.95h1.95v1.95ZM447.06,113.43h-1.95v-1.95h1.95v1.95ZM444.14,113.43h-1.95v-1.95h1.95v1.95ZM441.22,113.43h-1.95v-1.95h1.95v1.95ZM438.3,113.43h-1.95v-1.95h1.95v1.95ZM435.38,113.43h-1.95v-1.95h1.95v1.95ZM432.46,113.43h-1.95v-1.95h1.95v1.95ZM429.54,113.43h-1.95v-1.95h1.95v1.95ZM426.62,113.43h-1.95v-1.95h1.95v1.95ZM423.7,113.43h-1.95v-1.95h1.95v1.95ZM420.78,113.43h-1.95v-1.95h1.95v1.95ZM417.86,113.43h-1.95v-1.95h1.95v1.95ZM414.94,113.43h-1.95v-1.95h1.95v1.95ZM412.02,113.43h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,110.51h-1.95v-1.95h1.95v1.95ZM476.27,110.51h-1.95v-1.95h1.95v1.95ZM473.35,110.51h-1.95v-1.95h1.95v1.95ZM470.43,110.51h-1.95v-1.95h1.95v1.95ZM467.51,110.51h-1.95v-1.95h1.95v1.95ZM464.59,110.51h-1.95v-1.95h1.95v1.95ZM461.67,110.51h-1.95v-1.95h1.95v1.95ZM458.75,110.51h-1.95v-1.95h1.95v1.95ZM455.82,110.51h-1.95v-1.95h1.95v1.95ZM452.9,110.51h-1.95v-1.95h1.95v1.95ZM449.98,110.51h-1.95v-1.95h1.95v1.95ZM447.06,110.51h-1.95v-1.95h1.95v1.95ZM444.14,110.51h-1.95v-1.95h1.95v1.95ZM441.22,110.51h-1.95v-1.95h1.95v1.95ZM438.3,110.51h-1.95v-1.95h1.95v1.95ZM435.38,110.51h-1.95v-1.95h1.95v1.95ZM432.46,110.51h-1.95v-1.95h1.95v1.95ZM429.54,110.51h-1.95v-1.95h1.95v1.95ZM426.62,110.51h-1.95v-1.95h1.95v1.95ZM423.7,110.51h-1.95v-1.95h1.95v1.95ZM420.78,110.51h-1.95v-1.95h1.95v1.95ZM417.86,110.51h-1.95v-1.95h1.95v1.95ZM414.94,110.51h-1.95v-1.95h1.95v1.95ZM412.02,110.51h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,107.59h-1.95v-1.95h1.95v1.95ZM476.27,107.59h-1.95v-1.95h1.95v1.95ZM473.35,107.59h-1.95v-1.95h1.95v1.95ZM470.43,107.59h-1.95v-1.95h1.95v1.95ZM467.51,107.59h-1.95v-1.95h1.95v1.95ZM464.59,107.59h-1.95v-1.95h1.95v1.95ZM461.67,107.59h-1.95v-1.95h1.95v1.95ZM458.75,107.59h-1.95v-1.95h1.95v1.95ZM455.82,107.59h-1.95v-1.95h1.95v1.95ZM452.9,107.59h-1.95v-1.95h1.95v1.95ZM449.98,107.59h-1.95v-1.95h1.95v1.95ZM447.06,107.59h-1.95v-1.95h1.95v1.95ZM444.14,107.59h-1.95v-1.95h1.95v1.95ZM441.22,107.59h-1.95v-1.95h1.95v1.95ZM438.3,107.59h-1.95v-1.95h1.95v1.95ZM435.38,107.59h-1.95v-1.95h1.95v1.95ZM432.46,107.59h-1.95v-1.95h1.95v1.95ZM429.54,107.59h-1.95v-1.95h1.95v1.95ZM426.62,107.59h-1.95v-1.95h1.95v1.95ZM423.7,107.59h-1.95v-1.95h1.95v1.95ZM420.78,107.59h-1.95v-1.95h1.95v1.95ZM417.86,107.59h-1.95v-1.95h1.95v1.95ZM414.94,107.59h-1.95v-1.95h1.95v1.95ZM412.02,107.59h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,104.67h-1.95v-1.95h1.95v1.95ZM476.27,104.67h-1.95v-1.95h1.95v1.95ZM473.35,104.67h-1.95v-1.95h1.95v1.95ZM470.43,104.67h-1.95v-1.95h1.95v1.95ZM467.51,104.67h-1.95v-1.95h1.95v1.95ZM464.59,104.67h-1.95v-1.95h1.95v1.95ZM461.67,104.67h-1.95v-1.95h1.95v1.95ZM458.75,104.67h-1.95v-1.95h1.95v1.95ZM455.82,104.67h-1.95v-1.95h1.95v1.95ZM452.9,104.67h-1.95v-1.95h1.95v1.95ZM449.98,104.67h-1.95v-1.95h1.95v1.95ZM447.06,104.67h-1.95v-1.95h1.95v1.95ZM444.14,104.67h-1.95v-1.95h1.95v1.95ZM441.22,104.67h-1.95v-1.95h1.95v1.95ZM438.3,104.67h-1.95v-1.95h1.95v1.95ZM435.38,104.67h-1.95v-1.95h1.95v1.95ZM432.46,104.67h-1.95v-1.95h1.95v1.95ZM429.54,104.67h-1.95v-1.95h1.95v1.95ZM426.62,104.67h-1.95v-1.95h1.95v1.95ZM423.7,104.67h-1.95v-1.95h1.95v1.95ZM420.78,104.67h-1.95v-1.95h1.95v1.95ZM417.86,104.67h-1.95v-1.95h1.95v1.95ZM414.94,104.67h-1.95v-1.95h1.95v1.95ZM412.02,104.67h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,101.75h-1.95v-1.95h1.95v1.95ZM476.27,101.75h-1.95v-1.95h1.95v1.95ZM473.35,101.75h-1.95v-1.95h1.95v1.95ZM470.43,101.75h-1.95v-1.95h1.95v1.95ZM467.51,101.75h-1.95v-1.95h1.95v1.95ZM464.59,101.75h-1.95v-1.95h1.95v1.95ZM461.67,101.75h-1.95v-1.95h1.95v1.95ZM458.75,101.75h-1.95v-1.95h1.95v1.95ZM455.82,101.75h-1.95v-1.95h1.95v1.95ZM452.9,101.75h-1.95v-1.95h1.95v1.95ZM449.98,101.75h-1.95v-1.95h1.95v1.95ZM447.06,101.75h-1.95v-1.95h1.95v1.95ZM444.14,101.75h-1.95v-1.95h1.95v1.95ZM441.22,101.75h-1.95v-1.95h1.95v1.95ZM438.3,101.75h-1.95v-1.95h1.95v1.95ZM435.38,101.75h-1.95v-1.95h1.95v1.95ZM432.46,101.75h-1.95v-1.95h1.95v1.95ZM429.54,101.75h-1.95v-1.95h1.95v1.95ZM426.62,101.75h-1.95v-1.95h1.95v1.95ZM423.7,101.75h-1.95v-1.95h1.95v1.95ZM420.78,101.75h-1.95v-1.95h1.95v1.95ZM417.86,101.75h-1.95v-1.95h1.95v1.95ZM414.94,101.75h-1.95v-1.95h1.95v1.95ZM412.02,101.75h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,98.83h-1.95v-1.95h1.95v1.95ZM476.27,98.83h-1.95v-1.95h1.95v1.95ZM473.35,98.83h-1.95v-1.95h1.95v1.95ZM470.43,98.83h-1.95v-1.95h1.95v1.95ZM467.51,98.83h-1.95v-1.95h1.95v1.95ZM464.59,98.83h-1.95v-1.95h1.95v1.95ZM461.67,98.83h-1.95v-1.95h1.95v1.95ZM458.75,98.83h-1.95v-1.95h1.95v1.95ZM455.82,98.83h-1.95v-1.95h1.95v1.95ZM452.9,98.83h-1.95v-1.95h1.95v1.95ZM449.98,98.83h-1.95v-1.95h1.95v1.95ZM447.06,98.83h-1.95v-1.95h1.95v1.95ZM444.14,98.83h-1.95v-1.95h1.95v1.95ZM441.22,98.83h-1.95v-1.95h1.95v1.95ZM438.3,98.83h-1.95v-1.95h1.95v1.95ZM435.38,98.83h-1.95v-1.95h1.95v1.95ZM432.46,98.83h-1.95v-1.95h1.95v1.95ZM429.54,98.83h-1.95v-1.95h1.95v1.95ZM426.62,98.83h-1.95v-1.95h1.95v1.95ZM423.7,98.83h-1.95v-1.95h1.95v1.95ZM420.78,98.83h-1.95v-1.95h1.95v1.95ZM417.86,98.83h-1.95v-1.95h1.95v1.95ZM414.94,98.83h-1.95v-1.95h1.95v1.95ZM412.02,98.83h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,95.91h-1.95v-1.95h1.95v1.95ZM476.27,95.91h-1.95v-1.95h1.95v1.95ZM473.35,95.91h-1.95v-1.95h1.95v1.95ZM470.43,95.91h-1.95v-1.95h1.95v1.95ZM467.51,95.91h-1.95v-1.95h1.95v1.95ZM464.59,95.91h-1.95v-1.95h1.95v1.95ZM461.67,95.91h-1.95v-1.95h1.95v1.95ZM458.75,95.91h-1.95v-1.95h1.95v1.95ZM455.82,95.91h-1.95v-1.95h1.95v1.95ZM452.9,95.91h-1.95v-1.95h1.95v1.95ZM449.98,95.91h-1.95v-1.95h1.95v1.95ZM447.06,95.91h-1.95v-1.95h1.95v1.95ZM444.14,95.91h-1.95v-1.95h1.95v1.95ZM441.22,95.91h-1.95v-1.95h1.95v1.95ZM438.3,95.91h-1.95v-1.95h1.95v1.95ZM435.38,95.91h-1.95v-1.95h1.95v1.95ZM432.46,95.91h-1.95v-1.95h1.95v1.95ZM429.54,95.91h-1.95v-1.95h1.95v1.95ZM426.62,95.91h-1.95v-1.95h1.95v1.95ZM423.7,95.91h-1.95v-1.95h1.95v1.95ZM420.78,95.91h-1.95v-1.95h1.95v1.95ZM417.86,95.91h-1.95v-1.95h1.95v1.95ZM414.94,95.91h-1.95v-1.95h1.95v1.95ZM412.02,95.91h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,92.99h-1.95v-1.95h1.95v1.95ZM476.27,92.99h-1.95v-1.95h1.95v1.95ZM473.35,92.99h-1.95v-1.95h1.95v1.95ZM470.43,92.99h-1.95v-1.95h1.95v1.95ZM467.51,92.99h-1.95v-1.95h1.95v1.95ZM464.59,92.99h-1.95v-1.95h1.95v1.95ZM461.67,92.99h-1.95v-1.95h1.95v1.95ZM458.75,92.99h-1.95v-1.95h1.95v1.95ZM455.82,92.99h-1.95v-1.95h1.95v1.95ZM452.9,92.99h-1.95v-1.95h1.95v1.95ZM449.98,92.99h-1.95v-1.95h1.95v1.95ZM447.06,92.99h-1.95v-1.95h1.95v1.95ZM444.14,92.99h-1.95v-1.95h1.95v1.95ZM441.22,92.99h-1.95v-1.95h1.95v1.95ZM438.3,92.99h-1.95v-1.95h1.95v1.95ZM435.38,92.99h-1.95v-1.95h1.95v1.95ZM432.46,92.99h-1.95v-1.95h1.95v1.95ZM429.54,92.99h-1.95v-1.95h1.95v1.95ZM426.62,92.99h-1.95v-1.95h1.95v1.95ZM423.7,92.99h-1.95v-1.95h1.95v1.95ZM420.78,92.99h-1.95v-1.95h1.95v1.95ZM417.86,92.99h-1.95v-1.95h1.95v1.95ZM414.94,92.99h-1.95v-1.95h1.95v1.95ZM412.02,92.99h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,90.07h-1.95v-1.95h1.95v1.95ZM476.27,90.07h-1.95v-1.95h1.95v1.95ZM473.35,90.07h-1.95v-1.95h1.95v1.95ZM470.43,90.07h-1.95v-1.95h1.95v1.95ZM467.51,90.07h-1.95v-1.95h1.95v1.95ZM464.59,90.07h-1.95v-1.95h1.95v1.95ZM461.67,90.07h-1.95v-1.95h1.95v1.95ZM458.75,90.07h-1.95v-1.95h1.95v1.95ZM455.82,90.07h-1.95v-1.95h1.95v1.95ZM452.9,90.07h-1.95v-1.95h1.95v1.95ZM449.98,90.07h-1.95v-1.95h1.95v1.95ZM447.06,90.07h-1.95v-1.95h1.95v1.95ZM444.14,90.07h-1.95v-1.95h1.95v1.95ZM441.22,90.07h-1.95v-1.95h1.95v1.95ZM438.3,90.07h-1.95v-1.95h1.95v1.95ZM435.38,90.07h-1.95v-1.95h1.95v1.95ZM432.46,90.07h-1.95v-1.95h1.95v1.95ZM429.54,90.07h-1.95v-1.95h1.95v1.95ZM426.62,90.07h-1.95v-1.95h1.95v1.95ZM423.7,90.07h-1.95v-1.95h1.95v1.95ZM420.78,90.07h-1.95v-1.95h1.95v1.95ZM417.86,90.07h-1.95v-1.95h1.95v1.95ZM414.94,90.07h-1.95v-1.95h1.95v1.95ZM412.02,90.07h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,87.15h-1.95v-1.95h1.95v1.95ZM476.27,87.15h-1.95v-1.95h1.95v1.95ZM473.35,87.15h-1.95v-1.95h1.95v1.95ZM470.43,87.15h-1.95v-1.95h1.95v1.95ZM467.51,87.15h-1.95v-1.95h1.95v1.95ZM464.59,87.15h-1.95v-1.95h1.95v1.95ZM461.67,87.15h-1.95v-1.95h1.95v1.95ZM458.75,87.15h-1.95v-1.95h1.95v1.95ZM455.82,87.15h-1.95v-1.95h1.95v1.95ZM452.9,87.15h-1.95v-1.95h1.95v1.95ZM449.98,87.15h-1.95v-1.95h1.95v1.95ZM447.06,87.15h-1.95v-1.95h1.95v1.95ZM444.14,87.15h-1.95v-1.95h1.95v1.95ZM441.22,87.15h-1.95v-1.95h1.95v1.95ZM438.3,87.15h-1.95v-1.95h1.95v1.95ZM435.38,87.15h-1.95v-1.95h1.95v1.95ZM432.46,87.15h-1.95v-1.95h1.95v1.95ZM429.54,87.15h-1.95v-1.95h1.95v1.95ZM426.62,87.15h-1.95v-1.95h1.95v1.95ZM423.7,87.15h-1.95v-1.95h1.95v1.95ZM420.78,87.15h-1.95v-1.95h1.95v1.95ZM417.86,87.15h-1.95v-1.95h1.95v1.95ZM414.94,87.15h-1.95v-1.95h1.95v1.95ZM412.02,87.15h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,84.23h-1.95v-1.95h1.95v1.95ZM476.27,84.23h-1.95v-1.95h1.95v1.95ZM473.35,84.23h-1.95v-1.95h1.95v1.95ZM470.43,84.23h-1.95v-1.95h1.95v1.95ZM467.51,84.23h-1.95v-1.95h1.95v1.95ZM464.59,84.23h-1.95v-1.95h1.95v1.95ZM461.67,84.23h-1.95v-1.95h1.95v1.95ZM458.75,84.23h-1.95v-1.95h1.95v1.95ZM455.82,84.23h-1.95v-1.95h1.95v1.95ZM452.9,84.23h-1.95v-1.95h1.95v1.95ZM449.98,84.23h-1.95v-1.95h1.95v1.95ZM447.06,84.23h-1.95v-1.95h1.95v1.95ZM444.14,84.23h-1.95v-1.95h1.95v1.95ZM441.22,84.23h-1.95v-1.95h1.95v1.95ZM438.3,84.23h-1.95v-1.95h1.95v1.95ZM435.38,84.23h-1.95v-1.95h1.95v1.95ZM432.46,84.23h-1.95v-1.95h1.95v1.95ZM429.54,84.23h-1.95v-1.95h1.95v1.95ZM426.62,84.23h-1.95v-1.95h1.95v1.95ZM423.7,84.23h-1.95v-1.95h1.95v1.95ZM420.78,84.23h-1.95v-1.95h1.95v1.95ZM417.86,84.23h-1.95v-1.95h1.95v1.95ZM414.94,84.23h-1.95v-1.95h1.95v1.95ZM412.02,84.23h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,81.31h-1.95v-1.95h1.95v1.95ZM476.27,81.31h-1.95v-1.95h1.95v1.95ZM473.35,81.31h-1.95v-1.95h1.95v1.95ZM470.43,81.31h-1.95v-1.95h1.95v1.95ZM467.51,81.31h-1.95v-1.95h1.95v1.95ZM464.59,81.31h-1.95v-1.95h1.95v1.95ZM461.67,81.31h-1.95v-1.95h1.95v1.95ZM458.75,81.31h-1.95v-1.95h1.95v1.95ZM455.82,81.31h-1.95v-1.95h1.95v1.95ZM452.9,81.31h-1.95v-1.95h1.95v1.95ZM449.98,81.31h-1.95v-1.95h1.95v1.95ZM447.06,81.31h-1.95v-1.95h1.95v1.95ZM444.14,81.31h-1.95v-1.95h1.95v1.95ZM441.22,81.31h-1.95v-1.95h1.95v1.95ZM438.3,81.31h-1.95v-1.95h1.95v1.95ZM435.38,81.31h-1.95v-1.95h1.95v1.95ZM432.46,81.31h-1.95v-1.95h1.95v1.95ZM429.54,81.31h-1.95v-1.95h1.95v1.95ZM426.62,81.31h-1.95v-1.95h1.95v1.95ZM423.7,81.31h-1.95v-1.95h1.95v1.95ZM420.78,81.31h-1.95v-1.95h1.95v1.95ZM417.86,81.31h-1.95v-1.95h1.95v1.95ZM414.94,81.31h-1.95v-1.95h1.95v1.95ZM412.02,81.31h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,78.39h-1.95v-1.95h1.95v1.95ZM476.27,78.39h-1.95v-1.95h1.95v1.95ZM473.35,78.39h-1.95v-1.95h1.95v1.95ZM470.43,78.39h-1.95v-1.95h1.95v1.95ZM467.51,78.39h-1.95v-1.95h1.95v1.95ZM464.59,78.39h-1.95v-1.95h1.95v1.95ZM461.67,78.39h-1.95v-1.95h1.95v1.95ZM458.75,78.39h-1.95v-1.95h1.95v1.95ZM455.82,78.39h-1.95v-1.95h1.95v1.95ZM452.9,78.39h-1.95v-1.95h1.95v1.95ZM449.98,78.39h-1.95v-1.95h1.95v1.95ZM447.06,78.39h-1.95v-1.95h1.95v1.95ZM444.14,78.39h-1.95v-1.95h1.95v1.95ZM441.22,78.39h-1.95v-1.95h1.95v1.95ZM438.3,78.39h-1.95v-1.95h1.95v1.95ZM435.38,78.39h-1.95v-1.95h1.95v1.95ZM432.46,78.39h-1.95v-1.95h1.95v1.95ZM429.54,78.39h-1.95v-1.95h1.95v1.95ZM426.62,78.39h-1.95v-1.95h1.95v1.95ZM423.7,78.39h-1.95v-1.95h1.95v1.95ZM420.78,78.39h-1.95v-1.95h1.95v1.95ZM417.86,78.39h-1.95v-1.95h1.95v1.95ZM414.94,78.39h-1.95v-1.95h1.95v1.95ZM412.02,78.39h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,75.47h-1.95v-1.95h1.95v1.95ZM476.27,75.47h-1.95v-1.95h1.95v1.95ZM473.35,75.47h-1.95v-1.95h1.95v1.95ZM470.43,75.47h-1.95v-1.95h1.95v1.95ZM467.51,75.47h-1.95v-1.95h1.95v1.95ZM464.59,75.47h-1.95v-1.95h1.95v1.95ZM461.67,75.47h-1.95v-1.95h1.95v1.95ZM458.75,75.47h-1.95v-1.95h1.95v1.95ZM455.82,75.47h-1.95v-1.95h1.95v1.95ZM452.9,75.47h-1.95v-1.95h1.95v1.95ZM449.98,75.47h-1.95v-1.95h1.95v1.95ZM447.06,75.47h-1.95v-1.95h1.95v1.95ZM444.14,75.47h-1.95v-1.95h1.95v1.95ZM441.22,75.47h-1.95v-1.95h1.95v1.95ZM438.3,75.47h-1.95v-1.95h1.95v1.95ZM435.38,75.47h-1.95v-1.95h1.95v1.95ZM432.46,75.47h-1.95v-1.95h1.95v1.95ZM429.54,75.47h-1.95v-1.95h1.95v1.95ZM426.62,75.47h-1.95v-1.95h1.95v1.95ZM423.7,75.47h-1.95v-1.95h1.95v1.95ZM420.78,75.47h-1.95v-1.95h1.95v1.95ZM417.86,75.47h-1.95v-1.95h1.95v1.95ZM414.94,75.47h-1.95v-1.95h1.95v1.95ZM412.02,75.47h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,72.54h-1.95v-1.95h1.95v1.95ZM476.27,72.54h-1.95v-1.95h1.95v1.95ZM473.35,72.54h-1.95v-1.95h1.95v1.95ZM470.43,72.54h-1.95v-1.95h1.95v1.95ZM467.51,72.54h-1.95v-1.95h1.95v1.95ZM464.59,72.54h-1.95v-1.95h1.95v1.95ZM461.67,72.54h-1.95v-1.95h1.95v1.95ZM458.75,72.54h-1.95v-1.95h1.95v1.95ZM455.82,72.54h-1.95v-1.95h1.95v1.95ZM452.9,72.54h-1.95v-1.95h1.95v1.95ZM449.98,72.54h-1.95v-1.95h1.95v1.95ZM447.06,72.54h-1.95v-1.95h1.95v1.95ZM444.14,72.54h-1.95v-1.95h1.95v1.95ZM441.22,72.54h-1.95v-1.95h1.95v1.95ZM438.3,72.54h-1.95v-1.95h1.95v1.95ZM435.38,72.54h-1.95v-1.95h1.95v1.95ZM432.46,72.54h-1.95v-1.95h1.95v1.95ZM429.54,72.54h-1.95v-1.95h1.95v1.95ZM426.62,72.54h-1.95v-1.95h1.95v1.95ZM423.7,72.54h-1.95v-1.95h1.95v1.95ZM420.78,72.54h-1.95v-1.95h1.95v1.95ZM417.86,72.54h-1.95v-1.95h1.95v1.95ZM414.94,72.54h-1.95v-1.95h1.95v1.95ZM412.02,72.54h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,69.62h-1.95v-1.95h1.95v1.95ZM476.27,69.62h-1.95v-1.95h1.95v1.95ZM473.35,69.62h-1.95v-1.95h1.95v1.95ZM470.43,69.62h-1.95v-1.95h1.95v1.95ZM467.51,69.62h-1.95v-1.95h1.95v1.95ZM464.59,69.62h-1.95v-1.95h1.95v1.95ZM461.67,69.62h-1.95v-1.95h1.95v1.95ZM458.75,69.62h-1.95v-1.95h1.95v1.95ZM455.82,69.62h-1.95v-1.95h1.95v1.95ZM452.9,69.62h-1.95v-1.95h1.95v1.95ZM449.98,69.62h-1.95v-1.95h1.95v1.95ZM447.06,69.62h-1.95v-1.95h1.95v1.95ZM444.14,69.62h-1.95v-1.95h1.95v1.95ZM441.22,69.62h-1.95v-1.95h1.95v1.95ZM438.3,69.62h-1.95v-1.95h1.95v1.95ZM435.38,69.62h-1.95v-1.95h1.95v1.95ZM432.46,69.62h-1.95v-1.95h1.95v1.95ZM429.54,69.62h-1.95v-1.95h1.95v1.95ZM426.62,69.62h-1.95v-1.95h1.95v1.95ZM423.7,69.62h-1.95v-1.95h1.95v1.95ZM420.78,69.62h-1.95v-1.95h1.95v1.95ZM417.86,69.62h-1.95v-1.95h1.95v1.95ZM414.94,69.62h-1.95v-1.95h1.95v1.95ZM412.02,69.62h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,66.7h-1.95v-1.95h1.95v1.95ZM476.27,66.7h-1.95v-1.95h1.95v1.95ZM473.35,66.7h-1.95v-1.95h1.95v1.95ZM470.43,66.7h-1.95v-1.95h1.95v1.95ZM467.51,66.7h-1.95v-1.95h1.95v1.95ZM464.59,66.7h-1.95v-1.95h1.95v1.95ZM461.67,66.7h-1.95v-1.95h1.95v1.95ZM458.75,66.7h-1.95v-1.95h1.95v1.95ZM455.82,66.7h-1.95v-1.95h1.95v1.95ZM452.9,66.7h-1.95v-1.95h1.95v1.95ZM449.98,66.7h-1.95v-1.95h1.95v1.95ZM447.06,66.7h-1.95v-1.95h1.95v1.95ZM444.14,66.7h-1.95v-1.95h1.95v1.95ZM441.22,66.7h-1.95v-1.95h1.95v1.95ZM438.3,66.7h-1.95v-1.95h1.95v1.95ZM435.38,66.7h-1.95v-1.95h1.95v1.95ZM432.46,66.7h-1.95v-1.95h1.95v1.95ZM429.54,66.7h-1.95v-1.95h1.95v1.95ZM426.62,66.7h-1.95v-1.95h1.95v1.95ZM423.7,66.7h-1.95v-1.95h1.95v1.95ZM420.78,66.7h-1.95v-1.95h1.95v1.95ZM417.86,66.7h-1.95v-1.95h1.95v1.95ZM414.94,66.7h-1.95v-1.95h1.95v1.95ZM412.02,66.7h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,63.78h-1.95v-1.95h1.95v1.95ZM476.27,63.78h-1.95v-1.95h1.95v1.95ZM473.35,63.78h-1.95v-1.95h1.95v1.95ZM470.43,63.78h-1.95v-1.95h1.95v1.95ZM467.51,63.78h-1.95v-1.95h1.95v1.95ZM464.59,63.78h-1.95v-1.95h1.95v1.95ZM461.67,63.78h-1.95v-1.95h1.95v1.95ZM458.75,63.78h-1.95v-1.95h1.95v1.95ZM455.82,63.78h-1.95v-1.95h1.95v1.95ZM452.9,63.78h-1.95v-1.95h1.95v1.95ZM449.98,63.78h-1.95v-1.95h1.95v1.95ZM447.06,63.78h-1.95v-1.95h1.95v1.95ZM444.14,63.78h-1.95v-1.95h1.95v1.95ZM441.22,63.78h-1.95v-1.95h1.95v1.95ZM438.3,63.78h-1.95v-1.95h1.95v1.95ZM435.38,63.78h-1.95v-1.95h1.95v1.95ZM432.46,63.78h-1.95v-1.95h1.95v1.95ZM429.54,63.78h-1.95v-1.95h1.95v1.95ZM426.62,63.78h-1.95v-1.95h1.95v1.95ZM423.7,63.78h-1.95v-1.95h1.95v1.95ZM420.78,63.78h-1.95v-1.95h1.95v1.95ZM417.86,63.78h-1.95v-1.95h1.95v1.95ZM414.94,63.78h-1.95v-1.95h1.95v1.95ZM412.02,63.78h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,60.86h-1.95v-1.95h1.95v1.95ZM476.27,60.86h-1.95v-1.95h1.95v1.95ZM473.35,60.86h-1.95v-1.95h1.95v1.95ZM470.43,60.86h-1.95v-1.95h1.95v1.95ZM467.51,60.86h-1.95v-1.95h1.95v1.95ZM464.59,60.86h-1.95v-1.95h1.95v1.95ZM461.67,60.86h-1.95v-1.95h1.95v1.95ZM458.75,60.86h-1.95v-1.95h1.95v1.95ZM455.82,60.86h-1.95v-1.95h1.95v1.95ZM452.9,60.86h-1.95v-1.95h1.95v1.95ZM449.98,60.86h-1.95v-1.95h1.95v1.95ZM447.06,60.86h-1.95v-1.95h1.95v1.95ZM444.14,60.86h-1.95v-1.95h1.95v1.95ZM441.22,60.86h-1.95v-1.95h1.95v1.95ZM438.3,60.86h-1.95v-1.95h1.95v1.95ZM435.38,60.86h-1.95v-1.95h1.95v1.95ZM432.46,60.86h-1.95v-1.95h1.95v1.95ZM429.54,60.86h-1.95v-1.95h1.95v1.95ZM426.62,60.86h-1.95v-1.95h1.95v1.95ZM423.7,60.86h-1.95v-1.95h1.95v1.95ZM420.78,60.86h-1.95v-1.95h1.95v1.95ZM417.86,60.86h-1.95v-1.95h1.95v1.95ZM414.94,60.86h-1.95v-1.95h1.95v1.95ZM412.02,60.86h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.19,57.94h-1.95v-1.95h1.95v1.95ZM476.27,57.94h-1.95v-1.95h1.95v1.95ZM473.35,57.94h-1.95v-1.95h1.95v1.95ZM470.43,57.94h-1.95v-1.95h1.95v1.95ZM467.51,57.94h-1.95v-1.95h1.95v1.95ZM464.59,57.94h-1.95v-1.95h1.95v1.95ZM461.67,57.94h-1.95v-1.95h1.95v1.95ZM458.75,57.94h-1.95v-1.95h1.95v1.95ZM455.82,57.94h-1.95v-1.95h1.95v1.95ZM452.9,57.94h-1.95v-1.95h1.95v1.95ZM449.98,57.94h-1.95v-1.95h1.95v1.95ZM447.06,57.94h-1.95v-1.95h1.95v1.95ZM444.14,57.94h-1.95v-1.95h1.95v1.95ZM441.22,57.94h-1.95v-1.95h1.95v1.95ZM438.3,57.94h-1.95v-1.95h1.95v1.95ZM435.38,57.94h-1.95v-1.95h1.95v1.95ZM432.46,57.94h-1.95v-1.95h1.95v1.95ZM429.54,57.94h-1.95v-1.95h1.95v1.95ZM426.62,57.94h-1.95v-1.95h1.95v1.95ZM423.7,57.94h-1.95v-1.95h1.95v1.95ZM420.78,57.94h-1.95v-1.95h1.95v1.95ZM417.86,57.94h-1.95v-1.95h1.95v1.95ZM414.94,57.94h-1.95v-1.95h1.95v1.95ZM412.02,57.94h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,125.11h-1.95v-1.95h1.95v1.95ZM406.18,125.11h-1.95v-1.95h1.95v1.95ZM403.26,125.11h-1.95v-1.95h1.95v1.95ZM400.34,125.11h-1.95v-1.95h1.95v1.95ZM397.42,125.11h-1.95v-1.95h1.95v1.95ZM394.5,125.11h-1.95v-1.95h1.95v1.95ZM391.58,125.11h-1.95v-1.95h1.95v1.95ZM388.66,125.11h-1.95v-1.95h1.95v1.95ZM385.74,125.11h-1.95v-1.95h1.95v1.95ZM382.82,125.11h-1.95v-1.95h1.95v1.95ZM379.89,125.11h-1.95v-1.95h1.95v1.95ZM376.97,125.11h-1.95v-1.95h1.95v1.95ZM374.05,125.11h-1.95v-1.95h1.95v1.95ZM371.13,125.11h-1.95v-1.95h1.95v1.95ZM368.21,125.11h-1.95v-1.95h1.95v1.95ZM365.29,125.11h-1.95v-1.95h1.95v1.95ZM362.37,125.11h-1.95v-1.95h1.95v1.95ZM359.45,125.11h-1.95v-1.95h1.95v1.95ZM356.53,125.11h-1.95v-1.95h1.95v1.95ZM353.61,125.11h-1.95v-1.95h1.95v1.95ZM350.69,125.11h-1.95v-1.95h1.95v1.95ZM347.77,125.11h-1.95v-1.95h1.95v1.95ZM344.85,125.11h-1.95v-1.95h1.95v1.95ZM341.93,125.11h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,122.19h-1.95v-1.95h1.95v1.95ZM406.18,122.19h-1.95v-1.95h1.95v1.95ZM403.26,122.19h-1.95v-1.95h1.95v1.95ZM400.34,122.19h-1.95v-1.95h1.95v1.95ZM397.42,122.19h-1.95v-1.95h1.95v1.95ZM394.5,122.19h-1.95v-1.95h1.95v1.95ZM391.58,122.19h-1.95v-1.95h1.95v1.95ZM388.66,122.19h-1.95v-1.95h1.95v1.95ZM385.74,122.19h-1.95v-1.95h1.95v1.95ZM382.82,122.19h-1.95v-1.95h1.95v1.95ZM379.89,122.19h-1.95v-1.95h1.95v1.95ZM376.97,122.19h-1.95v-1.95h1.95v1.95ZM374.05,122.19h-1.95v-1.95h1.95v1.95ZM371.13,122.19h-1.95v-1.95h1.95v1.95ZM368.21,122.19h-1.95v-1.95h1.95v1.95ZM365.29,122.19h-1.95v-1.95h1.95v1.95ZM362.37,122.19h-1.95v-1.95h1.95v1.95ZM359.45,122.19h-1.95v-1.95h1.95v1.95ZM356.53,122.19h-1.95v-1.95h1.95v1.95ZM353.61,122.19h-1.95v-1.95h1.95v1.95ZM350.69,122.19h-1.95v-1.95h1.95v1.95ZM347.77,122.19h-1.95v-1.95h1.95v1.95ZM344.85,122.19h-1.95v-1.95h1.95v1.95ZM341.93,122.19h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,119.27h-1.95v-1.95h1.95v1.95ZM406.18,119.27h-1.95v-1.95h1.95v1.95ZM403.26,119.27h-1.95v-1.95h1.95v1.95ZM400.34,119.27h-1.95v-1.95h1.95v1.95ZM397.42,119.27h-1.95v-1.95h1.95v1.95ZM394.5,119.27h-1.95v-1.95h1.95v1.95ZM391.58,119.27h-1.95v-1.95h1.95v1.95ZM388.66,119.27h-1.95v-1.95h1.95v1.95ZM385.74,119.27h-1.95v-1.95h1.95v1.95ZM382.82,119.27h-1.95v-1.95h1.95v1.95ZM379.89,119.27h-1.95v-1.95h1.95v1.95ZM376.97,119.27h-1.95v-1.95h1.95v1.95ZM374.05,119.27h-1.95v-1.95h1.95v1.95ZM371.13,119.27h-1.95v-1.95h1.95v1.95ZM368.21,119.27h-1.95v-1.95h1.95v1.95ZM365.29,119.27h-1.95v-1.95h1.95v1.95ZM362.37,119.27h-1.95v-1.95h1.95v1.95ZM359.45,119.27h-1.95v-1.95h1.95v1.95ZM356.53,119.27h-1.95v-1.95h1.95v1.95ZM353.61,119.27h-1.95v-1.95h1.95v1.95ZM350.69,119.27h-1.95v-1.95h1.95v1.95ZM347.77,119.27h-1.95v-1.95h1.95v1.95ZM344.85,119.27h-1.95v-1.95h1.95v1.95ZM341.93,119.27h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,116.35h-1.95v-1.95h1.95v1.95ZM406.18,116.35h-1.95v-1.95h1.95v1.95ZM403.26,116.35h-1.95v-1.95h1.95v1.95ZM400.34,116.35h-1.95v-1.95h1.95v1.95ZM397.42,116.35h-1.95v-1.95h1.95v1.95ZM394.5,116.35h-1.95v-1.95h1.95v1.95ZM391.58,116.35h-1.95v-1.95h1.95v1.95ZM388.66,116.35h-1.95v-1.95h1.95v1.95ZM385.74,116.35h-1.95v-1.95h1.95v1.95ZM382.82,116.35h-1.95v-1.95h1.95v1.95ZM379.89,116.35h-1.95v-1.95h1.95v1.95ZM376.97,116.35h-1.95v-1.95h1.95v1.95ZM374.05,116.35h-1.95v-1.95h1.95v1.95ZM371.13,116.35h-1.95v-1.95h1.95v1.95ZM368.21,116.35h-1.95v-1.95h1.95v1.95ZM365.29,116.35h-1.95v-1.95h1.95v1.95ZM362.37,116.35h-1.95v-1.95h1.95v1.95ZM359.45,116.35h-1.95v-1.95h1.95v1.95ZM356.53,116.35h-1.95v-1.95h1.95v1.95ZM353.61,116.35h-1.95v-1.95h1.95v1.95ZM350.69,116.35h-1.95v-1.95h1.95v1.95ZM347.77,116.35h-1.95v-1.95h1.95v1.95ZM344.85,116.35h-1.95v-1.95h1.95v1.95ZM341.93,116.35h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,113.43h-1.95v-1.95h1.95v1.95ZM406.18,113.43h-1.95v-1.95h1.95v1.95ZM403.26,113.43h-1.95v-1.95h1.95v1.95ZM400.34,113.43h-1.95v-1.95h1.95v1.95ZM397.42,113.43h-1.95v-1.95h1.95v1.95ZM394.5,113.43h-1.95v-1.95h1.95v1.95ZM391.58,113.43h-1.95v-1.95h1.95v1.95ZM388.66,113.43h-1.95v-1.95h1.95v1.95ZM385.74,113.43h-1.95v-1.95h1.95v1.95ZM382.82,113.43h-1.95v-1.95h1.95v1.95ZM379.89,113.43h-1.95v-1.95h1.95v1.95ZM376.97,113.43h-1.95v-1.95h1.95v1.95ZM374.05,113.43h-1.95v-1.95h1.95v1.95ZM371.13,113.43h-1.95v-1.95h1.95v1.95ZM368.21,113.43h-1.95v-1.95h1.95v1.95ZM365.29,113.43h-1.95v-1.95h1.95v1.95ZM362.37,113.43h-1.95v-1.95h1.95v1.95ZM359.45,113.43h-1.95v-1.95h1.95v1.95ZM356.53,113.43h-1.95v-1.95h1.95v1.95ZM353.61,113.43h-1.95v-1.95h1.95v1.95ZM350.69,113.43h-1.95v-1.95h1.95v1.95ZM347.77,113.43h-1.95v-1.95h1.95v1.95ZM344.85,113.43h-1.95v-1.95h1.95v1.95ZM341.93,113.43h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,110.51h-1.95v-1.95h1.95v1.95ZM406.18,110.51h-1.95v-1.95h1.95v1.95ZM403.26,110.51h-1.95v-1.95h1.95v1.95ZM400.34,110.51h-1.95v-1.95h1.95v1.95ZM397.42,110.51h-1.95v-1.95h1.95v1.95ZM394.5,110.51h-1.95v-1.95h1.95v1.95ZM391.58,110.51h-1.95v-1.95h1.95v1.95ZM388.66,110.51h-1.95v-1.95h1.95v1.95ZM385.74,110.51h-1.95v-1.95h1.95v1.95ZM382.82,110.51h-1.95v-1.95h1.95v1.95ZM379.89,110.51h-1.95v-1.95h1.95v1.95ZM376.97,110.51h-1.95v-1.95h1.95v1.95ZM374.05,110.51h-1.95v-1.95h1.95v1.95ZM371.13,110.51h-1.95v-1.95h1.95v1.95ZM368.21,110.51h-1.95v-1.95h1.95v1.95ZM365.29,110.51h-1.95v-1.95h1.95v1.95ZM362.37,110.51h-1.95v-1.95h1.95v1.95ZM359.45,110.51h-1.95v-1.95h1.95v1.95ZM356.53,110.51h-1.95v-1.95h1.95v1.95ZM353.61,110.51h-1.95v-1.95h1.95v1.95ZM350.69,110.51h-1.95v-1.95h1.95v1.95ZM347.77,110.51h-1.95v-1.95h1.95v1.95ZM344.85,110.51h-1.95v-1.95h1.95v1.95ZM341.93,110.51h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,107.59h-1.95v-1.95h1.95v1.95ZM406.18,107.59h-1.95v-1.95h1.95v1.95ZM403.26,107.59h-1.95v-1.95h1.95v1.95ZM400.34,107.59h-1.95v-1.95h1.95v1.95ZM397.42,107.59h-1.95v-1.95h1.95v1.95ZM394.5,107.59h-1.95v-1.95h1.95v1.95ZM391.58,107.59h-1.95v-1.95h1.95v1.95ZM388.66,107.59h-1.95v-1.95h1.95v1.95ZM385.74,107.59h-1.95v-1.95h1.95v1.95ZM382.82,107.59h-1.95v-1.95h1.95v1.95ZM379.89,107.59h-1.95v-1.95h1.95v1.95ZM376.97,107.59h-1.95v-1.95h1.95v1.95ZM374.05,107.59h-1.95v-1.95h1.95v1.95ZM371.13,107.59h-1.95v-1.95h1.95v1.95ZM368.21,107.59h-1.95v-1.95h1.95v1.95ZM365.29,107.59h-1.95v-1.95h1.95v1.95ZM362.37,107.59h-1.95v-1.95h1.95v1.95ZM359.45,107.59h-1.95v-1.95h1.95v1.95ZM356.53,107.59h-1.95v-1.95h1.95v1.95ZM353.61,107.59h-1.95v-1.95h1.95v1.95ZM350.69,107.59h-1.95v-1.95h1.95v1.95ZM347.77,107.59h-1.95v-1.95h1.95v1.95ZM344.85,107.59h-1.95v-1.95h1.95v1.95ZM341.93,107.59h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,104.67h-1.95v-1.95h1.95v1.95ZM406.18,104.67h-1.95v-1.95h1.95v1.95ZM403.26,104.67h-1.95v-1.95h1.95v1.95ZM400.34,104.67h-1.95v-1.95h1.95v1.95ZM397.42,104.67h-1.95v-1.95h1.95v1.95ZM394.5,104.67h-1.95v-1.95h1.95v1.95ZM391.58,104.67h-1.95v-1.95h1.95v1.95ZM388.66,104.67h-1.95v-1.95h1.95v1.95ZM385.74,104.67h-1.95v-1.95h1.95v1.95ZM382.82,104.67h-1.95v-1.95h1.95v1.95ZM379.89,104.67h-1.95v-1.95h1.95v1.95ZM376.97,104.67h-1.95v-1.95h1.95v1.95ZM374.05,104.67h-1.95v-1.95h1.95v1.95ZM371.13,104.67h-1.95v-1.95h1.95v1.95ZM368.21,104.67h-1.95v-1.95h1.95v1.95ZM365.29,104.67h-1.95v-1.95h1.95v1.95ZM362.37,104.67h-1.95v-1.95h1.95v1.95ZM359.45,104.67h-1.95v-1.95h1.95v1.95ZM356.53,104.67h-1.95v-1.95h1.95v1.95ZM353.61,104.67h-1.95v-1.95h1.95v1.95ZM350.69,104.67h-1.95v-1.95h1.95v1.95ZM347.77,104.67h-1.95v-1.95h1.95v1.95ZM344.85,104.67h-1.95v-1.95h1.95v1.95ZM341.93,104.67h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,101.75h-1.95v-1.95h1.95v1.95ZM406.18,101.75h-1.95v-1.95h1.95v1.95ZM403.26,101.75h-1.95v-1.95h1.95v1.95ZM400.34,101.75h-1.95v-1.95h1.95v1.95ZM397.42,101.75h-1.95v-1.95h1.95v1.95ZM394.5,101.75h-1.95v-1.95h1.95v1.95ZM391.58,101.75h-1.95v-1.95h1.95v1.95ZM388.66,101.75h-1.95v-1.95h1.95v1.95ZM385.74,101.75h-1.95v-1.95h1.95v1.95ZM382.82,101.75h-1.95v-1.95h1.95v1.95ZM379.89,101.75h-1.95v-1.95h1.95v1.95ZM376.97,101.75h-1.95v-1.95h1.95v1.95ZM374.05,101.75h-1.95v-1.95h1.95v1.95ZM371.13,101.75h-1.95v-1.95h1.95v1.95ZM368.21,101.75h-1.95v-1.95h1.95v1.95ZM365.29,101.75h-1.95v-1.95h1.95v1.95ZM362.37,101.75h-1.95v-1.95h1.95v1.95ZM359.45,101.75h-1.95v-1.95h1.95v1.95ZM356.53,101.75h-1.95v-1.95h1.95v1.95ZM353.61,101.75h-1.95v-1.95h1.95v1.95ZM350.69,101.75h-1.95v-1.95h1.95v1.95ZM347.77,101.75h-1.95v-1.95h1.95v1.95ZM344.85,101.75h-1.95v-1.95h1.95v1.95ZM341.93,101.75h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,98.83h-1.95v-1.95h1.95v1.95ZM406.18,98.83h-1.95v-1.95h1.95v1.95ZM403.26,98.83h-1.95v-1.95h1.95v1.95ZM400.34,98.83h-1.95v-1.95h1.95v1.95ZM397.42,98.83h-1.95v-1.95h1.95v1.95ZM394.5,98.83h-1.95v-1.95h1.95v1.95ZM391.58,98.83h-1.95v-1.95h1.95v1.95ZM388.66,98.83h-1.95v-1.95h1.95v1.95ZM385.74,98.83h-1.95v-1.95h1.95v1.95ZM382.82,98.83h-1.95v-1.95h1.95v1.95ZM379.89,98.83h-1.95v-1.95h1.95v1.95ZM376.97,98.83h-1.95v-1.95h1.95v1.95ZM374.05,98.83h-1.95v-1.95h1.95v1.95ZM371.13,98.83h-1.95v-1.95h1.95v1.95ZM368.21,98.83h-1.95v-1.95h1.95v1.95ZM365.29,98.83h-1.95v-1.95h1.95v1.95ZM362.37,98.83h-1.95v-1.95h1.95v1.95ZM359.45,98.83h-1.95v-1.95h1.95v1.95ZM356.53,98.83h-1.95v-1.95h1.95v1.95ZM353.61,98.83h-1.95v-1.95h1.95v1.95ZM350.69,98.83h-1.95v-1.95h1.95v1.95ZM347.77,98.83h-1.95v-1.95h1.95v1.95ZM344.85,98.83h-1.95v-1.95h1.95v1.95ZM341.93,98.83h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,95.91h-1.95v-1.95h1.95v1.95ZM406.18,95.91h-1.95v-1.95h1.95v1.95ZM403.26,95.91h-1.95v-1.95h1.95v1.95ZM400.34,95.91h-1.95v-1.95h1.95v1.95ZM397.42,95.91h-1.95v-1.95h1.95v1.95ZM394.5,95.91h-1.95v-1.95h1.95v1.95ZM391.58,95.91h-1.95v-1.95h1.95v1.95ZM388.66,95.91h-1.95v-1.95h1.95v1.95ZM385.74,95.91h-1.95v-1.95h1.95v1.95ZM382.82,95.91h-1.95v-1.95h1.95v1.95ZM379.89,95.91h-1.95v-1.95h1.95v1.95ZM376.97,95.91h-1.95v-1.95h1.95v1.95ZM374.05,95.91h-1.95v-1.95h1.95v1.95ZM371.13,95.91h-1.95v-1.95h1.95v1.95ZM368.21,95.91h-1.95v-1.95h1.95v1.95ZM365.29,95.91h-1.95v-1.95h1.95v1.95ZM362.37,95.91h-1.95v-1.95h1.95v1.95ZM359.45,95.91h-1.95v-1.95h1.95v1.95ZM356.53,95.91h-1.95v-1.95h1.95v1.95ZM353.61,95.91h-1.95v-1.95h1.95v1.95ZM350.69,95.91h-1.95v-1.95h1.95v1.95ZM347.77,95.91h-1.95v-1.95h1.95v1.95ZM344.85,95.91h-1.95v-1.95h1.95v1.95ZM341.93,95.91h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,92.99h-1.95v-1.95h1.95v1.95ZM406.18,92.99h-1.95v-1.95h1.95v1.95ZM403.26,92.99h-1.95v-1.95h1.95v1.95ZM400.34,92.99h-1.95v-1.95h1.95v1.95ZM397.42,92.99h-1.95v-1.95h1.95v1.95ZM394.5,92.99h-1.95v-1.95h1.95v1.95ZM391.58,92.99h-1.95v-1.95h1.95v1.95ZM388.66,92.99h-1.95v-1.95h1.95v1.95ZM385.74,92.99h-1.95v-1.95h1.95v1.95ZM382.82,92.99h-1.95v-1.95h1.95v1.95ZM379.89,92.99h-1.95v-1.95h1.95v1.95ZM376.97,92.99h-1.95v-1.95h1.95v1.95ZM374.05,92.99h-1.95v-1.95h1.95v1.95ZM371.13,92.99h-1.95v-1.95h1.95v1.95ZM368.21,92.99h-1.95v-1.95h1.95v1.95ZM365.29,92.99h-1.95v-1.95h1.95v1.95ZM362.37,92.99h-1.95v-1.95h1.95v1.95ZM359.45,92.99h-1.95v-1.95h1.95v1.95ZM356.53,92.99h-1.95v-1.95h1.95v1.95ZM353.61,92.99h-1.95v-1.95h1.95v1.95ZM350.69,92.99h-1.95v-1.95h1.95v1.95ZM347.77,92.99h-1.95v-1.95h1.95v1.95ZM344.85,92.99h-1.95v-1.95h1.95v1.95ZM341.93,92.99h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,90.07h-1.95v-1.95h1.95v1.95ZM406.18,90.07h-1.95v-1.95h1.95v1.95ZM403.26,90.07h-1.95v-1.95h1.95v1.95ZM400.34,90.07h-1.95v-1.95h1.95v1.95ZM397.42,90.07h-1.95v-1.95h1.95v1.95ZM394.5,90.07h-1.95v-1.95h1.95v1.95ZM391.58,90.07h-1.95v-1.95h1.95v1.95ZM388.66,90.07h-1.95v-1.95h1.95v1.95ZM385.74,90.07h-1.95v-1.95h1.95v1.95ZM382.82,90.07h-1.95v-1.95h1.95v1.95ZM379.89,90.07h-1.95v-1.95h1.95v1.95ZM376.97,90.07h-1.95v-1.95h1.95v1.95ZM374.05,90.07h-1.95v-1.95h1.95v1.95ZM371.13,90.07h-1.95v-1.95h1.95v1.95ZM368.21,90.07h-1.95v-1.95h1.95v1.95ZM365.29,90.07h-1.95v-1.95h1.95v1.95ZM362.37,90.07h-1.95v-1.95h1.95v1.95ZM359.45,90.07h-1.95v-1.95h1.95v1.95ZM356.53,90.07h-1.95v-1.95h1.95v1.95ZM353.61,90.07h-1.95v-1.95h1.95v1.95ZM350.69,90.07h-1.95v-1.95h1.95v1.95ZM347.77,90.07h-1.95v-1.95h1.95v1.95ZM344.85,90.07h-1.95v-1.95h1.95v1.95ZM341.93,90.07h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,87.15h-1.95v-1.95h1.95v1.95ZM406.18,87.15h-1.95v-1.95h1.95v1.95ZM403.26,87.15h-1.95v-1.95h1.95v1.95ZM400.34,87.15h-1.95v-1.95h1.95v1.95ZM397.42,87.15h-1.95v-1.95h1.95v1.95ZM394.5,87.15h-1.95v-1.95h1.95v1.95ZM391.58,87.15h-1.95v-1.95h1.95v1.95ZM388.66,87.15h-1.95v-1.95h1.95v1.95ZM385.74,87.15h-1.95v-1.95h1.95v1.95ZM382.82,87.15h-1.95v-1.95h1.95v1.95ZM379.89,87.15h-1.95v-1.95h1.95v1.95ZM376.97,87.15h-1.95v-1.95h1.95v1.95ZM374.05,87.15h-1.95v-1.95h1.95v1.95ZM371.13,87.15h-1.95v-1.95h1.95v1.95ZM368.21,87.15h-1.95v-1.95h1.95v1.95ZM365.29,87.15h-1.95v-1.95h1.95v1.95ZM362.37,87.15h-1.95v-1.95h1.95v1.95ZM359.45,87.15h-1.95v-1.95h1.95v1.95ZM356.53,87.15h-1.95v-1.95h1.95v1.95ZM353.61,87.15h-1.95v-1.95h1.95v1.95ZM350.69,87.15h-1.95v-1.95h1.95v1.95ZM347.77,87.15h-1.95v-1.95h1.95v1.95ZM344.85,87.15h-1.95v-1.95h1.95v1.95ZM341.93,87.15h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,84.23h-1.95v-1.95h1.95v1.95ZM406.18,84.23h-1.95v-1.95h1.95v1.95ZM403.26,84.23h-1.95v-1.95h1.95v1.95ZM400.34,84.23h-1.95v-1.95h1.95v1.95ZM397.42,84.23h-1.95v-1.95h1.95v1.95ZM394.5,84.23h-1.95v-1.95h1.95v1.95ZM391.58,84.23h-1.95v-1.95h1.95v1.95ZM388.66,84.23h-1.95v-1.95h1.95v1.95ZM385.74,84.23h-1.95v-1.95h1.95v1.95ZM382.82,84.23h-1.95v-1.95h1.95v1.95ZM379.89,84.23h-1.95v-1.95h1.95v1.95ZM376.97,84.23h-1.95v-1.95h1.95v1.95ZM374.05,84.23h-1.95v-1.95h1.95v1.95ZM371.13,84.23h-1.95v-1.95h1.95v1.95ZM368.21,84.23h-1.95v-1.95h1.95v1.95ZM365.29,84.23h-1.95v-1.95h1.95v1.95ZM362.37,84.23h-1.95v-1.95h1.95v1.95ZM359.45,84.23h-1.95v-1.95h1.95v1.95ZM356.53,84.23h-1.95v-1.95h1.95v1.95ZM353.61,84.23h-1.95v-1.95h1.95v1.95ZM350.69,84.23h-1.95v-1.95h1.95v1.95ZM347.77,84.23h-1.95v-1.95h1.95v1.95ZM344.85,84.23h-1.95v-1.95h1.95v1.95ZM341.93,84.23h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,81.31h-1.95v-1.95h1.95v1.95ZM406.18,81.31h-1.95v-1.95h1.95v1.95ZM403.26,81.31h-1.95v-1.95h1.95v1.95ZM400.34,81.31h-1.95v-1.95h1.95v1.95ZM397.42,81.31h-1.95v-1.95h1.95v1.95ZM394.5,81.31h-1.95v-1.95h1.95v1.95ZM391.58,81.31h-1.95v-1.95h1.95v1.95ZM388.66,81.31h-1.95v-1.95h1.95v1.95ZM385.74,81.31h-1.95v-1.95h1.95v1.95ZM382.82,81.31h-1.95v-1.95h1.95v1.95ZM379.89,81.31h-1.95v-1.95h1.95v1.95ZM376.97,81.31h-1.95v-1.95h1.95v1.95ZM374.05,81.31h-1.95v-1.95h1.95v1.95ZM371.13,81.31h-1.95v-1.95h1.95v1.95ZM368.21,81.31h-1.95v-1.95h1.95v1.95ZM365.29,81.31h-1.95v-1.95h1.95v1.95ZM362.37,81.31h-1.95v-1.95h1.95v1.95ZM359.45,81.31h-1.95v-1.95h1.95v1.95ZM356.53,81.31h-1.95v-1.95h1.95v1.95ZM353.61,81.31h-1.95v-1.95h1.95v1.95ZM350.69,81.31h-1.95v-1.95h1.95v1.95ZM347.77,81.31h-1.95v-1.95h1.95v1.95ZM344.85,81.31h-1.95v-1.95h1.95v1.95ZM341.93,81.31h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,78.39h-1.95v-1.95h1.95v1.95ZM406.18,78.39h-1.95v-1.95h1.95v1.95ZM403.26,78.39h-1.95v-1.95h1.95v1.95ZM400.34,78.39h-1.95v-1.95h1.95v1.95ZM397.42,78.39h-1.95v-1.95h1.95v1.95ZM394.5,78.39h-1.95v-1.95h1.95v1.95ZM391.58,78.39h-1.95v-1.95h1.95v1.95ZM388.66,78.39h-1.95v-1.95h1.95v1.95ZM385.74,78.39h-1.95v-1.95h1.95v1.95ZM382.82,78.39h-1.95v-1.95h1.95v1.95ZM379.89,78.39h-1.95v-1.95h1.95v1.95ZM376.97,78.39h-1.95v-1.95h1.95v1.95ZM374.05,78.39h-1.95v-1.95h1.95v1.95ZM371.13,78.39h-1.95v-1.95h1.95v1.95ZM368.21,78.39h-1.95v-1.95h1.95v1.95ZM365.29,78.39h-1.95v-1.95h1.95v1.95ZM362.37,78.39h-1.95v-1.95h1.95v1.95ZM359.45,78.39h-1.95v-1.95h1.95v1.95ZM356.53,78.39h-1.95v-1.95h1.95v1.95ZM353.61,78.39h-1.95v-1.95h1.95v1.95ZM350.69,78.39h-1.95v-1.95h1.95v1.95ZM347.77,78.39h-1.95v-1.95h1.95v1.95ZM344.85,78.39h-1.95v-1.95h1.95v1.95ZM341.93,78.39h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,75.47h-1.95v-1.95h1.95v1.95ZM406.18,75.47h-1.95v-1.95h1.95v1.95ZM403.26,75.47h-1.95v-1.95h1.95v1.95ZM400.34,75.47h-1.95v-1.95h1.95v1.95ZM397.42,75.47h-1.95v-1.95h1.95v1.95ZM394.5,75.47h-1.95v-1.95h1.95v1.95ZM391.58,75.47h-1.95v-1.95h1.95v1.95ZM388.66,75.47h-1.95v-1.95h1.95v1.95ZM385.74,75.47h-1.95v-1.95h1.95v1.95ZM382.82,75.47h-1.95v-1.95h1.95v1.95ZM379.89,75.47h-1.95v-1.95h1.95v1.95ZM376.97,75.47h-1.95v-1.95h1.95v1.95ZM374.05,75.47h-1.95v-1.95h1.95v1.95ZM371.13,75.47h-1.95v-1.95h1.95v1.95ZM368.21,75.47h-1.95v-1.95h1.95v1.95ZM365.29,75.47h-1.95v-1.95h1.95v1.95ZM362.37,75.47h-1.95v-1.95h1.95v1.95ZM359.45,75.47h-1.95v-1.95h1.95v1.95ZM356.53,75.47h-1.95v-1.95h1.95v1.95ZM353.61,75.47h-1.95v-1.95h1.95v1.95ZM350.69,75.47h-1.95v-1.95h1.95v1.95ZM347.77,75.47h-1.95v-1.95h1.95v1.95ZM344.85,75.47h-1.95v-1.95h1.95v1.95ZM341.93,75.47h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,72.54h-1.95v-1.95h1.95v1.95ZM406.18,72.54h-1.95v-1.95h1.95v1.95ZM403.26,72.54h-1.95v-1.95h1.95v1.95ZM400.34,72.54h-1.95v-1.95h1.95v1.95ZM397.42,72.54h-1.95v-1.95h1.95v1.95ZM394.5,72.54h-1.95v-1.95h1.95v1.95ZM391.58,72.54h-1.95v-1.95h1.95v1.95ZM388.66,72.54h-1.95v-1.95h1.95v1.95ZM385.74,72.54h-1.95v-1.95h1.95v1.95ZM382.82,72.54h-1.95v-1.95h1.95v1.95ZM379.89,72.54h-1.95v-1.95h1.95v1.95ZM376.97,72.54h-1.95v-1.95h1.95v1.95ZM374.05,72.54h-1.95v-1.95h1.95v1.95ZM371.13,72.54h-1.95v-1.95h1.95v1.95ZM368.21,72.54h-1.95v-1.95h1.95v1.95ZM365.29,72.54h-1.95v-1.95h1.95v1.95ZM362.37,72.54h-1.95v-1.95h1.95v1.95ZM359.45,72.54h-1.95v-1.95h1.95v1.95ZM356.53,72.54h-1.95v-1.95h1.95v1.95ZM353.61,72.54h-1.95v-1.95h1.95v1.95ZM350.69,72.54h-1.95v-1.95h1.95v1.95ZM347.77,72.54h-1.95v-1.95h1.95v1.95ZM344.85,72.54h-1.95v-1.95h1.95v1.95ZM341.93,72.54h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,69.62h-1.95v-1.95h1.95v1.95ZM406.18,69.62h-1.95v-1.95h1.95v1.95ZM403.26,69.62h-1.95v-1.95h1.95v1.95ZM400.34,69.62h-1.95v-1.95h1.95v1.95ZM397.42,69.62h-1.95v-1.95h1.95v1.95ZM394.5,69.62h-1.95v-1.95h1.95v1.95ZM391.58,69.62h-1.95v-1.95h1.95v1.95ZM388.66,69.62h-1.95v-1.95h1.95v1.95ZM385.74,69.62h-1.95v-1.95h1.95v1.95ZM382.82,69.62h-1.95v-1.95h1.95v1.95ZM379.89,69.62h-1.95v-1.95h1.95v1.95ZM376.97,69.62h-1.95v-1.95h1.95v1.95ZM374.05,69.62h-1.95v-1.95h1.95v1.95ZM371.13,69.62h-1.95v-1.95h1.95v1.95ZM368.21,69.62h-1.95v-1.95h1.95v1.95ZM365.29,69.62h-1.95v-1.95h1.95v1.95ZM362.37,69.62h-1.95v-1.95h1.95v1.95ZM359.45,69.62h-1.95v-1.95h1.95v1.95ZM356.53,69.62h-1.95v-1.95h1.95v1.95ZM353.61,69.62h-1.95v-1.95h1.95v1.95ZM350.69,69.62h-1.95v-1.95h1.95v1.95ZM347.77,69.62h-1.95v-1.95h1.95v1.95ZM344.85,69.62h-1.95v-1.95h1.95v1.95ZM341.93,69.62h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,66.7h-1.95v-1.95h1.95v1.95ZM406.18,66.7h-1.95v-1.95h1.95v1.95ZM403.26,66.7h-1.95v-1.95h1.95v1.95ZM400.34,66.7h-1.95v-1.95h1.95v1.95ZM397.42,66.7h-1.95v-1.95h1.95v1.95ZM394.5,66.7h-1.95v-1.95h1.95v1.95ZM391.58,66.7h-1.95v-1.95h1.95v1.95ZM388.66,66.7h-1.95v-1.95h1.95v1.95ZM385.74,66.7h-1.95v-1.95h1.95v1.95ZM382.82,66.7h-1.95v-1.95h1.95v1.95ZM379.89,66.7h-1.95v-1.95h1.95v1.95ZM376.97,66.7h-1.95v-1.95h1.95v1.95ZM374.05,66.7h-1.95v-1.95h1.95v1.95ZM371.13,66.7h-1.95v-1.95h1.95v1.95ZM368.21,66.7h-1.95v-1.95h1.95v1.95ZM365.29,66.7h-1.95v-1.95h1.95v1.95ZM362.37,66.7h-1.95v-1.95h1.95v1.95ZM359.45,66.7h-1.95v-1.95h1.95v1.95ZM356.53,66.7h-1.95v-1.95h1.95v1.95ZM353.61,66.7h-1.95v-1.95h1.95v1.95ZM350.69,66.7h-1.95v-1.95h1.95v1.95ZM347.77,66.7h-1.95v-1.95h1.95v1.95ZM344.85,66.7h-1.95v-1.95h1.95v1.95ZM341.93,66.7h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,63.78h-1.95v-1.95h1.95v1.95ZM406.18,63.78h-1.95v-1.95h1.95v1.95ZM403.26,63.78h-1.95v-1.95h1.95v1.95ZM400.34,63.78h-1.95v-1.95h1.95v1.95ZM397.42,63.78h-1.95v-1.95h1.95v1.95ZM394.5,63.78h-1.95v-1.95h1.95v1.95ZM391.58,63.78h-1.95v-1.95h1.95v1.95ZM388.66,63.78h-1.95v-1.95h1.95v1.95ZM385.74,63.78h-1.95v-1.95h1.95v1.95ZM382.82,63.78h-1.95v-1.95h1.95v1.95ZM379.89,63.78h-1.95v-1.95h1.95v1.95ZM376.97,63.78h-1.95v-1.95h1.95v1.95ZM374.05,63.78h-1.95v-1.95h1.95v1.95ZM371.13,63.78h-1.95v-1.95h1.95v1.95ZM368.21,63.78h-1.95v-1.95h1.95v1.95ZM365.29,63.78h-1.95v-1.95h1.95v1.95ZM362.37,63.78h-1.95v-1.95h1.95v1.95ZM359.45,63.78h-1.95v-1.95h1.95v1.95ZM356.53,63.78h-1.95v-1.95h1.95v1.95ZM353.61,63.78h-1.95v-1.95h1.95v1.95ZM350.69,63.78h-1.95v-1.95h1.95v1.95ZM347.77,63.78h-1.95v-1.95h1.95v1.95ZM344.85,63.78h-1.95v-1.95h1.95v1.95ZM341.93,63.78h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,60.86h-1.95v-1.95h1.95v1.95ZM406.18,60.86h-1.95v-1.95h1.95v1.95ZM403.26,60.86h-1.95v-1.95h1.95v1.95ZM400.34,60.86h-1.95v-1.95h1.95v1.95ZM397.42,60.86h-1.95v-1.95h1.95v1.95ZM394.5,60.86h-1.95v-1.95h1.95v1.95ZM391.58,60.86h-1.95v-1.95h1.95v1.95ZM388.66,60.86h-1.95v-1.95h1.95v1.95ZM385.74,60.86h-1.95v-1.95h1.95v1.95ZM382.82,60.86h-1.95v-1.95h1.95v1.95ZM379.89,60.86h-1.95v-1.95h1.95v1.95ZM376.97,60.86h-1.95v-1.95h1.95v1.95ZM374.05,60.86h-1.95v-1.95h1.95v1.95ZM371.13,60.86h-1.95v-1.95h1.95v1.95ZM368.21,60.86h-1.95v-1.95h1.95v1.95ZM365.29,60.86h-1.95v-1.95h1.95v1.95ZM362.37,60.86h-1.95v-1.95h1.95v1.95ZM359.45,60.86h-1.95v-1.95h1.95v1.95ZM356.53,60.86h-1.95v-1.95h1.95v1.95ZM353.61,60.86h-1.95v-1.95h1.95v1.95ZM350.69,60.86h-1.95v-1.95h1.95v1.95ZM347.77,60.86h-1.95v-1.95h1.95v1.95ZM344.85,60.86h-1.95v-1.95h1.95v1.95ZM341.93,60.86h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,57.94h-1.95v-1.95h1.95v1.95ZM406.18,57.94h-1.95v-1.95h1.95v1.95ZM403.26,57.94h-1.95v-1.95h1.95v1.95ZM400.34,57.94h-1.95v-1.95h1.95v1.95ZM397.42,57.94h-1.95v-1.95h1.95v1.95ZM394.5,57.94h-1.95v-1.95h1.95v1.95ZM391.58,57.94h-1.95v-1.95h1.95v1.95ZM388.66,57.94h-1.95v-1.95h1.95v1.95ZM385.74,57.94h-1.95v-1.95h1.95v1.95ZM382.82,57.94h-1.95v-1.95h1.95v1.95ZM379.89,57.94h-1.95v-1.95h1.95v1.95ZM376.97,57.94h-1.95v-1.95h1.95v1.95ZM374.05,57.94h-1.95v-1.95h1.95v1.95ZM371.13,57.94h-1.95v-1.95h1.95v1.95ZM368.21,57.94h-1.95v-1.95h1.95v1.95ZM365.29,57.94h-1.95v-1.95h1.95v1.95ZM362.37,57.94h-1.95v-1.95h1.95v1.95ZM359.45,57.94h-1.95v-1.95h1.95v1.95ZM356.53,57.94h-1.95v-1.95h1.95v1.95ZM353.61,57.94h-1.95v-1.95h1.95v1.95ZM350.69,57.94h-1.95v-1.95h1.95v1.95ZM347.77,57.94h-1.95v-1.95h1.95v1.95ZM344.85,57.94h-1.95v-1.95h1.95v1.95ZM341.93,57.94h-1.95v-1.95h1.95v1.95Z",
    style: {
      fill: "#6868ac"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.47,67.42l-.35-22.17c0-.51.58-1.06.73-1.12,1.69-.71,3.66-.92,6.03-.62,1.25.16,2.46.53,3.6,1.1,1.38.67,2.93.9,4.48.65,2.93-.48,5.4-2.82,6-5.71.5-2.34-.15-3.68-1.5-5.33-1.4-1.73-3.48-2.72-5.72-2.72-1.19,0-2.33.28-3.4.83-1.19.6-2.6.97-4.2,1.11-1.92.17-5.34-.95-5.83-1.4l-.16-.15-.03-.27-1-21.6h.51c24.06-.47,24.13-.3,24.3.1.1.22.19.42.28.59.56,1.17.69,1.57.42,3.65-.16,1.21-.53,2.42-1.1,3.6-.68,1.4-.9,2.96-.66,4.51.48,2.94,2.82,5.41,5.7,6.01,2.26.46,4.54-.08,6.26-1.48,1.76-1.41,2.76-3.52,2.76-5.77,0-1.22-.27-2.36-.81-3.4-.62-1.23-.98-2.6-1.11-4.2-.14-1.63-.01-1.96.4-2.74.1-.2.23-.44.38-.77.17-.37.24-.52,23.22-1.83l.53-.03v21.21c0,.14.02.35.04.5,1.32.5,2.82.68,4.57.53,1.49-.12,2.74-.45,3.83-1,1.21-.62,2.51-.94,3.86-.94,2.54,0,4.91,1.12,6.5,3.09,1.63,1.98,2.25,4.58,1.71,7.14-.68,3.28-3.49,5.95-6.82,6.49-1.76.28-3.51.02-5.08-.74-1.05-.52-2.15-.86-3.29-1.01-2.06-.26-3.79-.11-5.25.45-.11,1.72.01,11.95.18,21.79v.5s-22.85.34-22.85.34c-.5,0-.94-.28-1.12-.71-.77-1.72-1-3.74-.69-6.15.05-.41.15-.86.28-1.36.19-.6.42-1.16.67-1.69.2-.41.36-.86.5-1.43.38-1.19.48-2.38.29-3.56-.47-2.92-2.79-5.37-5.63-5.96-2.23-.46-4.48.08-6.18,1.47-1.74,1.4-2.73,3.49-2.73,5.73,0,1.21.27,2.35.8,3.38.61,1.22.97,2.58,1.1,4.17.16,1.85-.04,3.46-.58,4.92-.13.27-.23.48-.32.7l-.11.15c-.11.11-.25.2-.4.26l-.17.04-3.66.19-19.17.7ZM411.32,45.01c-.08.08-.19.22-.21.28l.34,21.09,18.14-.66,3.52-.18c.08-.18.17-.37.27-.56.47-1.27.65-2.74.5-4.44-.12-1.46-.45-2.7-1-3.8-.6-1.17-.91-2.46-.91-3.83,0-2.54,1.13-4.91,3.1-6.5,1.93-1.58,4.49-2.19,7.02-1.67,3.24.68,5.88,3.47,6.41,6.79.21,1.35.11,2.69-.32,4-.15.6-.33,1.12-.56,1.59-.24.48-.44,1-.61,1.53-.12.44-.2.84-.25,1.21-.28,2.22-.08,4.06.61,5.62.04.09.13.12.2.12l21.85-.32c-.38-21.89-.24-21.95.18-22.13,1.69-.71,3.66-.91,6.03-.62,1.25.16,2.46.53,3.6,1.1,1.38.67,2.93.9,4.48.65,2.93-.48,5.4-2.82,6-5.71.48-2.26-.07-4.56-1.5-6.3-1.4-1.73-3.48-2.72-5.72-2.72-1.19,0-2.33.28-3.4.83-1.19.6-2.6.97-4.2,1.11-2.02.17-3.75-.05-5.28-.7-.46-.2-.43-1.2-.41-1.52h0V9.31c-8.27.47-20.18,1.21-21.94,1.44-.11.24-.21.43-.3.59-.33.62-.41.77-.29,2.19.12,1.47.45,2.72,1.01,3.83.61,1.18.92,2.48.92,3.86,0,2.56-1.14,4.94-3.14,6.55-1.95,1.59-4.54,2.2-7.09,1.68-3.28-.68-5.94-3.49-6.48-6.83-.28-1.75-.02-3.51.74-5.1.53-1.09.87-2.2,1.01-3.29.24-1.87.15-2.06-.33-3.09-.05-.11-.11-.24-.17-.37-1.89-.12-14.35.06-22.97.22l.94,20.37c.68.35,3.37,1.21,4.95,1.07,1.47-.12,2.76-.46,3.83-1,1.21-.62,2.51-.94,3.86-.94,2.54,0,4.91,1.12,6.5,3.09,1.52,1.85,2.28,3.45,1.71,6.17-.68,3.28-3.49,5.95-6.82,6.49-1.75.28-3.51.02-5.08-.74-1.05-.52-2.15-.86-3.29-1.01-2.15-.27-3.93-.1-5.43.52Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.23,90.82c-1.48-1.83-3.68-2.88-6.04-2.88-1.27,0-2.47.3-3.59.88-1.1.56-2.41.92-3.96,1.05-1.94.17-3.57-.06-4.99-.65-.26-.11-.43-.37-.43-.65l-.21-22.79h-.07s-22.36.33-22.36.33c-.28,0-.54-.15-.65-.41-.73-1.63-.95-3.55-.65-5.89.06-.43.15-.86.27-1.3.19-.71.44-1.43.78-2.13.16-.33.28-.66.39-1,.39-1.2.5-2.48.3-3.77-.5-3.12-2.97-5.74-6.02-6.38-2.37-.49-4.77.07-6.6,1.57-1.85,1.5-2.92,3.72-2.92,6.11,0,1.27.28,2.49.86,3.61.56,1.12.92,2.41,1.05,3.98.15,1.81-.05,3.35-.56,4.7-.06.16-.11.33-.17.48-.03.07-.08.14-.14.19-.07.07-.15.12-.24.16-.09.04-.18.06-.28.06l-3.38.12-18.65.68s0,.1,0,.27c.01.54.04,1.89.08,3.65l.8,16.75s.04,1.03.1,1.05c1.42.6,2.08.82,4.03.66,1.55-.13,2.87-.49,3.97-1.05,1.12-.58,2.32-.88,3.6-.88,1.85,0,3.46.77,4.89,1.89.65.43,1.24.96,1.75,1.58.33.4.6.83.84,1.28,0,.01.02.03.02.04.1.2.2.4.28.61.84,1.89.98,3.98.64,5.6-.64,3.07-4.02,6.09-7.13,6.6-1.65.26-3.28.02-4.74-.69-1.12-.56-2.27-.9-3.41-1.05-2.25-.28-4.12-.09-5.71.58-.24.1.43,19.25.55,22.79l57.55-.1,1.14-23.43c0-.28.17-.54.43-.65,1.59-.67,3.46-.86,5.7-.58,1.14.15,2.28.49,3.4,1.05,1.46.71,3.09.95,4.73.69,3.1-.51,5.7-2.99,6.34-6.06.51-2.39-.07-4.82-1.59-6.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-15)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-16)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 67.29 473.73 67.09 491.25 49.57 491.46 49.77 473.94 67.29",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 73.14 473.73 72.93 497.09 49.57 497.3 49.77 473.94 73.14",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 78.87,
    x2: 503.04,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 64.03,
    width: 41.3,
    height: 0.49,
    transform: "translate(97.61 364.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 84.71,
    x2: 508.88,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 66.95,
    width: 49.56,
    height: 0.49,
    transform: "translate(96.4 367.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 90.55,
    x2: 514.72,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 69.87,
    width: 57.82,
    height: 0.49,
    transform: "translate(95.19 370.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 96.39,
    x2: 520.56,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 72.79,
    width: 66.08,
    height: 0.49,
    transform: "translate(93.98 372.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 102.24,
    x2: 526.4,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 75.71,
    width: 74.34,
    height: 0.49,
    transform: "translate(92.77 375.88) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 108.08,
    x2: 532.24,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 78.63,
    width: 82.6,
    height: 0.49,
    transform: "translate(91.56 378.8) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 113.92,
    x2: 538.08,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 81.55,
    width: 90.86,
    height: 0.49,
    transform: "translate(90.35 381.72) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 119.76,
    x2: 543.92,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 84.47,
    width: 99.12,
    height: 0.49,
    transform: "translate(89.15 384.64) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 125.6,
    x2: 549.76,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(87.94 387.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 555.6,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(86.73 390.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 131.44,
    x2: 555.6,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(85.52 393.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 125.6,
    x2: 479.67,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(67.41 338) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(66.2 340.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 131.44,
    x2: 485.51,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(64.99 343.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 3.05 473.73 2.84 497.09 -20.52 497.3 -20.32 473.94 3.05",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 8.78,
    x2: 503.04,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: -6.06,
    width: 41.3,
    height: 0.49,
    transform: "translate(147.17 343.67) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 14.63,
    x2: 508.88,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.57,
    y: -3.14,
    width: 49.56,
    height: 0.49,
    transform: "translate(145.96 346.59) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 20.47,
    x2: 514.72,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: -0.22,
    width: 57.82,
    height: 0.49,
    transform: "translate(144.75 349.51) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 26.31,
    x2: 520.56,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 2.7,
    width: 66.08,
    height: 0.49,
    transform: "translate(143.54 352.43) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 32.15,
    x2: 526.4,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 5.62,
    width: 74.34,
    height: 0.49,
    transform: "translate(142.33 355.35) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 37.99,
    x2: 532.24,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 8.54,
    width: 82.6,
    height: 0.49,
    transform: "translate(141.12 358.27) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 43.83,
    x2: 538.08,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 11.46,
    width: 90.86,
    height: 0.49,
    transform: "translate(139.91 361.19) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 49.67,
    x2: 543.92,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 14.38,
    width: 99.12,
    height: 0.49,
    transform: "translate(138.71 364.11) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 55.51,
    x2: 549.76,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(137.5 367.03) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 555.6,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(136.29 369.95) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 61.35,
    x2: 555.6,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(135.08 372.87) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.51,
    y1: 61.35,
    x2: 555.6,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(133.87 375.8) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.36,
    y1: 61.35,
    x2: 555.6,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.05,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(132.66 378.72) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 55.51,
    x2: 479.67,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(116.97 317.47) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 61.35,
    x2: 485.51,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(115.76 320.39) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 61.35,
    x2: 485.51,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(114.55 323.31) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 61.35,
    x2: 485.51,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(113.34 326.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 61.35,
    x2: 485.51,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(112.13 329.16) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 61.35,
    x2: 485.51,
    y2: 2.94,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 31.9,
    width: 82.6,
    height: 0.49,
    transform: "translate(110.92 332.08) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 61.35,
    x2: 485.51,
    y2: 8.78,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 34.82,
    width: 74.34,
    height: 0.49,
    transform: "translate(109.71 335) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 61.35,
    x2: 485.51,
    y2: 14.63,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 37.74,
    width: 66.08,
    height: 0.49,
    transform: "translate(108.5 337.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 61.35,
    x2: 485.51,
    y2: 20.47,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 40.66,
    width: 57.82,
    height: 0.49,
    transform: "translate(107.29 340.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 61.35,
    x2: 485.51,
    y2: 26.31,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 43.59,
    width: 49.56,
    height: 0.49,
    transform: "translate(106.08 343.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 61.35,
    x2: 485.51,
    y2: 32.15,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 46.51,
    width: 41.3,
    height: 0.49,
    transform: "translate(104.87 346.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 61.35,
    x2: 485.51,
    y2: 37.99,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 49.43,
    width: 33.04,
    height: 0.49,
    transform: "translate(103.66 349.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 61.35,
    x2: 485.51,
    y2: 43.83,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 52.35,
    width: 24.78,
    height: 0.49,
    transform: "translate(102.45 352.52) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 55.27,
    width: 16.52,
    height: 0.49,
    transform: "translate(101.24 355.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-17)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 137.38 473.73 137.18 491.25 119.65 491.46 119.86 473.94 137.38",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 143.22 473.73 143.02 497.09 119.65 497.3 119.86 473.94 143.22",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 148.96,
    x2: 503.04,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 134.12,
    width: 41.3,
    height: 0.49,
    transform: "translate(48.05 384.73) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 154.8,
    x2: 508.88,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 137.04,
    width: 49.56,
    height: 0.49,
    transform: "translate(46.84 387.65) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 160.64,
    x2: 514.72,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 139.96,
    width: 57.82,
    height: 0.49,
    transform: "translate(45.63 390.57) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 166.48,
    x2: 520.56,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 142.88,
    width: 66.08,
    height: 0.49,
    transform: "translate(44.42 393.49) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 172.32,
    x2: 526.4,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 145.8,
    width: 74.34,
    height: 0.49,
    transform: "translate(43.21 396.41) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 178.16,
    x2: 532.24,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 148.72,
    width: 82.6,
    height: 0.49,
    transform: "translate(42 399.33) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 184.01,
    x2: 538.08,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 151.64,
    width: 90.86,
    height: 0.49,
    transform: "translate(40.79 402.25) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 189.85,
    x2: 543.92,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 154.56,
    width: 99.12,
    height: 0.49,
    transform: "translate(39.59 405.17) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 195.69,
    x2: 549.76,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(38.38 408.09) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 201.53,
    x2: 555.6,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(37.17 411.01) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 201.53,
    x2: 555.6,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(35.96 413.93) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 195.69,
    x2: 479.67,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(17.85 358.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 201.53,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(16.64 361.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 201.53,
    x2: 485.51,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(15.43 364.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 67.29 473.73 67.09 491.25 49.57 491.46 49.77 473.94 67.29",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 73.14 473.73 72.93 497.09 49.57 497.3 49.77 473.94 73.14",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 78.87,
    x2: 503.04,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 64.03,
    width: 41.3,
    height: 0.49,
    transform: "translate(97.61 364.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 84.71,
    x2: 508.88,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 66.95,
    width: 49.56,
    height: 0.49,
    transform: "translate(96.4 367.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 90.55,
    x2: 514.72,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 69.87,
    width: 57.82,
    height: 0.49,
    transform: "translate(95.19 370.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 96.39,
    x2: 520.56,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 72.79,
    width: 66.08,
    height: 0.49,
    transform: "translate(93.98 372.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 102.24,
    x2: 526.4,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 75.71,
    width: 74.34,
    height: 0.49,
    transform: "translate(92.77 375.88) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 108.08,
    x2: 532.24,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 78.63,
    width: 82.6,
    height: 0.49,
    transform: "translate(91.56 378.8) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 113.92,
    x2: 538.08,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 81.55,
    width: 90.86,
    height: 0.49,
    transform: "translate(90.35 381.72) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 119.76,
    x2: 543.92,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 84.47,
    width: 99.12,
    height: 0.49,
    transform: "translate(89.15 384.64) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 125.6,
    x2: 549.76,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(87.94 387.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 555.6,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(86.73 390.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 131.44,
    x2: 555.6,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(85.52 393.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.51,
    y1: 131.44,
    x2: 555.6,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(84.31 396.32) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.36,
    y1: 131.44,
    x2: 555.6,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.05,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(83.1 399.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 125.6,
    x2: 479.67,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(67.41 338) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(66.2 340.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 131.44,
    x2: 485.51,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(64.99 343.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 131.44,
    x2: 485.51,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(63.78 346.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 131.44,
    x2: 485.51,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(62.57 349.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 131.44,
    x2: 485.51,
    y2: 73.03,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 101.99,
    width: 82.6,
    height: 0.49,
    transform: "translate(61.36 352.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 131.44,
    x2: 485.51,
    y2: 78.87,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 104.91,
    width: 74.34,
    height: 0.49,
    transform: "translate(60.15 355.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 131.44,
    x2: 485.51,
    y2: 84.71,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 107.83,
    width: 66.08,
    height: 0.49,
    transform: "translate(58.94 358.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 131.44,
    x2: 485.51,
    y2: 90.55,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 110.75,
    width: 57.82,
    height: 0.49,
    transform: "translate(57.73 361.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 131.44,
    x2: 485.51,
    y2: 96.39,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 113.67,
    width: 49.56,
    height: 0.49,
    transform: "translate(56.52 364.29) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 131.44,
    x2: 485.51,
    y2: 102.24,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 116.59,
    width: 41.3,
    height: 0.49,
    transform: "translate(55.31 367.21) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 131.44,
    x2: 485.51,
    y2: 108.08,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 119.51,
    width: 33.04,
    height: 0.49,
    transform: "translate(54.1 370.13) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 131.44,
    x2: 485.51,
    y2: 113.92,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 122.43,
    width: 24.78,
    height: 0.49,
    transform: "translate(52.89 373.05) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 125.36,
    width: 16.52,
    height: 0.49,
    transform: "translate(51.68 375.97) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 55.51,
    x2: 549.76,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(137.5 367.03) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 555.6,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(136.29 369.95) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 61.35,
    x2: 555.6,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(135.08 372.87) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.51,
    y1: 61.35,
    x2: 555.6,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(133.87 375.8) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.36,
    y1: 61.35,
    x2: 555.6,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.05,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(132.66 378.72) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 55.51,
    x2: 479.67,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(116.97 317.47) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 61.35,
    x2: 485.51,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(115.76 320.39) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 61.35,
    x2: 485.51,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(114.55 323.31) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 61.35,
    x2: 485.51,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(113.34 326.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 61.35,
    x2: 485.51,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(112.13 329.16) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 61.35,
    x2: 485.51,
    y2: 2.94,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 31.9,
    width: 82.6,
    height: 0.49,
    transform: "translate(110.92 332.08) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 61.35,
    x2: 485.51,
    y2: 8.78,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 34.82,
    width: 74.34,
    height: 0.49,
    transform: "translate(109.71 335) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 61.35,
    x2: 485.51,
    y2: 14.63,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 37.74,
    width: 66.08,
    height: 0.49,
    transform: "translate(108.5 337.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 61.35,
    x2: 485.51,
    y2: 20.47,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 40.66,
    width: 57.82,
    height: 0.49,
    transform: "translate(107.29 340.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 61.35,
    x2: 485.51,
    y2: 26.31,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 43.59,
    width: 49.56,
    height: 0.49,
    transform: "translate(106.08 343.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 61.35,
    x2: 485.51,
    y2: 32.15,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 46.51,
    width: 41.3,
    height: 0.49,
    transform: "translate(104.87 346.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 61.35,
    x2: 485.51,
    y2: 37.99,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 49.43,
    width: 33.04,
    height: 0.49,
    transform: "translate(103.66 349.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 61.35,
    x2: 485.51,
    y2: 43.83,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 52.35,
    width: 24.78,
    height: 0.49,
    transform: "translate(102.45 352.52) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 55.27,
    width: 16.52,
    height: 0.49,
    transform: "translate(101.24 355.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-18)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 137.38 473.73 137.18 491.25 119.65 491.46 119.86 473.94 137.38",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 143.22 473.73 143.02 497.09 119.65 497.3 119.86 473.94 143.22",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 148.96,
    x2: 503.04,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 134.12,
    width: 41.3,
    height: 0.49,
    transform: "translate(48.05 384.73) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 154.8,
    x2: 508.88,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 137.04,
    width: 49.56,
    height: 0.49,
    transform: "translate(46.84 387.65) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 160.64,
    x2: 514.72,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 139.96,
    width: 57.82,
    height: 0.49,
    transform: "translate(45.63 390.57) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 166.48,
    x2: 520.56,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 142.88,
    width: 66.08,
    height: 0.49,
    transform: "translate(44.42 393.49) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 172.32,
    x2: 526.4,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 145.8,
    width: 74.34,
    height: 0.49,
    transform: "translate(43.21 396.41) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 178.16,
    x2: 532.24,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 148.72,
    width: 82.6,
    height: 0.49,
    transform: "translate(42 399.33) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 184.01,
    x2: 538.08,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 151.64,
    width: 90.86,
    height: 0.49,
    transform: "translate(40.79 402.25) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 189.85,
    x2: 543.92,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 154.56,
    width: 99.12,
    height: 0.49,
    transform: "translate(39.59 405.17) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 195.69,
    x2: 549.76,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(38.38 408.09) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 201.53,
    x2: 555.6,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(37.17 411.01) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 201.53,
    x2: 555.6,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(35.96 413.93) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.51,
    y1: 201.53,
    x2: 555.6,
    y2: 131.44,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 166.24,
    width: 99.12,
    height: 0.49,
    transform: "translate(34.75 416.85) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 195.69,
    x2: 479.67,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(17.85 358.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 201.53,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(16.64 361.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 201.53,
    x2: 485.51,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(15.43 364.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 201.53,
    x2: 485.51,
    y2: 131.44,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 166.24,
    width: 99.12,
    height: 0.49,
    transform: "translate(14.22 367.29) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 125.6,
    x2: 549.76,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(87.94 387.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 555.6,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(86.73 390.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 131.44,
    x2: 555.6,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(85.52 393.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.51,
    y1: 131.44,
    x2: 555.6,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(84.31 396.32) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.36,
    y1: 131.44,
    x2: 555.6,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.05,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(83.1 399.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 125.6,
    x2: 479.67,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(67.41 338) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(66.2 340.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 131.44,
    x2: 485.51,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(64.99 343.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 131.44,
    x2: 485.51,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(63.78 346.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 131.44,
    x2: 485.51,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(62.57 349.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 131.44,
    x2: 485.51,
    y2: 73.03,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 101.99,
    width: 82.6,
    height: 0.49,
    transform: "translate(61.36 352.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 131.44,
    x2: 485.51,
    y2: 78.87,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 104.91,
    width: 74.34,
    height: 0.49,
    transform: "translate(60.15 355.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 131.44,
    x2: 485.51,
    y2: 84.71,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 107.83,
    width: 66.08,
    height: 0.49,
    transform: "translate(58.94 358.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 131.44,
    x2: 485.51,
    y2: 90.55,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 110.75,
    width: 57.82,
    height: 0.49,
    transform: "translate(57.73 361.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 131.44,
    x2: 485.51,
    y2: 96.39,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 113.67,
    width: 49.56,
    height: 0.49,
    transform: "translate(56.52 364.29) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 131.44,
    x2: 485.51,
    y2: 102.24,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 116.59,
    width: 41.3,
    height: 0.49,
    transform: "translate(55.31 367.21) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 131.44,
    x2: 485.51,
    y2: 108.08,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 119.51,
    width: 33.04,
    height: 0.49,
    transform: "translate(54.1 370.13) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 131.44,
    x2: 485.51,
    y2: 113.92,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 122.43,
    width: 24.78,
    height: 0.49,
    transform: "translate(52.89 373.05) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 125.36,
    width: 16.52,
    height: 0.49,
    transform: "translate(51.68 375.97) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-19)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 67.29 473.73 67.09 491.25 49.57 491.46 49.77 473.94 67.29",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 73.14 473.73 72.93 497.09 49.57 497.3 49.77 473.94 73.14",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 78.87,
    x2: 503.04,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 64.03,
    width: 41.3,
    height: 0.49,
    transform: "translate(97.61 364.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 84.71,
    x2: 508.88,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 66.95,
    width: 49.56,
    height: 0.49,
    transform: "translate(96.4 367.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 90.55,
    x2: 514.72,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 69.87,
    width: 57.82,
    height: 0.49,
    transform: "translate(95.19 370.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 96.39,
    x2: 520.56,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 72.79,
    width: 66.08,
    height: 0.49,
    transform: "translate(93.98 372.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 102.24,
    x2: 526.4,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 75.71,
    width: 74.34,
    height: 0.49,
    transform: "translate(92.77 375.88) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 108.08,
    x2: 532.24,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 78.63,
    width: 82.6,
    height: 0.49,
    transform: "translate(91.56 378.8) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 113.92,
    x2: 538.08,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 81.55,
    width: 90.86,
    height: 0.49,
    transform: "translate(90.35 381.72) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 119.76,
    x2: 543.92,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 84.47,
    width: 99.12,
    height: 0.49,
    transform: "translate(89.15 384.64) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 125.6,
    x2: 549.76,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(87.94 387.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 555.6,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(86.73 390.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 131.44,
    x2: 555.6,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(85.52 393.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 67.29 403.64 67.09 421.16 49.57 421.37 49.77 403.85 67.29",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 73.14 403.64 72.93 427 49.57 427.21 49.77 403.85 73.14",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 78.87,
    x2: 432.95,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.7,
    y: 64.03,
    width: 41.3,
    height: 0.49,
    transform: "translate(77.08 314.64) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 84.71,
    x2: 438.79,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.49,
    y: 66.95,
    width: 49.56,
    height: 0.49,
    transform: "translate(75.87 317.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 90.55,
    x2: 444.63,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.28,
    y: 69.87,
    width: 57.82,
    height: 0.49,
    transform: "translate(74.66 320.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 96.39,
    x2: 450.47,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.07,
    y: 72.79,
    width: 66.08,
    height: 0.49,
    transform: "translate(73.46 323.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 102.24,
    x2: 456.31,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.86,
    y: 75.71,
    width: 74.34,
    height: 0.49,
    transform: "translate(72.25 326.32) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 108.08,
    x2: 462.15,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.65,
    y: 78.63,
    width: 82.6,
    height: 0.49,
    transform: "translate(71.04 329.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 113.92,
    x2: 467.99,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.44,
    y: 81.55,
    width: 90.86,
    height: 0.49,
    transform: "translate(69.83 332.16) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 119.76,
    x2: 473.83,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.23,
    y: 84.47,
    width: 99.12,
    height: 0.49,
    transform: "translate(68.62 335.08) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 125.6,
    x2: 479.67,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(67.41 338) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(66.2 340.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 131.44,
    x2: 485.51,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(64.99 343.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 125.6,
    x2: 409.59,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(46.88 288.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 131.44,
    x2: 415.43,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.72,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(45.67 291.36) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 131.44,
    x2: 415.43,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(44.46 294.28) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 3.05 473.73 2.84 497.09 -20.52 497.3 -20.32 473.94 3.05",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 8.78,
    x2: 503.04,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: -6.06,
    width: 41.3,
    height: 0.49,
    transform: "translate(147.17 343.67) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 14.63,
    x2: 508.88,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.57,
    y: -3.14,
    width: 49.56,
    height: 0.49,
    transform: "translate(145.96 346.59) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 20.47,
    x2: 514.72,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: -0.22,
    width: 57.82,
    height: 0.49,
    transform: "translate(144.75 349.51) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 26.31,
    x2: 520.56,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 2.7,
    width: 66.08,
    height: 0.49,
    transform: "translate(143.54 352.43) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 32.15,
    x2: 526.4,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 5.62,
    width: 74.34,
    height: 0.49,
    transform: "translate(142.33 355.35) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 37.99,
    x2: 532.24,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 8.54,
    width: 82.6,
    height: 0.49,
    transform: "translate(141.12 358.27) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 43.83,
    x2: 538.08,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 11.46,
    width: 90.86,
    height: 0.49,
    transform: "translate(139.91 361.19) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 49.67,
    x2: 543.92,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 14.38,
    width: 99.12,
    height: 0.49,
    transform: "translate(138.71 364.11) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 55.51,
    x2: 549.76,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(137.5 367.03) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 555.6,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(136.29 369.95) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 61.35,
    x2: 555.6,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(135.08 372.87) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 3.05 403.64 2.84 427 -20.52 427.21 -20.32 403.85 3.05",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 8.78,
    x2: 432.95,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.7,
    y: -6.06,
    width: 41.3,
    height: 0.49,
    transform: "translate(126.64 294.11) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 14.63,
    x2: 438.79,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.49,
    y: -3.14,
    width: 49.56,
    height: 0.49,
    transform: "translate(125.43 297.03) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 20.47,
    x2: 444.63,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.28,
    y: -0.22,
    width: 57.82,
    height: 0.49,
    transform: "translate(124.22 299.95) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 26.31,
    x2: 450.47,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.07,
    y: 2.7,
    width: 66.08,
    height: 0.49,
    transform: "translate(123.02 302.87) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 32.15,
    x2: 456.31,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.86,
    y: 5.62,
    width: 74.34,
    height: 0.49,
    transform: "translate(121.81 305.79) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 37.99,
    x2: 462.15,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.65,
    y: 8.54,
    width: 82.6,
    height: 0.49,
    transform: "translate(120.6 308.71) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 43.83,
    x2: 467.99,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.44,
    y: 11.46,
    width: 90.86,
    height: 0.49,
    transform: "translate(119.39 311.63) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 49.67,
    x2: 473.83,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.23,
    y: 14.38,
    width: 99.12,
    height: 0.49,
    transform: "translate(118.18 314.55) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 55.51,
    x2: 479.67,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(116.97 317.47) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 61.35,
    x2: 485.51,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(115.76 320.39) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 61.35,
    x2: 485.51,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(114.55 323.31) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 61.35,
    x2: 485.51,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(113.34 326.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 61.35,
    x2: 485.51,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(112.13 329.16) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 61.35,
    x2: 485.51,
    y2: 2.94,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 31.9,
    width: 82.6,
    height: 0.49,
    transform: "translate(110.92 332.08) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 61.35,
    x2: 485.51,
    y2: 8.78,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 34.82,
    width: 74.34,
    height: 0.49,
    transform: "translate(109.71 335) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 61.35,
    x2: 485.51,
    y2: 14.63,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 37.74,
    width: 66.08,
    height: 0.49,
    transform: "translate(108.5 337.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 61.35,
    x2: 485.51,
    y2: 20.47,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 40.66,
    width: 57.82,
    height: 0.49,
    transform: "translate(107.29 340.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 61.35,
    x2: 485.51,
    y2: 26.31,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 43.59,
    width: 49.56,
    height: 0.49,
    transform: "translate(106.08 343.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 61.35,
    x2: 485.51,
    y2: 32.15,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 46.51,
    width: 41.3,
    height: 0.49,
    transform: "translate(104.87 346.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 61.35,
    x2: 485.51,
    y2: 37.99,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 49.43,
    width: 33.04,
    height: 0.49,
    transform: "translate(103.66 349.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 61.35,
    x2: 485.51,
    y2: 43.83,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 52.35,
    width: 24.78,
    height: 0.49,
    transform: "translate(102.45 352.52) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 55.27,
    width: 16.52,
    height: 0.49,
    transform: "translate(101.24 355.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 55.51,
    x2: 409.59,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(96.44 267.91) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 61.35,
    x2: 415.43,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.72,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(95.23 270.83) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 61.35,
    x2: 415.43,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(94.02 273.75) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.34,
    y1: 61.35,
    x2: 415.43,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.82,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(92.81 276.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.18,
    y1: 61.35,
    x2: 415.43,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.87,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(91.6 279.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.02,
    y1: 61.35,
    x2: 415.43,
    y2: 2.94,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.92,
    y: 31.9,
    width: 82.6,
    height: 0.49,
    transform: "translate(90.39 282.52) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.86,
    y1: 61.35,
    x2: 415.43,
    y2: 8.78,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.97,
    y: 34.82,
    width: 74.34,
    height: 0.49,
    transform: "translate(89.18 285.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.7,
    y1: 61.35,
    x2: 415.43,
    y2: 14.63,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.02,
    y: 37.74,
    width: 66.08,
    height: 0.49,
    transform: "translate(87.97 288.36) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.54,
    y1: 61.35,
    x2: 415.43,
    y2: 20.47,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.07,
    y: 40.66,
    width: 57.82,
    height: 0.49,
    transform: "translate(86.76 291.28) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.38,
    y1: 61.35,
    x2: 415.43,
    y2: 26.31,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.12,
    y: 43.59,
    width: 49.56,
    height: 0.49,
    transform: "translate(85.55 294.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.22,
    y1: 61.35,
    x2: 415.43,
    y2: 32.15,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.17,
    y: 46.51,
    width: 41.3,
    height: 0.49,
    transform: "translate(84.34 297.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.06,
    y1: 61.35,
    x2: 415.43,
    y2: 37.99,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.23,
    y: 49.43,
    width: 33.04,
    height: 0.49,
    transform: "translate(83.13 300.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.9,
    y1: 61.35,
    x2: 415.43,
    y2: 43.83,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.27,
    y: 52.35,
    width: 24.78,
    height: 0.49,
    transform: "translate(81.92 302.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 61.35,
    x2: 415.43,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.33,
    y: 55.27,
    width: 16.52,
    height: 0.49,
    transform: "translate(80.71 305.88) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-20)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 137.38 473.73 137.18 491.25 119.65 491.46 119.86 473.94 137.38",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 143.22 473.73 143.02 497.09 119.65 497.3 119.86 473.94 143.22",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 148.96,
    x2: 503.04,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 134.12,
    width: 41.3,
    height: 0.49,
    transform: "translate(48.05 384.73) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 154.8,
    x2: 508.88,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 137.04,
    width: 49.56,
    height: 0.49,
    transform: "translate(46.84 387.65) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 160.64,
    x2: 514.72,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 139.96,
    width: 57.82,
    height: 0.49,
    transform: "translate(45.63 390.57) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 166.48,
    x2: 520.56,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 142.88,
    width: 66.08,
    height: 0.49,
    transform: "translate(44.42 393.49) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 172.32,
    x2: 526.4,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 145.8,
    width: 74.34,
    height: 0.49,
    transform: "translate(43.21 396.41) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 178.16,
    x2: 532.24,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 148.72,
    width: 82.6,
    height: 0.49,
    transform: "translate(42 399.33) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 184.01,
    x2: 538.08,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 151.64,
    width: 90.86,
    height: 0.49,
    transform: "translate(40.79 402.25) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 189.85,
    x2: 543.92,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 154.56,
    width: 99.12,
    height: 0.49,
    transform: "translate(39.59 405.17) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 195.69,
    x2: 549.76,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(38.38 408.09) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 201.53,
    x2: 555.6,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(37.17 411.01) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 201.53,
    x2: 555.6,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(35.96 413.93) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 137.38 403.64 137.18 421.16 119.65 421.37 119.86 403.85 137.38",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 143.22 403.64 143.02 427 119.65 427.21 119.86 403.85 143.22",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 148.96,
    x2: 432.95,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.7,
    y: 134.12,
    width: 41.3,
    height: 0.49,
    transform: "translate(27.52 335.17) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 154.8,
    x2: 438.79,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.49,
    y: 137.04,
    width: 49.56,
    height: 0.49,
    transform: "translate(26.31 338.09) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 160.64,
    x2: 444.63,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.28,
    y: 139.96,
    width: 57.82,
    height: 0.49,
    transform: "translate(25.1 341.01) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 166.48,
    x2: 450.47,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.07,
    y: 142.88,
    width: 66.08,
    height: 0.49,
    transform: "translate(23.9 343.93) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 172.32,
    x2: 456.31,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.86,
    y: 145.8,
    width: 74.34,
    height: 0.49,
    transform: "translate(22.69 346.85) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 178.16,
    x2: 462.15,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.65,
    y: 148.72,
    width: 82.6,
    height: 0.49,
    transform: "translate(21.48 349.77) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 184.01,
    x2: 467.99,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.44,
    y: 151.64,
    width: 90.86,
    height: 0.49,
    transform: "translate(20.27 352.69) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 189.85,
    x2: 473.83,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.23,
    y: 154.56,
    width: 99.12,
    height: 0.49,
    transform: "translate(19.06 355.61) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 195.69,
    x2: 479.67,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(17.85 358.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 201.53,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(16.64 361.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 201.53,
    x2: 485.51,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(15.43 364.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 195.69,
    x2: 409.59,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(-2.68 308.97) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 201.53,
    x2: 415.43,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.72,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(-3.89 311.89) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 201.53,
    x2: 415.43,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(-5.1 314.81) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 67.29 473.73 67.09 491.25 49.57 491.46 49.77 473.94 67.29",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 73.14 473.73 72.93 497.09 49.57 497.3 49.77 473.94 73.14",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 78.87,
    x2: 503.04,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 64.03,
    width: 41.3,
    height: 0.49,
    transform: "translate(97.61 364.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 84.71,
    x2: 508.88,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 66.95,
    width: 49.56,
    height: 0.49,
    transform: "translate(96.4 367.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 90.55,
    x2: 514.72,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 69.87,
    width: 57.82,
    height: 0.49,
    transform: "translate(95.19 370.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 96.39,
    x2: 520.56,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 72.79,
    width: 66.08,
    height: 0.49,
    transform: "translate(93.98 372.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 102.24,
    x2: 526.4,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 75.71,
    width: 74.34,
    height: 0.49,
    transform: "translate(92.77 375.88) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 108.08,
    x2: 532.24,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 78.63,
    width: 82.6,
    height: 0.49,
    transform: "translate(91.56 378.8) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 113.92,
    x2: 538.08,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 81.55,
    width: 90.86,
    height: 0.49,
    transform: "translate(90.35 381.72) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 119.76,
    x2: 543.92,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 84.47,
    width: 99.12,
    height: 0.49,
    transform: "translate(89.15 384.64) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 125.6,
    x2: 549.76,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(87.94 387.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 555.6,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(86.73 390.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 131.44,
    x2: 555.6,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(85.52 393.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 67.29 403.64 67.09 421.16 49.57 421.37 49.77 403.85 67.29",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 73.14 403.64 72.93 427 49.57 427.21 49.77 403.85 73.14",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 78.87,
    x2: 432.95,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.7,
    y: 64.03,
    width: 41.3,
    height: 0.49,
    transform: "translate(77.08 314.64) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 84.71,
    x2: 438.79,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.49,
    y: 66.95,
    width: 49.56,
    height: 0.49,
    transform: "translate(75.87 317.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 90.55,
    x2: 444.63,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.28,
    y: 69.87,
    width: 57.82,
    height: 0.49,
    transform: "translate(74.66 320.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 96.39,
    x2: 450.47,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.07,
    y: 72.79,
    width: 66.08,
    height: 0.49,
    transform: "translate(73.46 323.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 102.24,
    x2: 456.31,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.86,
    y: 75.71,
    width: 74.34,
    height: 0.49,
    transform: "translate(72.25 326.32) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 108.08,
    x2: 462.15,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.65,
    y: 78.63,
    width: 82.6,
    height: 0.49,
    transform: "translate(71.04 329.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 113.92,
    x2: 467.99,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.44,
    y: 81.55,
    width: 90.86,
    height: 0.49,
    transform: "translate(69.83 332.16) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 119.76,
    x2: 473.83,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.23,
    y: 84.47,
    width: 99.12,
    height: 0.49,
    transform: "translate(68.62 335.08) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 125.6,
    x2: 479.67,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(67.41 338) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(66.2 340.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 131.44,
    x2: 485.51,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(64.99 343.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 131.44,
    x2: 485.51,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(63.78 346.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 131.44,
    x2: 485.51,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(62.57 349.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 131.44,
    x2: 485.51,
    y2: 73.03,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 101.99,
    width: 82.6,
    height: 0.49,
    transform: "translate(61.36 352.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 131.44,
    x2: 485.51,
    y2: 78.87,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 104.91,
    width: 74.34,
    height: 0.49,
    transform: "translate(60.15 355.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 131.44,
    x2: 485.51,
    y2: 84.71,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 107.83,
    width: 66.08,
    height: 0.49,
    transform: "translate(58.94 358.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 131.44,
    x2: 485.51,
    y2: 90.55,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 110.75,
    width: 57.82,
    height: 0.49,
    transform: "translate(57.73 361.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 131.44,
    x2: 485.51,
    y2: 96.39,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 113.67,
    width: 49.56,
    height: 0.49,
    transform: "translate(56.52 364.29) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 131.44,
    x2: 485.51,
    y2: 102.24,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 116.59,
    width: 41.3,
    height: 0.49,
    transform: "translate(55.31 367.21) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 131.44,
    x2: 485.51,
    y2: 108.08,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 119.51,
    width: 33.04,
    height: 0.49,
    transform: "translate(54.1 370.13) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 131.44,
    x2: 485.51,
    y2: 113.92,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 122.43,
    width: 24.78,
    height: 0.49,
    transform: "translate(52.89 373.05) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 125.36,
    width: 16.52,
    height: 0.49,
    transform: "translate(51.68 375.97) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 125.6,
    x2: 409.59,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(46.88 288.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 131.44,
    x2: 415.43,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.72,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(45.67 291.36) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 131.44,
    x2: 415.43,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(44.46 294.28) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.34,
    y1: 131.44,
    x2: 415.43,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.82,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(43.25 297.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.18,
    y1: 131.44,
    x2: 415.43,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.87,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(42.04 300.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.02,
    y1: 131.44,
    x2: 415.43,
    y2: 73.03,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.92,
    y: 101.99,
    width: 82.6,
    height: 0.49,
    transform: "translate(40.83 303.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.86,
    y1: 131.44,
    x2: 415.43,
    y2: 78.87,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.97,
    y: 104.91,
    width: 74.34,
    height: 0.49,
    transform: "translate(39.62 305.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.7,
    y1: 131.44,
    x2: 415.43,
    y2: 84.71,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.02,
    y: 107.83,
    width: 66.08,
    height: 0.49,
    transform: "translate(38.41 308.89) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.54,
    y1: 131.44,
    x2: 415.43,
    y2: 90.55,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.07,
    y: 110.75,
    width: 57.82,
    height: 0.49,
    transform: "translate(37.2 311.81) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.38,
    y1: 131.44,
    x2: 415.43,
    y2: 96.39,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.12,
    y: 113.67,
    width: 49.56,
    height: 0.49,
    transform: "translate(35.99 314.73) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.22,
    y1: 131.44,
    x2: 415.43,
    y2: 102.24,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.17,
    y: 116.59,
    width: 41.3,
    height: 0.49,
    transform: "translate(34.78 317.65) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.06,
    y1: 131.44,
    x2: 415.43,
    y2: 108.08,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.22,
    y: 119.51,
    width: 33.04,
    height: 0.49,
    transform: "translate(33.57 320.57) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.9,
    y1: 131.44,
    x2: 415.43,
    y2: 113.92,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.27,
    y: 122.43,
    width: 24.78,
    height: 0.49,
    transform: "translate(32.36 323.49) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 415.43,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.33,
    y: 125.36,
    width: 16.52,
    height: 0.49,
    transform: "translate(31.15 326.41) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 55.51,
    x2: 549.76,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(137.5 367.03) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 555.6,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(136.29 369.95) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 61.35,
    x2: 555.6,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(135.08 372.87) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 55.51,
    x2: 479.67,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(116.97 317.47) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 61.35,
    x2: 485.51,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(115.76 320.39) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 61.35,
    x2: 485.51,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(114.55 323.31) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 61.35,
    x2: 485.51,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(113.34 326.24) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 61.35,
    x2: 485.51,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(112.13 329.16) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 61.35,
    x2: 485.51,
    y2: 2.94,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 31.9,
    width: 82.6,
    height: 0.49,
    transform: "translate(110.92 332.08) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 61.35,
    x2: 485.51,
    y2: 8.78,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 34.82,
    width: 74.34,
    height: 0.49,
    transform: "translate(109.71 335) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 61.35,
    x2: 485.51,
    y2: 14.63,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 37.74,
    width: 66.08,
    height: 0.49,
    transform: "translate(108.5 337.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 61.35,
    x2: 485.51,
    y2: 20.47,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 40.66,
    width: 57.82,
    height: 0.49,
    transform: "translate(107.29 340.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 61.35,
    x2: 485.51,
    y2: 26.31,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 43.59,
    width: 49.56,
    height: 0.49,
    transform: "translate(106.08 343.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 61.35,
    x2: 485.51,
    y2: 32.15,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 46.51,
    width: 41.3,
    height: 0.49,
    transform: "translate(104.87 346.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 61.35,
    x2: 485.51,
    y2: 37.99,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 49.43,
    width: 33.04,
    height: 0.49,
    transform: "translate(103.66 349.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 61.35,
    x2: 485.51,
    y2: 43.83,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 52.35,
    width: 24.78,
    height: 0.49,
    transform: "translate(102.45 352.52) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 61.35,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 55.27,
    width: 16.52,
    height: 0.49,
    transform: "translate(101.24 355.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 55.51,
    x2: 409.59,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 17.3,
    width: 107.38,
    height: 0.49,
    transform: "translate(96.44 267.91) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 61.35,
    x2: 415.43,
    y2: -20.42,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.72,
    y: 20.22,
    width: 115.64,
    height: 0.49,
    transform: "translate(95.23 270.83) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 61.35,
    x2: 415.43,
    y2: -14.58,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 23.14,
    width: 107.38,
    height: 0.49,
    transform: "translate(94.02 273.75) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.34,
    y1: 61.35,
    x2: 415.43,
    y2: -8.74,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.82,
    y: 26.06,
    width: 99.12,
    height: 0.49,
    transform: "translate(92.81 276.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.18,
    y1: 61.35,
    x2: 415.43,
    y2: -2.9,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.87,
    y: 28.98,
    width: 90.86,
    height: 0.49,
    transform: "translate(91.6 279.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.02,
    y1: 61.35,
    x2: 415.43,
    y2: 2.94,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.92,
    y: 31.9,
    width: 82.6,
    height: 0.49,
    transform: "translate(90.39 282.52) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.86,
    y1: 61.35,
    x2: 415.43,
    y2: 8.78,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.97,
    y: 34.82,
    width: 74.34,
    height: 0.49,
    transform: "translate(89.18 285.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.7,
    y1: 61.35,
    x2: 415.43,
    y2: 14.63,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.02,
    y: 37.74,
    width: 66.08,
    height: 0.49,
    transform: "translate(87.97 288.36) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.54,
    y1: 61.35,
    x2: 415.43,
    y2: 20.47,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.07,
    y: 40.66,
    width: 57.82,
    height: 0.49,
    transform: "translate(86.76 291.28) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.38,
    y1: 61.35,
    x2: 415.43,
    y2: 26.31,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.12,
    y: 43.59,
    width: 49.56,
    height: 0.49,
    transform: "translate(85.55 294.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.22,
    y1: 61.35,
    x2: 415.43,
    y2: 32.15,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.17,
    y: 46.51,
    width: 41.3,
    height: 0.49,
    transform: "translate(84.34 297.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.06,
    y1: 61.35,
    x2: 415.43,
    y2: 37.99,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.23,
    y: 49.43,
    width: 33.04,
    height: 0.49,
    transform: "translate(83.13 300.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.9,
    y1: 61.35,
    x2: 415.43,
    y2: 43.83,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.27,
    y: 52.35,
    width: 24.78,
    height: 0.49,
    transform: "translate(81.92 302.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 61.35,
    x2: 415.43,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.33,
    y: 55.27,
    width: 16.52,
    height: 0.49,
    transform: "translate(80.71 305.88) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-21)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 137.38 473.73 137.18 491.25 119.65 491.46 119.86 473.94 137.38",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.94 143.22 473.73 143.02 497.09 119.65 497.3 119.86 473.94 143.22",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 148.96,
    x2: 503.04,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 134.12,
    width: 41.3,
    height: 0.49,
    transform: "translate(48.05 384.73) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 154.8,
    x2: 508.88,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.58,
    y: 137.04,
    width: 49.56,
    height: 0.49,
    transform: "translate(46.84 387.65) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 160.64,
    x2: 514.72,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.37,
    y: 139.96,
    width: 57.82,
    height: 0.49,
    transform: "translate(45.63 390.57) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 166.48,
    x2: 520.56,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.16,
    y: 142.88,
    width: 66.08,
    height: 0.49,
    transform: "translate(44.42 393.49) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 172.32,
    x2: 526.4,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 145.8,
    width: 74.34,
    height: 0.49,
    transform: "translate(43.21 396.41) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 178.16,
    x2: 532.24,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.74,
    y: 148.72,
    width: 82.6,
    height: 0.49,
    transform: "translate(42 399.33) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 184.01,
    x2: 538.08,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 151.64,
    width: 90.86,
    height: 0.49,
    transform: "translate(40.79 402.25) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 189.85,
    x2: 543.92,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.32,
    y: 154.56,
    width: 99.12,
    height: 0.49,
    transform: "translate(39.59 405.17) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 195.69,
    x2: 549.76,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(38.38 408.09) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 201.53,
    x2: 555.6,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(37.17 411.01) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 201.53,
    x2: 555.6,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(35.96 413.93) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 137.38 403.64 137.18 421.16 119.65 421.37 119.86 403.85 137.38",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 143.22 403.64 143.02 427 119.65 427.21 119.86 403.85 143.22",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 148.96,
    x2: 432.95,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.7,
    y: 134.12,
    width: 41.3,
    height: 0.49,
    transform: "translate(27.52 335.17) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 154.8,
    x2: 438.79,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.49,
    y: 137.04,
    width: 49.56,
    height: 0.49,
    transform: "translate(26.31 338.09) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 160.64,
    x2: 444.63,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.28,
    y: 139.96,
    width: 57.82,
    height: 0.49,
    transform: "translate(25.1 341.01) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 166.48,
    x2: 450.47,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.07,
    y: 142.88,
    width: 66.08,
    height: 0.49,
    transform: "translate(23.9 343.93) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 172.32,
    x2: 456.31,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.86,
    y: 145.8,
    width: 74.34,
    height: 0.49,
    transform: "translate(22.69 346.85) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 178.16,
    x2: 462.15,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.65,
    y: 148.72,
    width: 82.6,
    height: 0.49,
    transform: "translate(21.48 349.77) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 184.01,
    x2: 467.99,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.44,
    y: 151.64,
    width: 90.86,
    height: 0.49,
    transform: "translate(20.27 352.69) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 189.85,
    x2: 473.83,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.23,
    y: 154.56,
    width: 99.12,
    height: 0.49,
    transform: "translate(19.06 355.61) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 195.69,
    x2: 479.67,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(17.85 358.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 201.53,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(16.64 361.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 201.53,
    x2: 485.51,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(15.43 364.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 201.53,
    x2: 485.51,
    y2: 131.44,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 166.24,
    width: 99.12,
    height: 0.49,
    transform: "translate(14.22 367.29) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 195.69,
    x2: 409.59,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 157.48,
    width: 107.38,
    height: 0.49,
    transform: "translate(-2.68 308.97) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 201.53,
    x2: 415.43,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.72,
    y: 160.4,
    width: 115.64,
    height: 0.49,
    transform: "translate(-3.89 311.89) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 201.53,
    x2: 415.43,
    y2: 125.6,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 163.32,
    width: 107.38,
    height: 0.49,
    transform: "translate(-5.1 314.81) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.34,
    y1: 201.53,
    x2: 415.43,
    y2: 131.44,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.82,
    y: 166.24,
    width: 99.12,
    height: 0.49,
    transform: "translate(-6.31 317.73) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 125.6,
    x2: 549.76,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.11,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(87.94 387.56) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 555.6,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.9,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(86.73 390.48) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.67,
    y1: 131.44,
    x2: 555.6,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(85.52 393.4) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 125.6,
    x2: 479.67,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(67.41 338) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 485.51,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.81,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(66.2 340.92) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.59,
    y1: 131.44,
    x2: 485.51,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.86,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(64.99 343.84) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.43,
    y1: 131.44,
    x2: 485.51,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.91,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(63.78 346.76) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 131.44,
    x2: 485.51,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(62.57 349.68) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.11,
    y1: 131.44,
    x2: 485.51,
    y2: 73.03,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.01,
    y: 101.99,
    width: 82.6,
    height: 0.49,
    transform: "translate(61.36 352.6) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.95,
    y1: 131.44,
    x2: 485.51,
    y2: 78.87,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.06,
    y: 104.91,
    width: 74.34,
    height: 0.49,
    transform: "translate(60.15 355.53) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.79,
    y1: 131.44,
    x2: 485.51,
    y2: 84.71,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.11,
    y: 107.83,
    width: 66.08,
    height: 0.49,
    transform: "translate(58.94 358.45) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.63,
    y1: 131.44,
    x2: 485.51,
    y2: 90.55,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 110.75,
    width: 57.82,
    height: 0.49,
    transform: "translate(57.73 361.37) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.47,
    y1: 131.44,
    x2: 485.51,
    y2: 96.39,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.21,
    y: 113.67,
    width: 49.56,
    height: 0.49,
    transform: "translate(56.52 364.29) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.31,
    y1: 131.44,
    x2: 485.51,
    y2: 102.24,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.26,
    y: 116.59,
    width: 41.3,
    height: 0.49,
    transform: "translate(55.31 367.21) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.15,
    y1: 131.44,
    x2: 485.51,
    y2: 108.08,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.31,
    y: 119.51,
    width: 33.04,
    height: 0.49,
    transform: "translate(54.1 370.13) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.99,
    y1: 131.44,
    x2: 485.51,
    y2: 113.92,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.36,
    y: 122.43,
    width: 24.78,
    height: 0.49,
    transform: "translate(52.89 373.05) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.83,
    y1: 131.44,
    x2: 485.51,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.41,
    y: 125.36,
    width: 16.52,
    height: 0.49,
    transform: "translate(51.68 375.97) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 125.6,
    x2: 409.59,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 87.39,
    width: 107.38,
    height: 0.49,
    transform: "translate(46.88 288.44) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.66,
    y1: 131.44,
    x2: 415.43,
    y2: 49.67,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.72,
    y: 90.31,
    width: 115.64,
    height: 0.49,
    transform: "translate(45.67 291.36) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 131.44,
    x2: 415.43,
    y2: 55.51,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.77,
    y: 93.23,
    width: 107.38,
    height: 0.49,
    transform: "translate(44.46 294.28) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.34,
    y1: 131.44,
    x2: 415.43,
    y2: 61.35,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.82,
    y: 96.15,
    width: 99.12,
    height: 0.49,
    transform: "translate(43.25 297.2) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.18,
    y1: 131.44,
    x2: 415.43,
    y2: 67.19,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.87,
    y: 99.07,
    width: 90.86,
    height: 0.49,
    transform: "translate(42.04 300.12) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.02,
    y1: 131.44,
    x2: 415.43,
    y2: 73.03,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.92,
    y: 101.99,
    width: 82.6,
    height: 0.49,
    transform: "translate(40.83 303.04) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.86,
    y1: 131.44,
    x2: 415.43,
    y2: 78.87,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.97,
    y: 104.91,
    width: 74.34,
    height: 0.49,
    transform: "translate(39.62 305.96) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.7,
    y1: 131.44,
    x2: 415.43,
    y2: 84.71,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.02,
    y: 107.83,
    width: 66.08,
    height: 0.49,
    transform: "translate(38.41 308.89) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.54,
    y1: 131.44,
    x2: 415.43,
    y2: 90.55,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.07,
    y: 110.75,
    width: 57.82,
    height: 0.49,
    transform: "translate(37.2 311.81) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.38,
    y1: 131.44,
    x2: 415.43,
    y2: 96.39,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.12,
    y: 113.67,
    width: 49.56,
    height: 0.49,
    transform: "translate(35.99 314.73) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.22,
    y1: 131.44,
    x2: 415.43,
    y2: 102.24,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.17,
    y: 116.59,
    width: 41.3,
    height: 0.49,
    transform: "translate(34.78 317.65) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.06,
    y1: 131.44,
    x2: 415.43,
    y2: 108.08,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.22,
    y: 119.51,
    width: 33.04,
    height: 0.49,
    transform: "translate(33.57 320.57) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.9,
    y1: 131.44,
    x2: 415.43,
    y2: 113.92,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.27,
    y: 122.43,
    width: 24.78,
    height: 0.49,
    transform: "translate(32.36 323.49) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 131.44,
    x2: 415.43,
    y2: 119.76,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.33,
    y: 125.36,
    width: 16.52,
    height: 0.49,
    transform: "translate(31.15 326.41) rotate(-45)",
    style: {
      fill: "#f06400"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M411.05,127.07l-.02-.48c-.81-23.03-.68-23.09-.25-23.27,1.67-.71,3.63-.91,5.97-.62,1.24.16,2.44.53,3.57,1.1,1.37.67,2.9.89,4.44.65,3-.49,6.14-3.39,6.72-6.21.35-1.67.12-3.65-.61-5.29-.09-.2-.17-.39-.27-.58-.26-.49-.52-.89-.81-1.24-.45-.56-1-1.06-1.64-1.48-1.57-1.22-3.07-1.81-4.62-1.81-1.17,0-2.31.28-3.37.82-1.18.6-2.58.97-4.16,1.1-2.08.18-2.81-.08-4.26-.69-.45-.19-.43-1.17-.41-1.5l-.8-16.73-.1-4.42,22.52-.82.29.44-.19-.46.57.11-.46-.2c.04-.08.06-.17.09-.25l.07-.2c.5-1.32.67-2.78.52-4.48-.12-1.46-.45-2.7-1-3.8-.6-1.17-.91-2.46-.91-3.83,0-2.54,1.13-4.91,3.1-6.5,1.93-1.58,4.49-2.19,7.02-1.67,3.24.68,5.88,3.47,6.41,6.79.21,1.35.11,2.69-.32,4-.14.42-.27.76-.42,1.06-.31.64-.56,1.32-.75,2.04-.12.46-.21.87-.25,1.23-.28,2.22-.08,4.06.61,5.62.04.09.13.12.2.12l22.85-.34.08.5.21,22.79c0,.09.05.17.13.2,1.36.57,2.92.77,4.75.62,1.45-.12,2.72-.46,3.78-.99,1.2-.62,2.48-.93,3.82-.93,2.51,0,4.86,1.12,6.43,3.06,1.61,1.97,2.23,4.56,1.69,7.09-.67,3.26-3.45,5.91-6.75,6.45-1.73.28-3.47.02-5.03-.74-1.04-.52-2.13-.85-3.25-1-2.16-.27-3.94-.09-5.44.54-.07.03-.12.11-.12.19l-1.16,23.93-58.51.1ZM411.44,104.13c-.06,1.55.16,9.92.58,21.94l56.59-.09,1.11-22.95c0-.46.29-.9.73-1.09,1.67-.71,3.62-.91,5.96-.62,1.24.16,2.43.53,3.56,1.1,1.37.66,2.89.89,4.43.65,2.9-.47,5.33-2.8,5.93-5.67.47-2.24-.07-4.52-1.49-6.26h0c-1.38-1.71-3.44-2.7-5.65-2.7-1.17,0-2.3.28-3.36.82-1.18.6-2.57.97-4.15,1.1-2.01.17-3.71-.05-5.23-.69-.45-.19-.74-.63-.74-1.12l-.21-22.28-21.93.32c-.5,0-.94-.28-1.12-.71-.77-1.72-1-3.74-.69-6.15.05-.41.15-.86.28-1.36.21-.78.48-1.52.81-2.22.13-.26.24-.56.37-.94.38-1.15.47-2.34.28-3.53-.47-2.92-2.79-5.37-5.63-5.96-2.23-.46-4.48.08-6.18,1.47-1.74,1.4-2.73,3.49-2.73,5.73,0,1.21.27,2.35.8,3.38.61,1.22.97,2.58,1.1,4.17.16,1.85-.04,3.46-.58,4.92l-.06.17c-.04.12-.08.23-.13.34-.06.13-.14.24-.25.35-.11.11-.24.2-.4.26-.16.07-.32.1-.47.1l-21.52.79.07,3.42.82,17.26h0c0,.07.01.13.02.19,1.22.5,1.83.67,3.55.52,1.45-.12,2.73-.46,3.79-1,1.2-.62,2.49-.93,3.82-.93,1.78,0,3.48.65,5.2,1.99.69.46,1.31,1.02,1.83,1.66.33.4.62.84.89,1.36.14.25.23.47.33.69.81,1.81,1.06,4.02.67,5.89-.67,3.23-4.12,6.43-7.54,6.99-1.74.28-3.48.02-5.04-.74-1.04-.52-2.13-.86-3.26-1-2.04-.25-3.74-.11-5.19.44Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.98,103.78c1.59-.67,3.47-.86,5.71-.58,1.14.15,2.29.49,3.41,1.05,1.46.71,3.09.96,4.74.69,3.11-.51,6.5-3.52,7.13-6.6.34-1.62.2-3.71-.64-5.6-.09-.21-.18-.41-.28-.61,0-.01-.02-.03-.02-.04-.37-.67-.84-1.3-1.43-1.86-.37-.35-.76-.69-1.16-1-1.43-1.11-3.05-1.89-4.89-1.89-1.27,0-2.47.3-3.6.88-1.11.56-2.42.92-3.97,1.05-1.95.17-2.6-.06-4.03-.66-.07-.03-.12-1.05-.1-1.05l-.32-21.35s-24.1,2.27-24.21,2.5c-.66,1.46-.9,3.17-.73,5.19.13,1.57.49,2.87,1.05,3.99.58,1.12.86,2.34.86,3.62,0,2.4-1.07,4.63-2.92,6.13-.79.65-1.51,1.11-2.26,1.4-.64.25-1.31.36-2.07.33-.41-.01-.84-.06-1.31-.16-3.05-.64-5.53-3.26-6.03-6.39-.26-1.65-.02-3.3.69-4.78.54-1.12.9-2.29,1.05-3.43.3-2.34.07-4.27-.66-5.9-.01-.03-.31-.04-.81-.05-4.14-.07-23.01.47-23.01.47l.21,20.78c0,.25.15.46.36.59.03.02.04.05.07.06,1.42.6,3.05.82,5,.66,1.56-.13,2.87-.49,3.97-1.05,1.12-.58,2.32-.88,3.6-.88,2.36,0,4.57,1.05,6.05,2.89,1.52,1.85,2.1,4.29,1.59,6.69-.64,3.07-3.24,5.56-6.35,6.07-1.65.26-3.28.02-4.74-.69-1.12-.56-2.27-.9-3.41-1.05-2.25-.28-4.12-.09-5.71.58-.03.01-.05.05-.07.06-.21.13-.36.34-.36.59l-.06,21.36h.06l22.61,1.25c.58-1.41.8-3.03.64-4.94-.13-1.57-.49-2.87-1.05-3.99-.58-1.12-.86-2.34-.86-3.62,0-2.4,1.07-4.63,2.92-6.13,1.84-1.5,4.23-2.06,6.61-1.57,3.05.64,5.53,3.26,6.03,6.39.26,1.65.02,3.3-.69,4.78-.54,1.12-.9,2.29-1.05,3.43-.29,2.26-.08,3.15.59,4.74l24.39.43s0-.21-.02-.58c-.13-3.55-.77-22.11-.53-22.21Z",
    style: {
      fill: "#f06400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.32,127.57l-23.44-1.3-.06-.47.06-21.36c0-.41.22-.79.59-1.02l.14-.1c1.67-.71,3.62-.91,5.97-.62,1.24.16,2.44.53,3.57,1.1,1.37.67,2.9.89,4.44.65,2.9-.47,5.34-2.81,5.94-5.68.47-2.25-.07-4.53-1.49-6.27-1.39-1.72-3.45-2.7-5.67-2.7-1.17,0-2.31.28-3.37.83-1.18.6-2.58.97-4.16,1.1-2.01.17-3.72-.05-5.24-.69l-.1-.04-.12-.11c-.3-.17-.52-.56-.52-.97l-.21-21.26h.49c.19-.02,18.92-.56,23.04-.48.86.02,1.12.02,1.26.36.77,1.72,1,3.74.69,6.16-.16,1.2-.53,2.41-1.1,3.58-.67,1.39-.89,2.94-.65,4.48.47,2.92,2.79,5.38,5.64,5.98.4.08.8.13,1.23.15.68.02,1.29-.07,1.87-.3.66-.25,1.33-.67,2.12-1.32,1.74-1.41,2.74-3.5,2.74-5.74,0-1.21-.27-2.35-.81-3.39-.61-1.22-.97-2.59-1.1-4.18-.18-2.11.08-3.88.77-5.44.16-.35.23-.5,24.62-2.8l.54-.05.33,22.15c0,.14.02.31.03.44,1.22.5,1.83.67,3.55.52,1.45-.12,2.73-.46,3.79-1,1.2-.62,2.49-.93,3.82-.93,1.78,0,3.48.65,5.2,1.99.42.33.83.68,1.2,1.03.59.57,1.11,1.23,1.52,1.98.14.26.24.48.33.7.81,1.81,1.06,4.02.67,5.89-.67,3.23-4.12,6.43-7.54,6.99-1.74.28-3.48.02-5.04-.74-1.04-.52-2.13-.86-3.26-1-2.04-.25-3.74-.11-5.19.44-.08,1.81.25,12.68.58,21.84l.04,1.11-25.25-.45-.13-.3c-.73-1.73-.92-2.7-.62-5,.16-1.2.53-2.4,1.09-3.58.67-1.39.89-2.94.65-4.48-.47-2.92-2.79-5.38-5.64-5.98-2.23-.46-4.49.08-6.19,1.47-1.74,1.41-2.74,3.5-2.74,5.74,0,1.21.27,2.35.81,3.39.61,1.22.97,2.58,1.1,4.18.16,1.97-.06,3.66-.67,5.17l-.13.33ZM351.83,125.32l21.83,1.21c.46-1.28.62-2.71.48-4.38-.12-1.46-.45-2.71-1-3.81-.61-1.17-.92-2.47-.92-3.84,0-2.54,1.13-4.92,3.11-6.52,1.94-1.58,4.5-2.19,7.03-1.67,3.25.68,5.89,3.47,6.42,6.8.28,1.74.02,3.5-.74,5.07-.52,1.08-.86,2.19-1,3.28-.26,2.05-.09,2.9.43,4.18l23.54.42v-.06c-.79-22.45-.66-22.5-.23-22.69h0c1.67-.71,3.62-.91,5.97-.62,1.24.16,2.44.53,3.57,1.1,1.37.67,2.9.89,4.44.65,3-.49,6.14-3.39,6.72-6.21.35-1.67.12-3.65-.61-5.29-.09-.2-.17-.39-.27-.58-.38-.69-.83-1.28-1.36-1.78-.35-.33-.72-.65-1.12-.96-1.54-1.2-3.04-1.78-4.59-1.78-1.17,0-2.31.28-3.37.82-1.18.6-2.58.97-4.16,1.1-2.08.18-2.81-.08-4.26-.69-.45-.19-.43-1.18-.41-1.51l-.31-20.81c-8.82.83-21.54,2.08-23.35,2.38-.55,1.34-.75,2.89-.59,4.72.12,1.46.45,2.71,1,3.81.61,1.17.92,2.47.92,3.84,0,2.54-1.13,4.92-3.11,6.51-.87.71-1.63,1.18-2.4,1.48-.71.28-1.46.4-2.27.36-.48-.02-.94-.07-1.39-.17-3.25-.68-5.89-3.47-6.43-6.8-.28-1.74-.02-3.5.74-5.07.52-1.08.86-2.18,1-3.28.27-2.11.1-3.87-.51-5.38-.12,0-.28,0-.47-.01-3.71-.07-19.5.37-22.5.46l.2,20.29c0,.07.06.14.12.17l.08.06c1.35.55,2.89.75,4.69.59,1.45-.12,2.73-.46,3.79-1,1.2-.62,2.49-.94,3.82-.94,2.52,0,4.87,1.12,6.44,3.07,1.61,1.97,2.23,4.56,1.69,7.1-.68,3.27-3.46,5.92-6.76,6.46-1.74.28-3.48.02-5.04-.74-1.04-.52-2.13-.86-3.26-1-2.13-.27-3.89-.1-5.38.52l-.08.06c-.06.04-.12.1-.12.17l-.06,20.89Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-22)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-23)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.21,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79,108.07c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79,123.23c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.96,108.07c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.96,123.23c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.89,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,108.07c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,123.23c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,108.07c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,123.23c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-25)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.56,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,108.07c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,123.23c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,108.07c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,123.23c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,130.81c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,115.65c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-26)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.21,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79,77.75c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79,92.91c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.96,77.75c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.96,92.91c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-27)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.89,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,77.75c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,92.91c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,77.75c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,92.91c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-28)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.56,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,77.75c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,92.91c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,77.75c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,92.91c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,100.49c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,85.33c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-29)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.21,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79,47.42c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79,62.59c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.96,47.42c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.96,62.59c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-30)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.89,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,47.42c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,62.59c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,47.42c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,62.59c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-31)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.56,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,47.42c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,62.59c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,47.42c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,62.59c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,70.17c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,55c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,39.84c0,1.67,1.36,3.03,3.03,3.03s3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03-3.03,1.36-3.03,3.03Z",
    style: {
      fill: "#6868ac"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.32,127.59l-23.44-1.3-.06-.47.06-21.36c0-.41.22-.79.59-1.02l.14-.1c1.67-.71,3.62-.91,5.97-.62,1.24.16,2.44.53,3.57,1.1,1.37.67,2.9.89,4.44.65,2.9-.47,5.34-2.81,5.94-5.68.47-2.25-.07-4.53-1.49-6.27-1.39-1.72-3.45-2.7-5.67-2.7-1.18,0-2.31.28-3.37.82-1.18.6-2.58.97-4.16,1.1-2.01.17-3.72-.05-5.24-.69l-.1-.04-.12-.11c-.3-.17-.52-.56-.52-.97l-.21-21.26h.49c.19-.02,18.94-.55,23.04-.48.86.01,1.12.02,1.26.36.77,1.72,1,3.74.69,6.16-.16,1.2-.53,2.41-1.1,3.58-.67,1.39-.89,2.94-.65,4.48.47,2.93,2.79,5.38,5.64,5.98.4.08.8.13,1.23.15.68.02,1.29-.07,1.87-.3.66-.25,1.33-.67,2.12-1.32,1.74-1.41,2.74-3.5,2.74-5.74,0-1.21-.27-2.35-.81-3.39-.61-1.22-.97-2.59-1.1-4.18-.18-2.11.08-3.88.77-5.44.16-.35,25.16-2.85,25.16-2.85l.33,22.15c0,.14.02.31.03.44,1.22.51,1.83.67,3.55.52,1.45-.12,2.73-.46,3.79-1,1.2-.62,2.49-.94,3.82-.94,1.78,0,3.48.65,5.2,1.99.42.33.83.68,1.2,1.03.59.57,1.11,1.23,1.52,1.98.14.26.24.48.33.7.81,1.81,1.06,4.02.67,5.89-.67,3.23-4.12,6.43-7.54,6.99-1.74.28-3.48.02-5.04-.74-1.04-.52-2.13-.86-3.25-1-2.04-.25-3.74-.11-5.19.44-.08,1.81.25,12.68.58,21.84l.04,1.11-25.25-.45-.13-.3c-.73-1.73-.92-2.7-.62-5,.16-1.2.53-2.4,1.09-3.58.67-1.39.89-2.94.65-4.48-.47-2.92-2.79-5.38-5.64-5.98-2.23-.46-4.49.08-6.19,1.47-1.74,1.41-2.74,3.5-2.74,5.74,0,1.21.27,2.35.81,3.39.61,1.22.97,2.59,1.1,4.18.16,1.97-.06,3.66-.67,5.17l-.13.33ZM351.83,125.35l21.83,1.21c.46-1.28.62-2.71.48-4.38-.12-1.46-.45-2.71-1-3.81-.61-1.17-.92-2.47-.92-3.84,0-2.54,1.13-4.92,3.11-6.52,1.94-1.58,4.5-2.19,7.03-1.67,3.25.68,5.89,3.47,6.42,6.8.28,1.74.02,3.5-.74,5.07-.52,1.08-.86,2.19-1,3.28-.26,2.05-.09,2.9.43,4.18l23.54.42v-.06c-.79-22.45-.66-22.5-.23-22.69h0c1.67-.71,3.62-.91,5.97-.62,1.24.16,2.44.53,3.57,1.1,1.37.67,2.9.89,4.44.65,3-.49,6.14-3.39,6.72-6.21.35-1.67.12-3.65-.61-5.29-.09-.2-.17-.39-.27-.58-.38-.69-.83-1.28-1.36-1.78-.35-.33-.72-.65-1.12-.96-1.54-1.2-3.04-1.78-4.59-1.78-1.17,0-2.31.28-3.37.83-1.18.6-2.58.97-4.16,1.1-2.08.18-2.81-.08-4.26-.69-.45-.19-.43-1.18-.41-1.51l-.35-20.1c-8.82.83-21.5,1.37-23.31,1.67-.55,1.34-.75,2.89-.59,4.72.12,1.46.45,2.71,1,3.81.61,1.17.92,2.47.92,3.84,0,2.54-1.13,4.92-3.11,6.52-.87.71-1.64,1.18-2.4,1.48-.71.27-1.46.39-2.27.36-.48-.02-.93-.07-1.39-.17-3.25-.68-5.89-3.47-6.43-6.8-.28-1.74-.02-3.5.74-5.07.52-1.08.86-2.18,1-3.28.27-2.11.1-3.87-.51-5.38-.12,0-.28,0-.47-.01-3.7-.06-19.5.37-22.5.46l.2,20.28c0,.07.06.14.12.17l.08.06c1.35.55,2.89.75,4.69.59,1.45-.12,2.73-.46,3.79-1,1.2-.62,2.49-.93,3.82-.93,2.52,0,4.87,1.12,6.44,3.07,1.61,1.97,2.23,4.56,1.69,7.1-.68,3.27-3.46,5.92-6.76,6.46-1.74.28-3.48.02-5.04-.74-1.04-.52-2.13-.86-3.25-1-2.13-.26-3.89-.1-5.38.52l-.08.06c-.06.04-.12.1-.12.17l-.06,20.89Z",
    style: {
      fill: "#6868ac"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSsw2025IconsStartgrafikRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ssw2025-icons-startgrafik-rgb.b93d64f674386c9d136bf9c80d969cb1.svg";